/* cSpell:disable */

// This file was automatically generated by a tool on 04/03/2026, 7:56 PM UTC. DO NOT UPDATE MANUALLY.
// It includes declarations for Adaptive Card features available in Teams, Copilot, Outlook, Word, Excel, PowerPoint.

export type CardElement =
  | IContainer
  | IActionSet
  | IColumnSet
  | IMedia
  | IRichTextBlock
  | ITable
  | ITextBlock
  | IFactSet
  | IImageSet
  | IImage
  | ITextInput
  | IDateInput
  | ITimeInput
  | INumberInput
  | IToggleInput
  | IChoiceSetInput
  | IRatingInput
  | IRating
  | ICompoundButton
  | IIcon
  | ICarousel
  | IBadge
  | IProgressRing
  | IProgressBar
  | IDonutChart
  | IPieChart
  | IGroupedVerticalBarChart
  | IVerticalBarChart
  | IHorizontalBarChart
  | IStackedHorizontalBarChart
  | ILineChart
  | IGaugeChart
  | ICodeBlock
  | IComUserMicrosoftGraphComponent
  | IComUsersMicrosoftGraphComponent
  | IComResourceMicrosoftGraphComponent
  | IComFileMicrosoftGraphComponent
  | IComEventMicrosoftGraphComponent;

export type Action =
  | ISubmitAction
  | IOpenUrlAction
  | IExecuteAction
  | IToggleVisibilityAction
  | IShowCardAction
  | IResetInputsAction
  | IPopoverAction
  | IOpenUrlDialogAction
  | IInsertImageAction;

export type IconName =
  | 'AccessTime'
  | 'Accessibility'
  | 'AccessibilityCheckmark'
  | 'Add'
  | 'AddCircle'
  | 'AddSquare'
  | 'AddSquareMultiple'
  | 'AddSubtractCircle'
  | 'Airplane'
  | 'AirplaneLanding'
  | 'AirplaneTakeOff'
  | 'Album'
  | 'AlbumAdd'
  | 'Alert'
  | 'AlertBadge'
  | 'AlertOff'
  | 'AlertOn'
  | 'AlertSnooze'
  | 'AlertUrgent'
  | 'AlignBottom'
  | 'AlignCenterHorizontal'
  | 'AlignCenterVertical'
  | 'AlignDistributeBottom'
  | 'AlignDistributeLeft'
  | 'AlignDistributeRight'
  | 'AlignDistributeTop'
  | 'AlignEndHorizontal'
  | 'AlignEndVertical'
  | 'AlignLeft'
  | 'AlignRight'
  | 'AlignSpaceAroundHorizontal'
  | 'AlignSpaceAroundVertical'
  | 'AlignSpaceBetweenHorizontal'
  | 'AlignSpaceBetweenVertical'
  | 'AlignSpaceEvenlyHorizontal'
  | 'AlignSpaceEvenlyVertical'
  | 'AlignSpaceFitVertical'
  | 'AlignStartHorizontal'
  | 'AlignStartVertical'
  | 'AlignStraighten'
  | 'AlignStretchHorizontal'
  | 'AlignStretchVertical'
  | 'AlignTop'
  | 'AnimalCat'
  | 'AnimalDog'
  | 'AnimalRabbit'
  | 'AnimalRabbitOff'
  | 'AnimalTurtle'
  | 'AppFolder'
  | 'AppGeneric'
  | 'AppRecent'
  | 'AppStore'
  | 'AppTitle'
  | 'ApprovalsApp'
  | 'Apps'
  | 'AppsAddIn'
  | 'AppsList'
  | 'AppsListDetail'
  | 'Archive'
  | 'ArchiveArrowBack'
  | 'ArchiveMultiple'
  | 'ArchiveSettings'
  | 'ArrowAutofitContent'
  | 'ArrowAutofitDown'
  | 'ArrowAutofitHeight'
  | 'ArrowAutofitHeightDotted'
  | 'ArrowAutofitHeightIn'
  | 'ArrowAutofitUp'
  | 'ArrowAutofitWidth'
  | 'ArrowAutofitWidthDotted'
  | 'ArrowBetweenDown'
  | 'ArrowBetweenUp'
  | 'ArrowBidirectionalLeftRight'
  | 'ArrowBidirectionalUpDown'
  | 'ArrowBounce'
  | 'ArrowCircleDown'
  | 'ArrowCircleDownDouble'
  | 'ArrowCircleDownRight'
  | 'ArrowCircleDownSplit'
  | 'ArrowCircleDownUp'
  | 'ArrowCircleLeft'
  | 'ArrowCircleRight'
  | 'ArrowCircleUp'
  | 'ArrowCircleUpLeft'
  | 'ArrowCircleUpRight'
  | 'ArrowClockwise'
  | 'ArrowClockwiseDashes'
  | 'ArrowCollapseAll'
  | 'ArrowCounterclockwise'
  | 'ArrowCounterclockwiseDashes'
  | 'ArrowCurveDownLeft'
  | 'ArrowCurveDownRight'
  | 'ArrowCurveUpLeft'
  | 'ArrowCurveUpRight'
  | 'ArrowDown'
  | 'ArrowDownExclamation'
  | 'ArrowDownLeft'
  | 'ArrowDownload'
  | 'ArrowDownloadOff'
  | 'ArrowEject'
  | 'ArrowEnter'
  | 'ArrowEnterLeft'
  | 'ArrowEnterUp'
  | 'ArrowExit'
  | 'ArrowExpand'
  | 'ArrowExport'
  | 'ArrowExportLtr'
  | 'ArrowExportRtl'
  | 'ArrowExportUp'
  | 'ArrowFit'
  | 'ArrowFitIn'
  | 'ArrowFlowDiagonalUpRight'
  | 'ArrowFlowUpRight'
  | 'ArrowFlowUpRightRectangleMultiple'
  | 'ArrowForward'
  | 'ArrowForwardDownLightning'
  | 'ArrowForwardDownPerson'
  | 'ArrowHookDownLeft'
  | 'ArrowHookDownRight'
  | 'ArrowHookUpLeft'
  | 'ArrowHookUpRight'
  | 'ArrowImport'
  | 'ArrowJoin'
  | 'ArrowLeft'
  | 'ArrowMaximize'
  | 'ArrowMaximizeVertical'
  | 'ArrowMinimize'
  | 'ArrowMinimizeVertical'
  | 'ArrowMove'
  | 'ArrowMoveInward'
  | 'ArrowNext'
  | 'ArrowOutlineDownLeft'
  | 'ArrowOutlineUpRight'
  | 'ArrowParagraph'
  | 'ArrowPrevious'
  | 'ArrowRedo'
  | 'ArrowRepeat1'
  | 'ArrowRepeatAll'
  | 'ArrowRepeatAllOff'
  | 'ArrowReply'
  | 'ArrowReplyAll'
  | 'ArrowReplyDown'
  | 'ArrowReset'
  | 'ArrowRight'
  | 'ArrowRotateClockwise'
  | 'ArrowRotateCounterclockwise'
  | 'ArrowRouting'
  | 'ArrowRoutingRectangleMultiple'
  | 'ArrowShuffle'
  | 'ArrowShuffleOff'
  | 'ArrowSort'
  | 'ArrowSortDown'
  | 'ArrowSortDownLines'
  | 'ArrowSortUp'
  | 'ArrowSplit'
  | 'ArrowSprint'
  | 'ArrowSquareDown'
  | 'ArrowSquareUpRight'
  | 'ArrowStepBack'
  | 'ArrowStepIn'
  | 'ArrowStepInDiagonalDownLeft'
  | 'ArrowStepInLeft'
  | 'ArrowStepInRight'
  | 'ArrowStepOut'
  | 'ArrowStepOver'
  | 'ArrowSwap'
  | 'ArrowSync'
  | 'ArrowSyncCheckmark'
  | 'ArrowSyncCircle'
  | 'ArrowSyncDismiss'
  | 'ArrowSyncOff'
  | 'ArrowTrending'
  | 'ArrowTrendingCheckmark'
  | 'ArrowTrendingDown'
  | 'ArrowTrendingLines'
  | 'ArrowTrendingSettings'
  | 'ArrowTrendingSparkle'
  | 'ArrowTrendingText'
  | 'ArrowTrendingWrench'
  | 'ArrowTurnBidirectionalDownRight'
  | 'ArrowTurnDownLeft'
  | 'ArrowTurnDownRight'
  | 'ArrowTurnDownUp'
  | 'ArrowTurnLeftDown'
  | 'ArrowTurnLeftRight'
  | 'ArrowTurnLeftUp'
  | 'ArrowTurnRight'
  | 'ArrowTurnRightDown'
  | 'ArrowTurnRightLeft'
  | 'ArrowTurnRightUp'
  | 'ArrowTurnUpDown'
  | 'ArrowTurnUpLeft'
  | 'ArrowUndo'
  | 'ArrowUp'
  | 'ArrowUpLeft'
  | 'ArrowUpRight'
  | 'ArrowUpRightDashes'
  | 'ArrowUpSquareSettings'
  | 'ArrowUpload'
  | 'ArrowWrap'
  | 'ArrowWrapOff'
  | 'ArrowsBidirectional'
  | 'Attach'
  | 'AttachArrowRight'
  | 'AttachText'
  | 'AutoFitHeight'
  | 'AutoFitWidth'
  | 'Autocorrect'
  | 'Autosum'
  | 'Backpack'
  | 'BackpackAdd'
  | 'Backspace'
  | 'Badge'
  | 'Balloon'
  | 'BarcodeScanner'
  | 'Battery0'
  | 'Battery10'
  | 'Battery1'
  | 'Battery2'
  | 'Battery3'
  | 'Battery4'
  | 'Battery5'
  | 'Battery6'
  | 'Battery7'
  | 'Battery8'
  | 'Battery9'
  | 'BatteryCharge'
  | 'BatteryCheckmark'
  | 'BatterySaver'
  | 'BatteryWarning'
  | 'Beach'
  | 'Beaker'
  | 'BeakerAdd'
  | 'BeakerDismiss'
  | 'BeakerEdit'
  | 'BeakerEmpty'
  | 'BeakerOff'
  | 'BeakerSettings'
  | 'Bed'
  | 'BezierCurveSquare'
  | 'BinFull'
  | 'BinRecycle'
  | 'BinRecycleFull'
  | 'BinderTriangle'
  | 'Bluetooth'
  | 'BluetoothConnected'
  | 'BluetoothDisabled'
  | 'BluetoothSearching'
  | 'Blur'
  | 'Board'
  | 'BoardGames'
  | 'BoardHeart'
  | 'BoardSplit'
  | 'Book'
  | 'BookAdd'
  | 'BookArrowClockwise'
  | 'BookClock'
  | 'BookCoins'
  | 'BookCompass'
  | 'BookContacts'
  | 'BookDatabase'
  | 'BookDefault'
  | 'BookDismiss'
  | 'BookExclamationMark'
  | 'BookGlobe'
  | 'BookInformation'
  | 'BookLetter'
  | 'BookNumber'
  | 'BookOpen'
  | 'BookOpenGlobe'
  | 'BookOpenMicrophone'
  | 'BookPulse'
  | 'BookQuestionMark'
  | 'BookQuestionMarkRtl'
  | 'BookSearch'
  | 'BookStar'
  | 'BookTemplate'
  | 'BookTheta'
  | 'BookToolbox'
  | 'Bookmark'
  | 'BookmarkAdd'
  | 'BookmarkMultiple'
  | 'BookmarkOff'
  | 'BookmarkSearch'
  | 'BorderAll'
  | 'BorderBottom'
  | 'BorderBottomDouble'
  | 'BorderBottomThick'
  | 'BorderInside'
  | 'BorderLeft'
  | 'BorderLeftRight'
  | 'BorderNone'
  | 'BorderOutside'
  | 'BorderOutsideThick'
  | 'BorderRight'
  | 'BorderTop'
  | 'BorderTopBottom'
  | 'BorderTopBottomDouble'
  | 'BorderTopBottomThick'
  | 'Bot'
  | 'BotAdd'
  | 'BotSparkle'
  | 'BowTie'
  | 'BowlChopsticks'
  | 'BowlSalad'
  | 'Box'
  | 'BoxArrowLeft'
  | 'BoxArrowUp'
  | 'BoxCheckmark'
  | 'BoxDismiss'
  | 'BoxEdit'
  | 'BoxMultiple'
  | 'BoxMultipleArrowLeft'
  | 'BoxMultipleArrowRight'
  | 'BoxMultipleCheckmark'
  | 'BoxMultipleSearch'
  | 'BoxSearch'
  | 'BoxToolbox'
  | 'Braces'
  | 'BracesCheckmark'
  | 'BracesDismiss'
  | 'BracesVariable'
  | 'BrainCircuit'
  | 'Branch'
  | 'BranchCompare'
  | 'BranchFork'
  | 'BranchForkHint'
  | 'BranchForkLink'
  | 'BranchRequest'
  | 'BreakoutRoom'
  | 'Briefcase'
  | 'BriefcaseMedical'
  | 'BriefcaseOff'
  | 'BriefcasePerson'
  | 'BriefcaseSearch'
  | 'BrightnessHigh'
  | 'BrightnessLow'
  | 'BroadActivityFeed'
  | 'Broom'
  | 'BubbleMultiple'
  | 'Bug'
  | 'BugArrowCounterclockwise'
  | 'BugProhibited'
  | 'Building'
  | 'BuildingBank'
  | 'BuildingBankLink'
  | 'BuildingBankToolbox'
  | 'BuildingCloud'
  | 'BuildingDesktop'
  | 'BuildingFactory'
  | 'BuildingGovernment'
  | 'BuildingGovernmentSearch'
  | 'BuildingHome'
  | 'BuildingLighthouse'
  | 'BuildingMosque'
  | 'BuildingMultiple'
  | 'BuildingPeople'
  | 'BuildingRetail'
  | 'BuildingRetailMoney'
  | 'BuildingRetailMore'
  | 'BuildingRetailShield'
  | 'BuildingRetailToolbox'
  | 'BuildingShop'
  | 'BuildingSkyscraper'
  | 'BuildingSwap'
  | 'BuildingTownhouse'
  | 'Button'
  | 'Calculator'
  | 'CalculatorArrowClockwise'
  | 'CalculatorMultiple'
  | 'Calendar'
  | 'Calendar3Day'
  | 'CalendarAdd'
  | 'CalendarAgenda'
  | 'CalendarArrowCounterclockwise'
  | 'CalendarArrowDown'
  | 'CalendarArrowRight'
  | 'CalendarAssistant'
  | 'CalendarCancel'
  | 'CalendarChat'
  | 'CalendarCheckmark'
  | 'CalendarClock'
  | 'CalendarDataBar'
  | 'CalendarDate'
  | 'CalendarDay'
  | 'CalendarEdit'
  | 'CalendarEmpty'
  | 'CalendarError'
  | 'CalendarEye'
  | 'CalendarInfo'
  | 'CalendarLink'
  | 'CalendarLock'
  | 'CalendarLtr'
  | 'CalendarMail'
  | 'CalendarMention'
  | 'CalendarMonth'
  | 'CalendarMultiple'
  | 'CalendarNote'
  | 'CalendarPattern'
  | 'CalendarPerson'
  | 'CalendarPhone'
  | 'CalendarPlay'
  | 'CalendarQuestionMark'
  | 'CalendarRecord'
  | 'CalendarReply'
  | 'CalendarRtl'
  | 'CalendarSearch'
  | 'CalendarSettings'
  | 'CalendarShield'
  | 'CalendarStar'
  | 'CalendarSync'
  | 'CalendarToday'
  | 'CalendarToolbox'
  | 'CalendarVideo'
  | 'CalendarWeekNumbers'
  | 'CalendarWeekStart'
  | 'CalendarWorkWeek'
  | 'Call'
  | 'CallAdd'
  | 'CallCheckmark'
  | 'CallConnecting'
  | 'CallDismiss'
  | 'CallEnd'
  | 'CallExclamation'
  | 'CallForward'
  | 'CallInbound'
  | 'CallMissed'
  | 'CallOutbound'
  | 'CallPark'
  | 'CallPause'
  | 'CallProhibited'
  | 'CallTransfer'
  | 'CallWarning'
  | 'CalligraphyPen'
  | 'CalligraphyPenCheckmark'
  | 'CalligraphyPenError'
  | 'CalligraphyPenQuestionMark'
  | 'Camera'
  | 'CameraAdd'
  | 'CameraDome'
  | 'CameraEdit'
  | 'CameraOff'
  | 'CameraSparkles'
  | 'CameraSwitch'
  | 'CardUi'
  | 'CaretDown'
  | 'CaretDownRight'
  | 'CaretLeft'
  | 'CaretRight'
  | 'CaretUp'
  | 'Cart'
  | 'Cast'
  | 'CastMultiple'
  | 'CatchUp'
  | 'Cd'
  | 'Cellular3G'
  | 'Cellular4G'
  | 'Cellular5G'
  | 'CellularData1'
  | 'CellularData2'
  | 'CellularData3'
  | 'CellularData4'
  | 'CellularData5'
  | 'CellularOff'
  | 'CellularWarning'
  | 'CenterHorizontal'
  | 'CenterVertical'
  | 'Certificate'
  | 'Channel'
  | 'ChannelAdd'
  | 'ChannelAlert'
  | 'ChannelArrowLeft'
  | 'ChannelDismiss'
  | 'ChannelShare'
  | 'ChannelSubtract'
  | 'ChartMultiple'
  | 'ChartPerson'
  | 'Chat'
  | 'ChatAdd'
  | 'ChatArrowBack'
  | 'ChatArrowDoubleBack'
  | 'ChatBubblesQuestion'
  | 'ChatCursor'
  | 'ChatDismiss'
  | 'ChatEmpty'
  | 'ChatHelp'
  | 'ChatLock'
  | 'ChatMail'
  | 'ChatMultiple'
  | 'ChatMultipleHeart'
  | 'ChatOff'
  | 'ChatSettings'
  | 'ChatSparkle'
  | 'ChatVideo'
  | 'ChatWarning'
  | 'Check'
  | 'Checkbox1'
  | 'Checkbox2'
  | 'CheckboxArrowRight'
  | 'CheckboxChecked'
  | 'CheckboxCheckedSync'
  | 'CheckboxIndeterminate'
  | 'CheckboxPerson'
  | 'CheckboxUnchecked'
  | 'CheckboxWarning'
  | 'Checkmark'
  | 'CheckmarkCircle'
  | 'CheckmarkCircleSquare'
  | 'CheckmarkLock'
  | 'CheckmarkNote'
  | 'CheckmarkSquare'
  | 'CheckmarkStarburst'
  | 'CheckmarkUnderlineCircle'
  | 'Chess'
  | 'ChevronCircleDown'
  | 'ChevronCircleLeft'
  | 'ChevronCircleRight'
  | 'ChevronCircleUp'
  | 'ChevronDoubleDown'
  | 'ChevronDoubleLeft'
  | 'ChevronDoubleRight'
  | 'ChevronDoubleUp'
  | 'ChevronDown'
  | 'ChevronDownUp'
  | 'ChevronLeft'
  | 'ChevronRight'
  | 'ChevronUp'
  | 'ChevronUpDown'
  | 'Circle'
  | 'CircleEdit'
  | 'CircleEraser'
  | 'CircleHalfFill'
  | 'CircleHint'
  | 'CircleHintHalfVertical'
  | 'CircleImage'
  | 'CircleLine'
  | 'CircleMultipleSubtractCheckmark'
  | 'CircleOff'
  | 'CircleSmall'
  | 'City'
  | 'Class'
  | 'Classification'
  | 'ClearFormatting'
  | 'Clipboard'
  | 'Clipboard3Day'
  | 'ClipboardArrowRight'
  | 'ClipboardBrush'
  | 'ClipboardBulletList'
  | 'ClipboardBulletListLtr'
  | 'ClipboardBulletListRtl'
  | 'ClipboardCheckmark'
  | 'ClipboardClock'
  | 'ClipboardCode'
  | 'ClipboardDataBar'
  | 'ClipboardDay'
  | 'ClipboardEdit'
  | 'ClipboardError'
  | 'ClipboardHeart'
  | 'ClipboardImage'
  | 'ClipboardLetter'
  | 'ClipboardLink'
  | 'ClipboardMathFormula'
  | 'ClipboardMonth'
  | 'ClipboardMore'
  | 'ClipboardMultiple'
  | 'ClipboardNote'
  | 'ClipboardNumber123'
  | 'ClipboardPaste'
  | 'ClipboardPulse'
  | 'ClipboardSearch'
  | 'ClipboardSettings'
  | 'ClipboardTask'
  | 'ClipboardTaskAdd'
  | 'ClipboardTaskList'
  | 'ClipboardTaskListLtr'
  | 'ClipboardTaskListRtl'
  | 'ClipboardText'
  | 'ClipboardTextEdit'
  | 'ClipboardTextLtr'
  | 'ClipboardTextRtl'
  | 'Clock'
  | 'ClockAlarm'
  | 'ClockArrowDownload'
  | 'ClockDismiss'
  | 'ClockLock'
  | 'ClockPause'
  | 'ClockToolbox'
  | 'ClosedCaption'
  | 'ClosedCaptionOff'
  | 'Cloud'
  | 'CloudAdd'
  | 'CloudArchive'
  | 'CloudArrowDown'
  | 'CloudArrowUp'
  | 'CloudBeaker'
  | 'CloudBidirectional'
  | 'CloudCheckmark'
  | 'CloudCube'
  | 'CloudDatabase'
  | 'CloudDesktop'
  | 'CloudDismiss'
  | 'CloudEdit'
  | 'CloudError'
  | 'CloudFlow'
  | 'CloudLink'
  | 'CloudOff'
  | 'CloudSwap'
  | 'CloudSync'
  | 'CloudWords'
  | 'Clover'
  | 'Code'
  | 'CodeBlock'
  | 'CodeCircle'
  | 'CodeCs'
  | 'CodeCsRectangle'
  | 'CodeFs'
  | 'CodeFsRectangle'
  | 'CodeJs'
  | 'CodeJsRectangle'
  | 'CodePy'
  | 'CodePyRectangle'
  | 'CodeRb'
  | 'CodeRbRectangle'
  | 'CodeText'
  | 'CodeTextEdit'
  | 'CodeTextOff'
  | 'CodeTs'
  | 'CodeTsRectangle'
  | 'CodeVb'
  | 'CodeVbRectangle'
  | 'Collections'
  | 'CollectionsAdd'
  | 'Color'
  | 'ColorBackground'
  | 'ColorBackgroundAccent'
  | 'ColorFill'
  | 'ColorFillAccent'
  | 'ColorLine'
  | 'ColorLineAccent'
  | 'Column'
  | 'ColumnArrowRight'
  | 'ColumnDoubleCompare'
  | 'ColumnEdit'
  | 'ColumnSingle'
  | 'ColumnSingleCompare'
  | 'ColumnTriple'
  | 'ColumnTripleEdit'
  | 'Comma'
  | 'Comment'
  | 'CommentAdd'
  | 'CommentArrowLeft'
  | 'CommentArrowRight'
  | 'CommentCheckmark'
  | 'CommentDismiss'
  | 'CommentEdit'
  | 'CommentError'
  | 'CommentLightning'
  | 'CommentLink'
  | 'CommentMention'
  | 'CommentMultiple'
  | 'CommentMultipleCheckmark'
  | 'CommentMultipleLink'
  | 'CommentNote'
  | 'CommentOff'
  | 'Communication'
  | 'CommunicationPerson'
  | 'CommunicationShield'
  | 'CompassNorthwest'
  | 'Component2DoubleTapSwipeDown'
  | 'Component2DoubleTapSwipeUp'
  | 'Compose'
  | 'Cone'
  | 'ConferenceRoom'
  | 'Connected'
  | 'Connector'
  | 'ContactCard'
  | 'ContactCardGroup'
  | 'ContactCardLink'
  | 'ContactCardRibbon'
  | 'ContentSettings'
  | 'ContentView'
  | 'ContentViewGallery'
  | 'ContentViewGalleryLightning'
  | 'ContractDownLeft'
  | 'ContractUpRight'
  | 'ControlButton'
  | 'ConvertRange'
  | 'Cookies'
  | 'Copy'
  | 'CopyAdd'
  | 'CopyArrowRight'
  | 'CopySelect'
  | 'Couch'
  | 'CreditCardClock'
  | 'CreditCardPerson'
  | 'CreditCardToolbox'
  | 'Crop'
  | 'CropInterim'
  | 'CropInterimOff'
  | 'CropSparkle'
  | 'Crown'
  | 'CrownSubtract'
  | 'Cube'
  | 'CubeAdd'
  | 'CubeArrowCurveDown'
  | 'CubeLink'
  | 'CubeMultiple'
  | 'CubeQuick'
  | 'CubeRotate'
  | 'CubeSync'
  | 'CubeTree'
  | 'CurrencyDollarEuro'
  | 'CurrencyDollarRupee'
  | 'Cursor'
  | 'CursorClick'
  | 'CursorHover'
  | 'CursorHoverOff'
  | 'CursorProhibited'
  | 'Cut'
  | 'DarkTheme'
  | 'DataArea'
  | 'DataBarHorizontal'
  | 'DataBarHorizontalDescending'
  | 'DataBarVertical'
  | 'DataBarVerticalAdd'
  | 'DataBarVerticalAscending'
  | 'DataBarVerticalStar'
  | 'DataFunnel'
  | 'DataHistogram'
  | 'DataLine'
  | 'DataPie'
  | 'DataScatter'
  | 'DataSunburst'
  | 'DataTreemap'
  | 'DataTrending'
  | 'DataUsage'
  | 'DataUsageEdit'
  | 'DataUsageSettings'
  | 'DataUsageToolbox'
  | 'DataWaterfall'
  | 'DataWhisker'
  | 'Database'
  | 'DatabaseArrowDown'
  | 'DatabaseArrowRight'
  | 'DatabaseArrowUp'
  | 'DatabaseLightning'
  | 'DatabaseLink'
  | 'DatabaseMultiple'
  | 'DatabasePerson'
  | 'DatabasePlugConnected'
  | 'DatabaseSearch'
  | 'DatabaseStack'
  | 'DatabaseSwitch'
  | 'DatabaseWarning'
  | 'DatabaseWindow'
  | 'DecimalArrowLeft'
  | 'DecimalArrowRight'
  | 'Delete'
  | 'DeleteArrowBack'
  | 'DeleteDismiss'
  | 'DeleteLines'
  | 'DeleteOff'
  | 'Dentist'
  | 'DesignIdeas'
  | 'Desk'
  | 'Desktop'
  | 'DesktopArrowDown'
  | 'DesktopArrowRight'
  | 'DesktopCheckmark'
  | 'DesktopCursor'
  | 'DesktopEdit'
  | 'DesktopFlow'
  | 'DesktopKeyboard'
  | 'DesktopMac'
  | 'DesktopPulse'
  | 'DesktopSignal'
  | 'DesktopSpeaker'
  | 'DesktopSpeakerOff'
  | 'DesktopSync'
  | 'DesktopToolbox'
  | 'DesktopTower'
  | 'DeveloperBoard'
  | 'DeveloperBoardLightning'
  | 'DeveloperBoardLightningToolbox'
  | 'DeveloperBoardSearch'
  | 'DeviceEq'
  | 'DeviceMeetingRoom'
  | 'DeviceMeetingRoomRemote'
  | 'Diagram'
  | 'Dialpad'
  | 'DialpadOff'
  | 'DialpadQuestionMark'
  | 'Diamond'
  | 'Directions'
  | 'Dishwasher'
  | 'Dismiss'
  | 'DismissCircle'
  | 'DismissSquare'
  | 'DismissSquareMultiple'
  | 'Diversity'
  | 'DividerShort'
  | 'DividerTall'
  | 'Dock'
  | 'DockRow'
  | 'Doctor'
  | 'Document100'
  | 'Document'
  | 'DocumentAdd'
  | 'DocumentArrowDown'
  | 'DocumentArrowLeft'
  | 'DocumentArrowRight'
  | 'DocumentArrowUp'
  | 'DocumentBorder'
  | 'DocumentBorderPrint'
  | 'DocumentBriefcase'
  | 'DocumentBulletList'
  | 'DocumentBulletListArrowLeft'
  | 'DocumentBulletListClock'
  | 'DocumentBulletListCube'
  | 'DocumentBulletListMultiple'
  | 'DocumentBulletListOff'
  | 'DocumentCatchUp'
  | 'DocumentCheckmark'
  | 'DocumentChevronDouble'
  | 'DocumentContract'
  | 'DocumentCopy'
  | 'DocumentCs'
  | 'DocumentCss'
  | 'DocumentCube'
  | 'DocumentData'
  | 'DocumentDataLink'
  | 'DocumentDataLock'
  | 'DocumentDatabase'
  | 'DocumentDismiss'
  | 'DocumentEdit'
  | 'DocumentEndnote'
  | 'DocumentError'
  | 'DocumentFit'
  | 'DocumentFlowchart'
  | 'DocumentFolder'
  | 'DocumentFooter'
  | 'DocumentFooterDismiss'
  | 'DocumentFs'
  | 'DocumentHeader'
  | 'DocumentHeaderArrowDown'
  | 'DocumentHeaderDismiss'
  | 'DocumentHeaderFooter'
  | 'DocumentHeart'
  | 'DocumentHeartPulse'
  | 'DocumentImage'
  | 'DocumentJava'
  | 'DocumentJavascript'
  | 'DocumentJs'
  | 'DocumentKey'
  | 'DocumentLandscape'
  | 'DocumentLandscapeData'
  | 'DocumentLandscapeSplit'
  | 'DocumentLandscapeSplitHint'
  | 'DocumentLightning'
  | 'DocumentLink'
  | 'DocumentLock'
  | 'DocumentMargins'
  | 'DocumentMention'
  | 'DocumentMultiple'
  | 'DocumentMultiplePercent'
  | 'DocumentMultipleProhibited'
  | 'DocumentMultipleSync'
  | 'DocumentNumber1'
  | 'DocumentOnePage'
  | 'DocumentOnePageAdd'
  | 'DocumentOnePageBeaker'
  | 'DocumentOnePageColumns'
  | 'DocumentOnePageLink'
  | 'DocumentOnePageMultiple'
  | 'DocumentOnePageSparkle'
  | 'DocumentPageBottomCenter'
  | 'DocumentPageBottomLeft'
  | 'DocumentPageBottomRight'
  | 'DocumentPageBreak'
  | 'DocumentPageNumber'
  | 'DocumentPageTopCenter'
  | 'DocumentPageTopLeft'
  | 'DocumentPageTopRight'
  | 'DocumentPdf'
  | 'DocumentPercent'
  | 'DocumentPerson'
  | 'DocumentPill'
  | 'DocumentPrint'
  | 'DocumentProhibited'
  | 'DocumentPy'
  | 'DocumentQuestionMark'
  | 'DocumentQueue'
  | 'DocumentQueueAdd'
  | 'DocumentQueueMultiple'
  | 'DocumentRb'
  | 'DocumentRibbon'
  | 'DocumentSass'
  | 'DocumentSave'
  | 'DocumentSearch'
  | 'DocumentSettings'
  | 'DocumentSplitHint'
  | 'DocumentSplitHintOff'
  | 'DocumentSync'
  | 'DocumentTable'
  | 'DocumentTableArrowRight'
  | 'DocumentTableCheckmark'
  | 'DocumentTableCube'
  | 'DocumentTableSearch'
  | 'DocumentTableTruck'
  | 'DocumentTarget'
  | 'DocumentText'
  | 'DocumentTextClock'
  | 'DocumentTextExtract'
  | 'DocumentTextLink'
  | 'DocumentTextToolbox'
  | 'DocumentToolbox'
  | 'DocumentTs'
  | 'DocumentVb'
  | 'DocumentWidth'
  | 'DocumentYml'
  | 'Door'
  | 'DoorArrowLeft'
  | 'DoorArrowRight'
  | 'DoorTag'
  | 'DoubleSwipeDown'
  | 'DoubleSwipeUp'
  | 'DoubleTapSwipeDown'
  | 'DoubleTapSwipeUp'
  | 'Drafts'
  | 'Drag'
  | 'DrawImage'
  | 'DrawShape'
  | 'DrawText'
  | 'Drawer'
  | 'DrawerAdd'
  | 'DrawerArrowDownload'
  | 'DrawerDismiss'
  | 'DrawerPlay'
  | 'DrawerSubtract'
  | 'DrinkBeer'
  | 'DrinkBottle'
  | 'DrinkBottleOff'
  | 'DrinkCoffee'
  | 'DrinkMargarita'
  | 'DrinkToGo'
  | 'DrinkWine'
  | 'DriveTrain'
  | 'Drop'
  | 'DualScreen'
  | 'DualScreenAdd'
  | 'DualScreenArrowRight'
  | 'DualScreenArrowUp'
  | 'DualScreenClock'
  | 'DualScreenClosedAlert'
  | 'DualScreenDesktop'
  | 'DualScreenDismiss'
  | 'DualScreenGroup'
  | 'DualScreenHeader'
  | 'DualScreenLock'
  | 'DualScreenMirror'
  | 'DualScreenPagination'
  | 'DualScreenSettings'
  | 'DualScreenSpan'
  | 'DualScreenSpeaker'
  | 'DualScreenStatusBar'
  | 'DualScreenTablet'
  | 'DualScreenUpdate'
  | 'DualScreenVerticalScroll'
  | 'DualScreenVibrate'
  | 'Dumbbell'
  | 'Dust'
  | 'Earth'
  | 'EarthLeaf'
  | 'Edit'
  | 'EditArrowBack'
  | 'EditOff'
  | 'EditProhibited'
  | 'EditSettings'
  | 'Elevator'
  | 'Emoji'
  | 'EmojiAdd'
  | 'EmojiAngry'
  | 'EmojiEdit'
  | 'EmojiHand'
  | 'EmojiHint'
  | 'EmojiLaugh'
  | 'EmojiMeh'
  | 'EmojiMultiple'
  | 'EmojiSad'
  | 'EmojiSadSlight'
  | 'EmojiSmileSlight'
  | 'EmojiSparkle'
  | 'EmojiSurprise'
  | 'Engine'
  | 'EqualCircle'
  | 'EqualOff'
  | 'Eraser'
  | 'EraserMedium'
  | 'EraserSegment'
  | 'EraserSmall'
  | 'EraserTool'
  | 'ErrorCircle'
  | 'ErrorCircleSettings'
  | 'ExpandUpLeft'
  | 'ExpandUpRight'
  | 'ExtendedDock'
  | 'Eye'
  | 'EyeLines'
  | 'EyeOff'
  | 'EyeTracking'
  | 'EyeTrackingOff'
  | 'Eyedropper'
  | 'EyedropperOff'
  | 'FStop'
  | 'FastAcceleration'
  | 'FastForward'
  | 'Fax'
  | 'Feed'
  | 'Filmstrip'
  | 'FilmstripImage'
  | 'FilmstripOff'
  | 'FilmstripPlay'
  | 'FilmstripSplit'
  | 'Filter'
  | 'FilterAdd'
  | 'FilterDismiss'
  | 'FilterSync'
  | 'Fingerprint'
  | 'Fire'
  | 'Fireplace'
  | 'FixedWidth'
  | 'Flag'
  | 'FlagCheckered'
  | 'FlagClock'
  | 'FlagOff'
  | 'FlagPride'
  | 'FlagPrideIntersexInclusiveProgress'
  | 'FlagPridePhiladelphia'
  | 'FlagPrideProgress'
  | 'Flash'
  | 'FlashAdd'
  | 'FlashAuto'
  | 'FlashCheckmark'
  | 'FlashFlow'
  | 'FlashOff'
  | 'FlashPlay'
  | 'FlashSettings'
  | 'FlashSparkle'
  | 'Flashlight'
  | 'FlashlightOff'
  | 'FlipHorizontal'
  | 'FlipVertical'
  | 'Flow'
  | 'Flowchart'
  | 'FlowchartCircle'
  | 'Fluent'
  | 'Fluid'
  | 'Folder'
  | 'FolderAdd'
  | 'FolderArrowLeft'
  | 'FolderArrowRight'
  | 'FolderArrowUp'
  | 'FolderBriefcase'
  | 'FolderGlobe'
  | 'FolderLightning'
  | 'FolderLink'
  | 'FolderList'
  | 'FolderMail'
  | 'FolderMultiple'
  | 'FolderOpen'
  | 'FolderOpenVertical'
  | 'FolderPeople'
  | 'FolderPerson'
  | 'FolderProhibited'
  | 'FolderSearch'
  | 'FolderSwap'
  | 'FolderSync'
  | 'FolderZip'
  | 'FontDecrease'
  | 'FontIncrease'
  | 'FontSpaceTrackingIn'
  | 'FontSpaceTrackingOut'
  | 'Food'
  | 'FoodApple'
  | 'FoodCake'
  | 'FoodCarrot'
  | 'FoodChickenLeg'
  | 'FoodEgg'
  | 'FoodFish'
  | 'FoodGrains'
  | 'FoodPizza'
  | 'FoodToast'
  | 'Form'
  | 'FormMultiple'
  | 'FormNew'
  | 'Fps120'
  | 'Fps240'
  | 'Fps30'
  | 'Fps60'
  | 'Fps960'
  | 'Frame'
  | 'FullScreenMaximize'
  | 'FullScreenMinimize'
  | 'Games'
  | 'GanttChart'
  | 'Gas'
  | 'GasPump'
  | 'Gather'
  | 'Gauge'
  | 'GaugeAdd'
  | 'Gavel'
  | 'GavelProhibited'
  | 'Gesture'
  | 'Gif'
  | 'Gift'
  | 'GiftCard'
  | 'GiftCardAdd'
  | 'GiftCardArrowRight'
  | 'GiftCardMoney'
  | 'GiftCardMultiple'
  | 'GiftOpen'
  | 'Glance'
  | 'GlanceDefault'
  | 'GlanceHorizontal'
  | 'GlanceHorizontalSparkle'
  | 'GlanceHorizontalSparkles'
  | 'Glasses'
  | 'GlassesOff'
  | 'Globe'
  | 'GlobeAdd'
  | 'GlobeArrowForward'
  | 'GlobeArrowUp'
  | 'GlobeClock'
  | 'GlobeDesktop'
  | 'GlobeError'
  | 'GlobeLocation'
  | 'GlobePerson'
  | 'GlobeProhibited'
  | 'GlobeSearch'
  | 'GlobeShield'
  | 'GlobeStar'
  | 'GlobeSurface'
  | 'GlobeSync'
  | 'GlobeVideo'
  | 'GlobeWarning'
  | 'Grid'
  | 'GridCircles'
  | 'GridDots'
  | 'GridKanban'
  | 'Group'
  | 'GroupDismiss'
  | 'GroupList'
  | 'GroupReturn'
  | 'Guardian'
  | 'Guest'
  | 'GuestAdd'
  | 'Guitar'
  | 'HandDraw'
  | 'HandLeft'
  | 'HandLeftChat'
  | 'HandOpenHeart'
  | 'HandRight'
  | 'HandRightOff'
  | 'HandWave'
  | 'Handshake'
  | 'HardDrive'
  | 'HardDriveCall'
  | 'HatGraduation'
  | 'HatGraduationAdd'
  | 'HatGraduationSparkle'
  | 'Hd'
  | 'Hdr'
  | 'HdrOff'
  | 'Headphones'
  | 'HeadphonesSoundWave'
  | 'Headset'
  | 'HeadsetAdd'
  | 'HeadsetVr'
  | 'Heart'
  | 'HeartBroken'
  | 'HeartCircle'
  | 'HeartCircleHint'
  | 'HeartOff'
  | 'HeartPulse'
  | 'HeartPulseCheckmark'
  | 'HeartPulseError'
  | 'HeartPulseWarning'
  | 'Hexagon'
  | 'HexagonThree'
  | 'Highlight'
  | 'HighlightAccent'
  | 'HighlightLink'
  | 'History'
  | 'HistoryDismiss'
  | 'Home'
  | 'HomeAdd'
  | 'HomeCheckmark'
  | 'HomeDatabase'
  | 'HomeHeart'
  | 'HomeMore'
  | 'HomePerson'
  | 'HomeSplit'
  | 'Hourglass'
  | 'HourglassHalf'
  | 'HourglassOneQuarter'
  | 'HourglassThreeQuarter'
  | 'Icons'
  | 'Image'
  | 'ImageAdd'
  | 'ImageAltText'
  | 'ImageArrowBack'
  | 'ImageArrowCounterclockwise'
  | 'ImageArrowForward'
  | 'ImageBorder'
  | 'ImageCircle'
  | 'ImageCopy'
  | 'ImageEdit'
  | 'ImageGlobe'
  | 'ImageMultiple'
  | 'ImageMultipleOff'
  | 'ImageOff'
  | 'ImageProhibited'
  | 'ImageReflection'
  | 'ImageSearch'
  | 'ImageShadow'
  | 'ImageSparkle'
  | 'ImageStack'
  | 'ImageTable'
  | 'ImmersiveReader'
  | 'Important'
  | 'Incognito'
  | 'Info'
  | 'InfoShield'
  | 'InkStroke'
  | 'InkStrokeArrowDown'
  | 'InkStrokeArrowUpDown'
  | 'InkingTool'
  | 'InkingToolAccent'
  | 'InprivateAccount'
  | 'Insert'
  | 'IosArrow'
  | 'IosArrowLtr'
  | 'IosArrowRtl'
  | 'IosChevronRight'
  | 'Iot'
  | 'IotAlert'
  | 'Javascript'
  | 'Joystick'
  | 'Key'
  | 'KeyCommand'
  | 'KeyMultiple'
  | 'KeyReset'
  | 'Keyboard123'
  | 'Keyboard'
  | 'KeyboardDock'
  | 'KeyboardLayoutFloat'
  | 'KeyboardLayoutOneHandedLeft'
  | 'KeyboardLayoutResize'
  | 'KeyboardLayoutSplit'
  | 'KeyboardMouse'
  | 'KeyboardShift'
  | 'KeyboardShiftUppercase'
  | 'KeyboardTab'
  | 'Kiosk'
  | 'Laptop'
  | 'LaptopDismiss'
  | 'LaptopMultiple'
  | 'LaptopSettings'
  | 'LaptopShield'
  | 'LaserTool'
  | 'Lasso'
  | 'LauncherSettings'
  | 'Layer'
  | 'LayerDiagonal'
  | 'LayerDiagonalAdd'
  | 'LayerDiagonalPerson'
  | 'LayoutCellFour'
  | 'LayoutCellFourFocusBottomLeft'
  | 'LayoutCellFourFocusBottomRight'
  | 'LayoutCellFourFocusTopLeft'
  | 'LayoutCellFourFocusTopRight'
  | 'LayoutColumnFour'
  | 'LayoutColumnFourFocusCenterLeft'
  | 'LayoutColumnFourFocusCenterRight'
  | 'LayoutColumnFourFocusLeft'
  | 'LayoutColumnFourFocusRight'
  | 'LayoutColumnOneThirdLeft'
  | 'LayoutColumnOneThirdRight'
  | 'LayoutColumnOneThirdRightHint'
  | 'LayoutColumnThree'
  | 'LayoutColumnThreeFocusCenter'
  | 'LayoutColumnThreeFocusLeft'
  | 'LayoutColumnThreeFocusRight'
  | 'LayoutColumnTwo'
  | 'LayoutColumnTwoFocusLeft'
  | 'LayoutColumnTwoFocusRight'
  | 'LayoutColumnTwoSplitLeft'
  | 'LayoutColumnTwoSplitLeftFocusBottomLeft'
  | 'LayoutColumnTwoSplitLeftFocusRight'
  | 'LayoutColumnTwoSplitLeftFocusTopLeft'
  | 'LayoutColumnTwoSplitRight'
  | 'LayoutColumnTwoSplitRightFocusBottomRight'
  | 'LayoutColumnTwoSplitRightFocusLeft'
  | 'LayoutColumnTwoSplitRightFocusTopRight'
  | 'LayoutRowFour'
  | 'LayoutRowFourFocusBottom'
  | 'LayoutRowFourFocusCenterBottom'
  | 'LayoutRowFourFocusCenterTop'
  | 'LayoutRowFourFocusTop'
  | 'LayoutRowThree'
  | 'LayoutRowThreeFocusBottom'
  | 'LayoutRowThreeFocusCenter'
  | 'LayoutRowThreeFocusTop'
  | 'LayoutRowTwo'
  | 'LayoutRowTwoFocusBottom'
  | 'LayoutRowTwoFocusTop'
  | 'LayoutRowTwoSplitBottom'
  | 'LayoutRowTwoSplitBottomFocusBottomLeft'
  | 'LayoutRowTwoSplitBottomFocusBottomRight'
  | 'LayoutRowTwoSplitBottomFocusTop'
  | 'LayoutRowTwoSplitTop'
  | 'LayoutRowTwoSplitTopFocusBottom'
  | 'LayoutRowTwoSplitTopFocusTopLeft'
  | 'LayoutRowTwoSplitTopFocusTopRight'
  | 'LeafOne'
  | 'LeafThree'
  | 'LeafTwo'
  | 'LearningApp'
  | 'Library'
  | 'Lightbulb'
  | 'LightbulbCheckmark'
  | 'LightbulbCircle'
  | 'LightbulbFilament'
  | 'LightbulbPerson'
  | 'Likert'
  | 'Line'
  | 'LineDashes'
  | 'LineHorizontal1'
  | 'LineHorizontal1Dashes'
  | 'LineHorizontal2DashesSolid'
  | 'LineHorizontal3'
  | 'LineHorizontal4'
  | 'LineHorizontal4Search'
  | 'LineHorizontal5'
  | 'LineHorizontal5Error'
  | 'LineStyle'
  | 'LineThickness'
  | 'Link'
  | 'LinkAdd'
  | 'LinkDismiss'
  | 'LinkEdit'
  | 'LinkMultiple'
  | 'LinkPerson'
  | 'LinkSettings'
  | 'LinkSquare'
  | 'LinkToolbox'
  | 'List'
  | 'ListBar'
  | 'ListBarTree'
  | 'ListBarTreeOffset'
  | 'ListRtl'
  | 'Live'
  | 'LiveOff'
  | 'LocalLanguage'
  | 'Location'
  | 'LocationAdd'
  | 'LocationAddLeft'
  | 'LocationAddRight'
  | 'LocationAddUp'
  | 'LocationArrow'
  | 'LocationArrowLeft'
  | 'LocationArrowRight'
  | 'LocationArrowUp'
  | 'LocationDismiss'
  | 'LocationLive'
  | 'LocationOff'
  | 'LocationTargetSquare'
  | 'LockClosed'
  | 'LockClosedKey'
  | 'LockMultiple'
  | 'LockOpen'
  | 'LockShield'
  | 'Lottery'
  | 'Luggage'
  | 'Mail'
  | 'MailAdd'
  | 'MailAlert'
  | 'MailAllRead'
  | 'MailAllUnread'
  | 'MailArrowDoubleBack'
  | 'MailArrowDown'
  | 'MailArrowForward'
  | 'MailArrowUp'
  | 'MailAttach'
  | 'MailCheckmark'
  | 'MailClock'
  | 'MailCopy'
  | 'MailDismiss'
  | 'MailEdit'
  | 'MailError'
  | 'MailInbox'
  | 'MailInboxAdd'
  | 'MailInboxAll'
  | 'MailInboxArrowDown'
  | 'MailInboxArrowRight'
  | 'MailInboxArrowUp'
  | 'MailInboxCheckmark'
  | 'MailInboxDismiss'
  | 'MailLink'
  | 'MailList'
  | 'MailMultiple'
  | 'MailOff'
  | 'MailOpenPerson'
  | 'MailPause'
  | 'MailProhibited'
  | 'MailRead'
  | 'MailReadMultiple'
  | 'MailRewind'
  | 'MailSettings'
  | 'MailShield'
  | 'MailTemplate'
  | 'MailUnread'
  | 'MailWarning'
  | 'Mailbox'
  | 'Map'
  | 'MapDrive'
  | 'Markdown'
  | 'MatchAppLayout'
  | 'MathFormatLinear'
  | 'MathFormatProfessional'
  | 'MathFormula'
  | 'MathSymbols'
  | 'Maximize'
  | 'MeetNow'
  | 'Megaphone'
  | 'MegaphoneCircle'
  | 'MegaphoneLoud'
  | 'MegaphoneOff'
  | 'Memory'
  | 'Mention'
  | 'MentionArrowDown'
  | 'MentionBrackets'
  | 'Merge'
  | 'Mic'
  | 'MicOff'
  | 'MicProhibited'
  | 'MicPulse'
  | 'MicPulseOff'
  | 'MicRecord'
  | 'MicSettings'
  | 'MicSparkle'
  | 'MicSync'
  | 'Microscope'
  | 'Midi'
  | 'MobileOptimized'
  | 'Mold'
  | 'Molecule'
  | 'Money'
  | 'MoneyCalculator'
  | 'MoneyDismiss'
  | 'MoneyHand'
  | 'MoneyOff'
  | 'MoneySettings'
  | 'MoreCircle'
  | 'MoreHorizontal'
  | 'MoreVertical'
  | 'MountainLocationBottom'
  | 'MountainLocationTop'
  | 'MountainTrail'
  | 'MoviesAndTv'
  | 'Multiplier12X'
  | 'Multiplier15X'
  | 'Multiplier18X'
  | 'Multiplier1X'
  | 'Multiplier2X'
  | 'Multiplier5X'
  | 'MultiselectLtr'
  | 'MultiselectRtl'
  | 'MusicNote1'
  | 'MusicNote2'
  | 'MusicNote2Play'
  | 'MusicNoteOff1'
  | 'MusicNoteOff2'
  | 'MyLocation'
  | 'Navigation'
  | 'NavigationLocationTarget'
  | 'NavigationPlay'
  | 'NavigationUnread'
  | 'NetworkAdapter'
  | 'NetworkCheck'
  | 'New'
  | 'News'
  | 'Next'
  | 'NextFrame'
  | 'Note'
  | 'NoteAdd'
  | 'NoteEdit'
  | 'NotePin'
  | 'Notebook'
  | 'NotebookAdd'
  | 'NotebookArrowCurveDown'
  | 'NotebookError'
  | 'NotebookEye'
  | 'NotebookLightning'
  | 'NotebookQuestionMark'
  | 'NotebookSection'
  | 'NotebookSectionArrowRight'
  | 'NotebookSubsection'
  | 'NotebookSync'
  | 'Notepad'
  | 'NotepadEdit'
  | 'NotepadPerson'
  | 'NumberCircle0'
  | 'NumberCircle1'
  | 'NumberCircle2'
  | 'NumberCircle3'
  | 'NumberCircle4'
  | 'NumberCircle5'
  | 'NumberCircle6'
  | 'NumberCircle7'
  | 'NumberCircle8'
  | 'NumberCircle9'
  | 'NumberRow'
  | 'NumberSymbol'
  | 'NumberSymbolDismiss'
  | 'NumberSymbolSquare'
  | 'Open'
  | 'OpenFolder'
  | 'OpenOff'
  | 'Options'
  | 'Organization'
  | 'OrganizationHorizontal'
  | 'Orientation'
  | 'Oval'
  | 'Oven'
  | 'PaddingDown'
  | 'PaddingLeft'
  | 'PaddingRight'
  | 'PaddingTop'
  | 'PageFit'
  | 'PaintBrush'
  | 'PaintBrushArrowDown'
  | 'PaintBrushArrowUp'
  | 'PaintBucket'
  | 'Pair'
  | 'PanelBottom'
  | 'PanelBottomContract'
  | 'PanelBottomExpand'
  | 'PanelLeft'
  | 'PanelLeftAdd'
  | 'PanelLeftContract'
  | 'PanelLeftExpand'
  | 'PanelLeftFocusRight'
  | 'PanelLeftHeader'
  | 'PanelLeftHeaderAdd'
  | 'PanelLeftHeaderKey'
  | 'PanelLeftKey'
  | 'PanelLeftText'
  | 'PanelLeftTextAdd'
  | 'PanelLeftTextDismiss'
  | 'PanelRight'
  | 'PanelRightAdd'
  | 'PanelRightContract'
  | 'PanelRightCursor'
  | 'PanelRightExpand'
  | 'PanelRightGallery'
  | 'PanelSeparateWindow'
  | 'PanelTopContract'
  | 'PanelTopExpand'
  | 'PanelTopGallery'
  | 'Password'
  | 'Patch'
  | 'Patient'
  | 'Pause'
  | 'PauseCircle'
  | 'PauseOff'
  | 'PauseSettings'
  | 'Payment'
  | 'Pen'
  | 'PenDismiss'
  | 'PenOff'
  | 'PenProhibited'
  | 'PenSparkle'
  | 'Pentagon'
  | 'People'
  | 'PeopleAdd'
  | 'PeopleAudience'
  | 'PeopleCall'
  | 'PeopleChat'
  | 'PeopleCheckmark'
  | 'PeopleCommunity'
  | 'PeopleCommunityAdd'
  | 'PeopleEdit'
  | 'PeopleError'
  | 'PeopleList'
  | 'PeopleLock'
  | 'PeopleMoney'
  | 'PeopleProhibited'
  | 'PeopleQueue'
  | 'PeopleSearch'
  | 'PeopleSettings'
  | 'PeopleStar'
  | 'PeopleSwap'
  | 'PeopleSync'
  | 'PeopleTeam'
  | 'PeopleTeamAdd'
  | 'PeopleTeamDelete'
  | 'PeopleTeamToolbox'
  | 'PeopleToolbox'
  | 'Person'
  | 'Person5'
  | 'Person6'
  | 'PersonAccounts'
  | 'PersonAdd'
  | 'PersonAlert'
  | 'PersonArrowBack'
  | 'PersonArrowLeft'
  | 'PersonArrowRight'
  | 'PersonAvailable'
  | 'PersonBoard'
  | 'PersonCall'
  | 'PersonChat'
  | 'PersonCircle'
  | 'PersonClock'
  | 'PersonDelete'
  | 'PersonDesktop'
  | 'PersonEdit'
  | 'PersonFeedback'
  | 'PersonHeart'
  | 'PersonInfo'
  | 'PersonKey'
  | 'PersonLightbulb'
  | 'PersonLightning'
  | 'PersonLink'
  | 'PersonLock'
  | 'PersonMail'
  | 'PersonMoney'
  | 'PersonNote'
  | 'PersonPhone'
  | 'PersonPill'
  | 'PersonProhibited'
  | 'PersonQuestionMark'
  | 'PersonRibbon'
  | 'PersonRunning'
  | 'PersonSearch'
  | 'PersonSettings'
  | 'PersonSquare'
  | 'PersonSquareCheckmark'
  | 'PersonStanding'
  | 'PersonStar'
  | 'PersonStarburst'
  | 'PersonSubtract'
  | 'PersonSupport'
  | 'PersonSwap'
  | 'PersonSync'
  | 'PersonTag'
  | 'PersonVoice'
  | 'PersonWalking'
  | 'PersonWarning'
  | 'PersonWrench'
  | 'Phone'
  | 'PhoneAdd'
  | 'PhoneArrowRight'
  | 'PhoneBriefcase'
  | 'PhoneChat'
  | 'PhoneCheckmark'
  | 'PhoneDesktop'
  | 'PhoneDesktopAdd'
  | 'PhoneDismiss'
  | 'PhoneEdit'
  | 'PhoneEraser'
  | 'PhoneFooterArrowDown'
  | 'PhoneHeaderArrowUp'
  | 'PhoneKey'
  | 'PhoneLaptop'
  | 'PhoneLinkSetup'
  | 'PhoneLock'
  | 'PhoneMultiple'
  | 'PhoneMultipleSettings'
  | 'PhonePageHeader'
  | 'PhonePagination'
  | 'PhonePerson'
  | 'PhoneScreenTime'
  | 'PhoneShake'
  | 'PhoneSpanIn'
  | 'PhoneSpanOut'
  | 'PhoneSpeaker'
  | 'PhoneStatusBar'
  | 'PhoneSubtract'
  | 'PhoneTablet'
  | 'PhoneUpdate'
  | 'PhoneUpdateCheckmark'
  | 'PhoneVerticalScroll'
  | 'PhoneVibrate'
  | 'PhotoFilter'
  | 'Pi'
  | 'PictureInPicture'
  | 'PictureInPictureEnter'
  | 'PictureInPictureExit'
  | 'Pill'
  | 'Pin'
  | 'PinOff'
  | 'Pipeline'
  | 'PipelineAdd'
  | 'PipelineArrowCurveDown'
  | 'PipelinePlay'
  | 'Pivot'
  | 'PlantGrass'
  | 'PlantRagweed'
  | 'Play'
  | 'PlayCircle'
  | 'PlayCircleHint'
  | 'PlayMultiple'
  | 'PlaySettings'
  | 'PlayingCards'
  | 'PlugConnected'
  | 'PlugConnectedAdd'
  | 'PlugConnectedCheckmark'
  | 'PlugConnectedSettings'
  | 'PlugDisconnected'
  | 'PointScan'
  | 'Poll'
  | 'PollHorizontal'
  | 'PollOff'
  | 'PortHdmi'
  | 'PortMicroUsb'
  | 'PortUsbA'
  | 'PortUsbC'
  | 'PositionBackward'
  | 'PositionForward'
  | 'PositionToBack'
  | 'PositionToFront'
  | 'Power'
  | 'Predictions'
  | 'Premium'
  | 'PremiumPerson'
  | 'PresenceAvailable'
  | 'PresenceAway'
  | 'PresenceBlocked'
  | 'PresenceBusy'
  | 'PresenceDnd'
  | 'PresenceOffline'
  | 'PresenceOof'
  | 'PresenceUnknown'
  | 'Presenter'
  | 'PresenterOff'
  | 'PreviewLink'
  | 'Previous'
  | 'PreviousFrame'
  | 'Print'
  | 'PrintAdd'
  | 'Production'
  | 'ProductionCheckmark'
  | 'Prohibited'
  | 'ProhibitedMultiple'
  | 'ProhibitedNote'
  | 'ProjectionScreen'
  | 'ProjectionScreenDismiss'
  | 'ProjectionScreenText'
  | 'ProtocolHandler'
  | 'Pulse'
  | 'PulseSquare'
  | 'PuzzleCube'
  | 'PuzzleCubePiece'
  | 'PuzzlePiece'
  | 'PuzzlePieceShield'
  | 'QrCode'
  | 'Question'
  | 'QuestionCircle'
  | 'QuizNew'
  | 'Radar'
  | 'RadarCheckmark'
  | 'RadarRectangleMultiple'
  | 'RadioButton'
  | 'RadioButtonOff'
  | 'Ram'
  | 'RatingMature'
  | 'RatioOneToOne'
  | 'ReOrder'
  | 'ReOrderDotsHorizontal'
  | 'ReOrderDotsVertical'
  | 'ReadAloud'
  | 'ReadingList'
  | 'ReadingListAdd'
  | 'ReadingModeMobile'
  | 'RealEstate'
  | 'Receipt'
  | 'ReceiptAdd'
  | 'ReceiptBag'
  | 'ReceiptCube'
  | 'ReceiptMoney'
  | 'ReceiptPlay'
  | 'ReceiptSearch'
  | 'ReceiptSparkles'
  | 'Record'
  | 'RecordStop'
  | 'RectangleLandscape'
  | 'RectangleLandscapeHintCopy'
  | 'RectangleLandscapeSparkle'
  | 'RectangleLandscapeSync'
  | 'RectangleLandscapeSyncOff'
  | 'RectanglePortraitLocationTarget'
  | 'Recycle'
  | 'RemixAdd'
  | 'Remote'
  | 'Rename'
  | 'Reorder'
  | 'Replay'
  | 'Resize'
  | 'ResizeImage'
  | 'ResizeLarge'
  | 'ResizeSmall'
  | 'ResizeTable'
  | 'ResizeVideo'
  | 'Reward'
  | 'Rewind'
  | 'Rhombus'
  | 'Ribbon'
  | 'RibbonAdd'
  | 'RibbonOff'
  | 'RibbonStar'
  | 'RoadCone'
  | 'Rocket'
  | 'RotateLeft'
  | 'RotateRight'
  | 'Router'
  | 'RowTriple'
  | 'Rss'
  | 'Ruler'
  | 'Run'
  | 'Sanitize'
  | 'Save'
  | 'SaveArrowRight'
  | 'SaveCopy'
  | 'SaveEdit'
  | 'SaveImage'
  | 'SaveMultiple'
  | 'SaveSearch'
  | 'SaveSync'
  | 'Savings'
  | 'ScaleFill'
  | 'ScaleFit'
  | 'Scales'
  | 'Scan'
  | 'ScanCamera'
  | 'ScanDash'
  | 'ScanObject'
  | 'ScanPerson'
  | 'ScanQrCode'
  | 'ScanTable'
  | 'ScanText'
  | 'ScanThumbUp'
  | 'ScanThumbUpOff'
  | 'ScanType'
  | 'ScanTypeCheckmark'
  | 'ScanTypeOff'
  | 'Scratchpad'
  | 'ScreenCut'
  | 'ScreenPerson'
  | 'ScreenSearch'
  | 'Screenshot'
  | 'ScreenshotRecord'
  | 'Script'
  | 'Search'
  | 'SearchInfo'
  | 'SearchSettings'
  | 'SearchShield'
  | 'SearchSquare'
  | 'SearchVisual'
  | 'Seat'
  | 'SeatAdd'
  | 'SelectAllOff'
  | 'SelectAllOn'
  | 'SelectObject'
  | 'SelectObjectSkew'
  | 'SelectObjectSkewDismiss'
  | 'SelectObjectSkewEdit'
  | 'Send'
  | 'SendBeaker'
  | 'SendClock'
  | 'SendCopy'
  | 'SerialPort'
  | 'Server'
  | 'ServerLink'
  | 'ServerMultiple'
  | 'ServerPlay'
  | 'ServerSurface'
  | 'ServerSurfaceMultiple'
  | 'ServiceBell'
  | 'Settings'
  | 'SettingsChat'
  | 'SettingsCogMultiple'
  | 'ShapeExclude'
  | 'ShapeIntersect'
  | 'ShapeOrganic'
  | 'ShapeSubtract'
  | 'ShapeUnion'
  | 'Shapes'
  | 'Share'
  | 'ShareAndroid'
  | 'ShareCloseTray'
  | 'ShareIos'
  | 'ShareScreenPerson'
  | 'ShareScreenPersonOverlay'
  | 'ShareScreenPersonOverlayInside'
  | 'ShareScreenPersonP'
  | 'ShareScreenStart'
  | 'ShareScreenStop'
  | 'Shield'
  | 'ShieldAdd'
  | 'ShieldBadge'
  | 'ShieldCheckmark'
  | 'ShieldDismiss'
  | 'ShieldDismissShield'
  | 'ShieldError'
  | 'ShieldGlobe'
  | 'ShieldKeyhole'
  | 'ShieldLock'
  | 'ShieldPerson'
  | 'ShieldPersonAdd'
  | 'ShieldProhibited'
  | 'ShieldQuestion'
  | 'ShieldTask'
  | 'Shifts'
  | 'Shifts30Minutes'
  | 'ShiftsActivity'
  | 'ShiftsAdd'
  | 'ShiftsAvailability'
  | 'ShiftsCheckmark'
  | 'ShiftsDay'
  | 'ShiftsOpen'
  | 'ShiftsProhibited'
  | 'ShiftsQuestionMark'
  | 'ShiftsTeam'
  | 'ShoppingBag'
  | 'ShoppingBagAdd'
  | 'ShoppingBagArrowLeft'
  | 'ShoppingBagDismiss'
  | 'ShoppingBagPause'
  | 'ShoppingBagPercent'
  | 'ShoppingBagPlay'
  | 'ShoppingBagTag'
  | 'Shortpick'
  | 'Showerhead'
  | 'SidebarSearchLtr'
  | 'SidebarSearchRtl'
  | 'SignOut'
  | 'Signature'
  | 'Sim'
  | 'SkipBack10'
  | 'SkipForward10'
  | 'SkipForward30'
  | 'SkipForwardTab'
  | 'SlashForward'
  | 'Sleep'
  | 'SlideAdd'
  | 'SlideArrowRight'
  | 'SlideContent'
  | 'SlideEraser'
  | 'SlideGrid'
  | 'SlideHide'
  | 'SlideLayout'
  | 'SlideLink'
  | 'SlideMicrophone'
  | 'SlideMultiple'
  | 'SlideMultipleArrowRight'
  | 'SlideMultipleSearch'
  | 'SlideRecord'
  | 'SlideSearch'
  | 'SlideSettings'
  | 'SlideSize'
  | 'SlideText'
  | 'SlideTextEdit'
  | 'SlideTextMultiple'
  | 'SlideTextPerson'
  | 'SlideTextSparkle'
  | 'SlideTransition'
  | 'Smartwatch'
  | 'SmartwatchDot'
  | 'Snooze'
  | 'SoundSource'
  | 'SoundWaveCircle'
  | 'Space3D'
  | 'Spacebar'
  | 'Sparkle'
  | 'SparkleCircle'
  | 'Speaker0'
  | 'Speaker1'
  | 'Speaker2'
  | 'SpeakerBluetooth'
  | 'SpeakerBox'
  | 'SpeakerEdit'
  | 'SpeakerMute'
  | 'SpeakerOff'
  | 'SpeakerSettings'
  | 'SpeakerUsb'
  | 'SpinnerIos'
  | 'SplitHint'
  | 'SplitHorizontal'
  | 'SplitVertical'
  | 'Sport'
  | 'SportAmericanFootball'
  | 'SportBaseball'
  | 'SportBasketball'
  | 'SportHockey'
  | 'SportSoccer'
  | 'SprayCan'
  | 'Square'
  | 'SquareAdd'
  | 'SquareArrowForward'
  | 'SquareDismiss'
  | 'SquareEraser'
  | 'SquareHint'
  | 'SquareHintApps'
  | 'SquareHintArrowBack'
  | 'SquareHintHexagon'
  | 'SquareHintSparkles'
  | 'SquareMultiple'
  | 'SquareShadow'
  | 'SquaresNested'
  | 'Stack'
  | 'StackAdd'
  | 'StackArrowForward'
  | 'StackStar'
  | 'StackVertical'
  | 'Star'
  | 'StarAdd'
  | 'StarArrowBack'
  | 'StarArrowRightEnd'
  | 'StarArrowRightStart'
  | 'StarCheckmark'
  | 'StarDismiss'
  | 'StarEdit'
  | 'StarEmphasis'
  | 'StarHalf'
  | 'StarLineHorizontal3'
  | 'StarOff'
  | 'StarOneQuarter'
  | 'StarProhibited'
  | 'StarSettings'
  | 'StarThreeQuarter'
  | 'Status'
  | 'Step'
  | 'Steps'
  | 'Stethoscope'
  | 'Sticker'
  | 'StickerAdd'
  | 'Stop'
  | 'Storage'
  | 'StoreMicrosoft'
  | 'Stream'
  | 'StreamInput'
  | 'StreamInputOutput'
  | 'StreamOutput'
  | 'StreetSign'
  | 'StyleGuide'
  | 'SubGrid'
  | 'Subtitles'
  | 'Subtract'
  | 'SubtractCircle'
  | 'SubtractCircleArrowBack'
  | 'SubtractCircleArrowForward'
  | 'SubtractParentheses'
  | 'SubtractSquare'
  | 'SubtractSquareMultiple'
  | 'SurfaceEarbuds'
  | 'SurfaceHub'
  | 'SwimmingPool'
  | 'SwipeDown'
  | 'SwipeRight'
  | 'SwipeUp'
  | 'Symbols'
  | 'SyncOff'
  | 'Syringe'
  | 'System'
  | 'Tab'
  | 'TabAdd'
  | 'TabArrowLeft'
  | 'TabDesktop'
  | 'TabDesktopArrowClockwise'
  | 'TabDesktopArrowLeft'
  | 'TabDesktopBottom'
  | 'TabDesktopClock'
  | 'TabDesktopCopy'
  | 'TabDesktopImage'
  | 'TabDesktopLink'
  | 'TabDesktopMultiple'
  | 'TabDesktopMultipleAdd'
  | 'TabDesktopMultipleBottom'
  | 'TabDesktopNewPage'
  | 'TabInPrivate'
  | 'TabInprivateAccount'
  | 'TabProhibited'
  | 'TabShieldDismiss'
  | 'Table'
  | 'TableAdd'
  | 'TableArrowUp'
  | 'TableBottomRow'
  | 'TableCalculator'
  | 'TableCellEdit'
  | 'TableCellsMerge'
  | 'TableCellsSplit'
  | 'TableChecker'
  | 'TableColumnTopBottom'
  | 'TableCopy'
  | 'TableDefault'
  | 'TableDeleteColumn'
  | 'TableDeleteRow'
  | 'TableDismiss'
  | 'TableEdit'
  | 'TableFreezeColumn'
  | 'TableFreezeColumnAndRow'
  | 'TableFreezeRow'
  | 'TableImage'
  | 'TableInsertColumn'
  | 'TableInsertRow'
  | 'TableLightning'
  | 'TableLink'
  | 'TableLock'
  | 'TableMoveAbove'
  | 'TableMoveBelow'
  | 'TableMoveLeft'
  | 'TableMoveRight'
  | 'TableMultiple'
  | 'TableOffset'
  | 'TableOffsetAdd'
  | 'TableOffsetLessThanOrEqualTo'
  | 'TableOffsetSettings'
  | 'TableResizeColumn'
  | 'TableResizeRow'
  | 'TableSearch'
  | 'TableSettings'
  | 'TableSimple'
  | 'TableSimpleCheckmark'
  | 'TableSimpleExclude'
  | 'TableSimpleInclude'
  | 'TableSimpleMultiple'
  | 'TableSplit'
  | 'TableStackAbove'
  | 'TableStackBelow'
  | 'TableStackLeft'
  | 'TableStackRight'
  | 'TableSwitch'
  | 'Tablet'
  | 'TabletLaptop'
  | 'TabletSpeaker'
  | 'Tabs'
  | 'Tag'
  | 'TagCircle'
  | 'TagDismiss'
  | 'TagError'
  | 'TagLock'
  | 'TagLockAccent'
  | 'TagMultiple'
  | 'TagOff'
  | 'TagQuestionMark'
  | 'TagReset'
  | 'TagSearch'
  | 'TapDouble'
  | 'TapSingle'
  | 'Target'
  | 'TargetAdd'
  | 'TargetArrow'
  | 'TargetDismiss'
  | 'TargetEdit'
  | 'TaskListAdd'
  | 'TaskListLtr'
  | 'TaskListRtl'
  | 'TaskListSquareAdd'
  | 'TaskListSquareDatabase'
  | 'TaskListSquareLtr'
  | 'TaskListSquarePerson'
  | 'TaskListSquareRtl'
  | 'TaskListSquareSettings'
  | 'TasksApp'
  | 'TeardropBottomRight'
  | 'Teddy'
  | 'Temperature'
  | 'Tent'
  | 'TetrisApp'
  | 'Text'
  | 'TextAbcUnderlineDouble'
  | 'TextAdd'
  | 'TextAddSpaceAfter'
  | 'TextAddSpaceBefore'
  | 'TextAddT'
  | 'TextAlignCenter'
  | 'TextAlignCenterRotate270'
  | 'TextAlignCenterRotate90'
  | 'TextAlignDistributed'
  | 'TextAlignDistributedEvenly'
  | 'TextAlignDistributedVertical'
  | 'TextAlignJustify'
  | 'TextAlignJustifyLow'
  | 'TextAlignJustifyLow90'
  | 'TextAlignJustifyLowRotate270'
  | 'TextAlignJustifyLowRotate90'
  | 'TextAlignJustifyRotate270'
  | 'TextAlignJustifyRotate90'
  | 'TextAlignLeft'
  | 'TextAlignLeftRotate270'
  | 'TextAlignLeftRotate90'
  | 'TextAlignRight'
  | 'TextAlignRightRotate270'
  | 'TextAlignRightRotate90'
  | 'TextArrowDownRightColumn'
  | 'TextAsterisk'
  | 'TextBaseline'
  | 'TextBold'
  | 'TextBoxSettings'
  | 'TextBulletList'
  | 'TextBulletList270'
  | 'TextBulletList90'
  | 'TextBulletListAdd'
  | 'TextBulletListCheckmark'
  | 'TextBulletListDismiss'
  | 'TextBulletListLtr'
  | 'TextBulletListLtr90'
  | 'TextBulletListLtrRotate270'
  | 'TextBulletListRtl'
  | 'TextBulletListRtl90'
  | 'TextBulletListSquare'
  | 'TextBulletListSquareClock'
  | 'TextBulletListSquareEdit'
  | 'TextBulletListSquarePerson'
  | 'TextBulletListSquareSearch'
  | 'TextBulletListSquareSettings'
  | 'TextBulletListSquareShield'
  | 'TextBulletListSquareSparkle'
  | 'TextBulletListSquareToolbox'
  | 'TextBulletListSquareWarning'
  | 'TextBulletListTree'
  | 'TextCaseLowercase'
  | 'TextCaseTitle'
  | 'TextCaseUppercase'
  | 'TextChangeCase'
  | 'TextClearFormatting'
  | 'TextCollapse'
  | 'TextColor'
  | 'TextColorAccent'
  | 'TextColumnOne'
  | 'TextColumnOneNarrow'
  | 'TextColumnOneSemiNarrow'
  | 'TextColumnOneWide'
  | 'TextColumnOneWideLightning'
  | 'TextColumnThree'
  | 'TextColumnTwo'
  | 'TextColumnTwoLeft'
  | 'TextColumnTwoRight'
  | 'TextColumnWide'
  | 'TextContinuous'
  | 'TextDensity'
  | 'TextDescription'
  | 'TextDescriptionLtr'
  | 'TextDescriptionRtl'
  | 'TextDirectionHorizontalLeft'
  | 'TextDirectionHorizontalLtr'
  | 'TextDirectionHorizontalRight'
  | 'TextDirectionHorizontalRtl'
  | 'TextDirectionRotate270Right'
  | 'TextDirectionRotate315Right'
  | 'TextDirectionRotate45Right'
  | 'TextDirectionRotate90Left'
  | 'TextDirectionRotate90Ltr'
  | 'TextDirectionRotate90Right'
  | 'TextDirectionRotate90Rtl'
  | 'TextDirectionVertical'
  | 'TextEditStyle'
  | 'TextEditStyleCharacterA'
  | 'TextEditStyleCharacterGa'
  | 'TextEffects'
  | 'TextEffectsSparkle'
  | 'TextExpand'
  | 'TextField'
  | 'TextFirstLine'
  | 'TextFont'
  | 'TextFontInfo'
  | 'TextFontSize'
  | 'TextFootnote'
  | 'TextGrammarArrowLeft'
  | 'TextGrammarArrowRight'
  | 'TextGrammarCheckmark'
  | 'TextGrammarDismiss'
  | 'TextGrammarError'
  | 'TextGrammarLightning'
  | 'TextGrammarSettings'
  | 'TextGrammarWand'
  | 'TextHanging'
  | 'TextHeader1'
  | 'TextHeader1Lines'
  | 'TextHeader1LinesCaret'
  | 'TextHeader2'
  | 'TextHeader2Lines'
  | 'TextHeader2LinesCaret'
  | 'TextHeader3'
  | 'TextHeader3Lines'
  | 'TextHeader3LinesCaret'
  | 'TextIndentDecrease'
  | 'TextIndentDecreaseLtr'
  | 'TextIndentDecreaseLtr90'
  | 'TextIndentDecreaseLtrRotate270'
  | 'TextIndentDecreaseRotate270'
  | 'TextIndentDecreaseRotate90'
  | 'TextIndentDecreaseRtl'
  | 'TextIndentDecreaseRtl90'
  | 'TextIndentDecreaseRtlRotate270'
  | 'TextIndentIncrease'
  | 'TextIndentIncreaseLtr'
  | 'TextIndentIncreaseLtr90'
  | 'TextIndentIncreaseLtrRotate270'
  | 'TextIndentIncreaseRotate270'
  | 'TextIndentIncreaseRotate90'
  | 'TextIndentIncreaseRtl'
  | 'TextIndentIncreaseRtl90'
  | 'TextIndentIncreaseRtlRotate270'
  | 'TextItalic'
  | 'TextLineSpacing'
  | 'TextMore'
  | 'TextNumberFormat'
  | 'TextNumberListLtr'
  | 'TextNumberListLtr90'
  | 'TextNumberListLtrRotate270'
  | 'TextNumberListRotate270'
  | 'TextNumberListRotate90'
  | 'TextNumberListRtl'
  | 'TextNumberListRtl90'
  | 'TextNumberListRtlRotate270'
  | 'TextParagraph'
  | 'TextParagraphDirection'
  | 'TextParagraphDirectionLeft'
  | 'TextParagraphDirectionRight'
  | 'TextPeriodAsterisk'
  | 'TextPositionBehind'
  | 'TextPositionFront'
  | 'TextPositionLine'
  | 'TextPositionSquare'
  | 'TextPositionSquareLeft'
  | 'TextPositionSquareRight'
  | 'TextPositionThrough'
  | 'TextPositionTight'
  | 'TextPositionTopBottom'
  | 'TextProofingTools'
  | 'TextQuote'
  | 'TextSortAscending'
  | 'TextSortDescending'
  | 'TextStrikethrough'
  | 'TextSubscript'
  | 'TextSuperscript'
  | 'TextT'
  | 'TextTTag'
  | 'TextUnderline'
  | 'TextUnderlineCharacterU'
  | 'TextUnderlineDouble'
  | 'TextWholeWord'
  | 'TextWordCount'
  | 'TextWrap'
  | 'TextWrapOff'
  | 'Textbox'
  | 'TextboxAlignBottom'
  | 'TextboxAlignBottomCenter'
  | 'TextboxAlignBottomLeft'
  | 'TextboxAlignBottomRight'
  | 'TextboxAlignBottomRotate90'
  | 'TextboxAlignCenter'
  | 'TextboxAlignMiddle'
  | 'TextboxAlignMiddleLeft'
  | 'TextboxAlignMiddleRight'
  | 'TextboxAlignMiddleRotate90'
  | 'TextboxAlignTop'
  | 'TextboxAlignTopCenter'
  | 'TextboxAlignTopLeft'
  | 'TextboxAlignTopRight'
  | 'TextboxAlignTopRotate90'
  | 'TextboxMore'
  | 'TextboxRotate90'
  | 'TextboxSettings'
  | 'Thinking'
  | 'ThumbDislike'
  | 'ThumbLike'
  | 'ThumbLikeDislike'
  | 'TicketDiagonal'
  | 'TicketHorizontal'
  | 'TimeAndWeather'
  | 'TimePicker'
  | 'Timeline'
  | 'Timer10'
  | 'Timer'
  | 'Timer2'
  | 'Timer3'
  | 'TimerOff'
  | 'ToggleLeft'
  | 'ToggleMultiple'
  | 'ToggleRight'
  | 'Toolbox'
  | 'TooltipQuote'
  | 'TopSpeed'
  | 'Translate'
  | 'TranslateAuto'
  | 'TranslateOff'
  | 'Transmission'
  | 'TrayItemAdd'
  | 'TrayItemRemove'
  | 'TreeDeciduous'
  | 'TreeEvergreen'
  | 'Triangle'
  | 'TriangleDown'
  | 'TriangleLeft'
  | 'TriangleRight'
  | 'TriangleUp'
  | 'Trophy'
  | 'TrophyLock'
  | 'TrophyOff'
  | 'Tv'
  | 'TvArrowRight'
  | 'TvUsb'
  | 'Umbrella'
  | 'UninstallApp'
  | 'UsbPlug'
  | 'UsbStick'
  | 'Vault'
  | 'VehicleBicycle'
  | 'VehicleBus'
  | 'VehicleCab'
  | 'VehicleCableCar'
  | 'VehicleCar'
  | 'VehicleCarCollision'
  | 'VehicleCarParking'
  | 'VehicleCarProfile'
  | 'VehicleCarProfileLtr'
  | 'VehicleCarProfileLtrClock'
  | 'VehicleCarProfileRtl'
  | 'VehicleShip'
  | 'VehicleSubway'
  | 'VehicleSubwayClock'
  | 'VehicleTruck'
  | 'VehicleTruckBag'
  | 'VehicleTruckCube'
  | 'VehicleTruckProfile'
  | 'Video'
  | 'Video360'
  | 'Video360Off'
  | 'VideoAdd'
  | 'VideoBackgroundEffect'
  | 'VideoBackgroundEffectHorizontal'
  | 'VideoChat'
  | 'VideoClip'
  | 'VideoClipMultiple'
  | 'VideoClipOff'
  | 'VideoClipOptimize'
  | 'VideoLink'
  | 'VideoOff'
  | 'VideoPeople'
  | 'VideoPerson'
  | 'VideoPersonCall'
  | 'VideoPersonClock'
  | 'VideoPersonOff'
  | 'VideoPersonPulse'
  | 'VideoPersonSparkle'
  | 'VideoPersonSparkleOff'
  | 'VideoPersonStar'
  | 'VideoPersonStarOff'
  | 'VideoPlayPause'
  | 'VideoProhibited'
  | 'VideoRecording'
  | 'VideoSecurity'
  | 'VideoSwitch'
  | 'VideoSync'
  | 'ViewDesktop'
  | 'ViewDesktopMobile'
  | 'VirtualNetwork'
  | 'VirtualNetworkToolbox'
  | 'Voicemail'
  | 'VoicemailArrowBack'
  | 'VoicemailArrowForward'
  | 'VoicemailArrowSubtract'
  | 'VoicemailShield'
  | 'VoicemailSubtract'
  | 'Vote'
  | 'WalkieTalkie'
  | 'Wallet'
  | 'WalletCreditCard'
  | 'Wallpaper'
  | 'Wand'
  | 'Warning'
  | 'WarningShield'
  | 'Washer'
  | 'Water'
  | 'WeatherBlowingSnow'
  | 'WeatherCloudy'
  | 'WeatherDrizzle'
  | 'WeatherDuststorm'
  | 'WeatherFog'
  | 'WeatherHailDay'
  | 'WeatherHailNight'
  | 'WeatherHaze'
  | 'WeatherMoon'
  | 'WeatherMoonOff'
  | 'WeatherPartlyCloudyDay'
  | 'WeatherPartlyCloudyNight'
  | 'WeatherRain'
  | 'WeatherRainShowersDay'
  | 'WeatherRainShowersNight'
  | 'WeatherRainSnow'
  | 'WeatherSnow'
  | 'WeatherSnowShowerDay'
  | 'WeatherSnowShowerNight'
  | 'WeatherSnowflake'
  | 'WeatherSqualls'
  | 'WeatherSunny'
  | 'WeatherSunnyHigh'
  | 'WeatherSunnyLow'
  | 'WeatherThunderstorm'
  | 'WebAsset'
  | 'Whiteboard'
  | 'WhiteboardOff'
  | 'Wifi1'
  | 'Wifi2'
  | 'Wifi3'
  | 'Wifi4'
  | 'WifiLock'
  | 'WifiOff'
  | 'WifiSettings'
  | 'WifiWarning'
  | 'Window'
  | 'WindowAd'
  | 'WindowAdOff'
  | 'WindowAdPerson'
  | 'WindowApps'
  | 'WindowArrowUp'
  | 'WindowBulletList'
  | 'WindowBulletListAdd'
  | 'WindowConsole'
  | 'WindowDatabase'
  | 'WindowDevEdit'
  | 'WindowDevTools'
  | 'WindowEdit'
  | 'WindowHeaderHorizontal'
  | 'WindowHeaderHorizontalOff'
  | 'WindowHeaderVertical'
  | 'WindowInprivate'
  | 'WindowInprivateAccount'
  | 'WindowLocationTarget'
  | 'WindowMultiple'
  | 'WindowMultipleSwap'
  | 'WindowNew'
  | 'WindowPlay'
  | 'WindowSettings'
  | 'WindowShield'
  | 'WindowText'
  | 'WindowWrench'
  | 'Wrench'
  | 'WrenchScrewdriver'
  | 'WrenchSettings'
  | 'XboxConsole'
  | 'XboxController'
  | 'XboxControllerError'
  | 'Xray'
  | 'ZoomFit'
  | 'ZoomIn'
  | 'ZoomOut';

export type ActionStyle = 'default' | 'positive' | 'destructive';

export type ActionMode = 'primary' | 'secondary';

export type MenuActionArray = (
  | IExecuteAction
  | IInsertImageAction
  | IOpenUrlAction
  | IOpenUrlDialogAction
  | IResetInputsAction
  | ISubmitAction
  | IToggleVisibilityAction
)[];

export type ThemeName = 'Light' | 'Dark';

export type ElementHeight = 'auto' | 'stretch';

export type HorizontalAlignment = 'Left' | 'Center' | 'Right';

export type Spacing =
  | 'None'
  | 'ExtraSmall'
  | 'Small'
  | 'Default'
  | 'Medium'
  | 'Large'
  | 'ExtraLarge'
  | 'Padding';

export type TargetWidth =
  | 'VeryNarrow'
  | 'Narrow'
  | 'Standard'
  | 'Wide'
  | 'atLeast:VeryNarrow'
  | 'atMost:VeryNarrow'
  | 'atLeast:Narrow'
  | 'atMost:Narrow'
  | 'atLeast:Standard'
  | 'atMost:Standard'
  | 'atLeast:Wide'
  | 'atMost:Wide';

export type ContainerStyle =
  | 'default'
  | 'emphasis'
  | 'accent'
  | 'good'
  | 'attention'
  | 'warning';

export type VerticalAlignment = 'Top' | 'Center' | 'Bottom';

export type FlowLayoutItemFit = 'Fit' | 'Fill';

export type FillMode =
  | 'Cover'
  | 'RepeatHorizontally'
  | 'RepeatVertically'
  | 'Repeat';

export type TextSize = 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge';

export type TextWeight = 'Lighter' | 'Default' | 'Bolder';

export type TextColor =
  | 'Default'
  | 'Dark'
  | 'Light'
  | 'Accent'
  | 'Good'
  | 'Warning'
  | 'Attention';

export type FontType = 'Default' | 'Monospace';

export type TextBlockStyle = 'default' | 'columnHeader' | 'heading';

export type ImageStyle = 'Default' | 'Person' | 'RoundedCorners';

export type Size = 'Auto' | 'Stretch' | 'Small' | 'Medium' | 'Large';

export type ImageFitMode = 'Cover' | 'Contain' | 'Fill';

export type InputTextStyle = 'Text' | 'Tel' | 'Url' | 'Email' | 'Password';

export type AssociatedInputs = 'auto' | 'none';

export type ChoiceSetInputStyle = 'compact' | 'expanded' | 'filtered';

export type RatingSize = 'Medium' | 'Large';

export type RatingColor = 'Neutral' | 'Marigold';

export type RatingStyle = 'Default' | 'Compact';

export type IconSize =
  | 'xxSmall'
  | 'xSmall'
  | 'Small'
  | 'Standard'
  | 'Medium'
  | 'Large'
  | 'xLarge'
  | 'xxLarge';

export type IconStyle = 'Regular' | 'Filled';

export type CarouselPageAnimation = 'Slide' | 'CrossFade' | 'None';

export type BadgeIconPosition = 'Before' | 'After';

export type BadgeAppearance = 'Filled' | 'Tint';

export type BadgeSize = 'Medium' | 'Large' | 'ExtraLarge';

export type BadgeShape = 'Square' | 'Rounded' | 'Circular';

export type BadgeStyle =
  | 'Default'
  | 'Subtle'
  | 'Informative'
  | 'Accent'
  | 'Good'
  | 'Attention'
  | 'Warning';

export type ProgressRingLabelPosition = 'Before' | 'After' | 'Above' | 'Below';

export type ProgressRingSize = 'Tiny' | 'Small' | 'Medium' | 'Large';

export type ProgressBarColor = 'Accent' | 'Good' | 'Warning' | 'Attention';

export type ChartColorSet =
  | 'categorical'
  | 'sequential'
  | 'sequentialred'
  | 'sequentialgreen'
  | 'sequentialyellow'
  | 'diverging';

export type ChartColor =
  | 'good'
  | 'warning'
  | 'attention'
  | 'neutral'
  | 'categoricalRed'
  | 'categoricalPurple'
  | 'categoricalLavender'
  | 'categoricalBlue'
  | 'categoricalLightBlue'
  | 'categoricalTeal'
  | 'categoricalGreen'
  | 'categoricalLime'
  | 'categoricalMarigold'
  | 'sequential1'
  | 'sequential2'
  | 'sequential3'
  | 'sequential4'
  | 'sequential5'
  | 'sequential6'
  | 'sequential7'
  | 'sequential8'
  | 'divergingBlue'
  | 'divergingLightBlue'
  | 'divergingCyan'
  | 'divergingTeal'
  | 'divergingYellow'
  | 'divergingPeach'
  | 'divergingLightRed'
  | 'divergingRed'
  | 'divergingMaroon'
  | 'divergingGray'
  | 'sequentialRed1'
  | 'sequentialRed2'
  | 'sequentialRed3'
  | 'sequentialRed4'
  | 'sequentialRed5'
  | 'sequentialRed6'
  | 'sequentialRed7'
  | 'sequentialRed8'
  | 'sequentialGreen1'
  | 'sequentialGreen2'
  | 'sequentialGreen3'
  | 'sequentialGreen4'
  | 'sequentialGreen5'
  | 'sequentialGreen6'
  | 'sequentialGreen7'
  | 'sequentialGreen8'
  | 'sequentialYellow1'
  | 'sequentialYellow2'
  | 'sequentialYellow3'
  | 'sequentialYellow4'
  | 'sequentialYellow5'
  | 'sequentialYellow6'
  | 'sequentialYellow7'
  | 'sequentialYellow8';

export type DonutThickness = 'Thin' | 'Thick';

export type HorizontalBarChartDisplayMode =
  | 'AbsoluteWithAxis'
  | 'AbsoluteNoAxis'
  | 'PartToWhole';

export type GaugeChartValueFormat = 'Percentage' | 'Fraction';

export type CodeLanguage =
  | 'Bash'
  | 'C'
  | 'Cpp'
  | 'CSharp'
  | 'Css'
  | 'Dos'
  | 'Go'
  | 'Graphql'
  | 'Html'
  | 'Java'
  | 'JavaScript'
  | 'Json'
  | 'ObjectiveC'
  | 'Perl'
  | 'Php'
  | 'PlainText'
  | 'PowerShell'
  | 'Python'
  | 'Sql'
  | 'TypeScript'
  | 'VbNet'
  | 'Verilog'
  | 'Vhdl'
  | 'Xml';

export type PersonaIconStyle = 'profilePicture' | 'contactCard' | 'none';

export type PersonaDisplayStyle = 'iconAndName' | 'iconOnly' | 'nameOnly';

export type FallbackElement =
  | IContainer
  | IActionSet
  | IColumnSet
  | IMedia
  | IRichTextBlock
  | ITable
  | ITextBlock
  | IFactSet
  | IImageSet
  | IImage
  | ITextInput
  | IDateInput
  | ITimeInput
  | INumberInput
  | IToggleInput
  | IChoiceSetInput
  | IRatingInput
  | IRating
  | ICompoundButton
  | IIcon
  | ICarousel
  | IBadge
  | IProgressRing
  | IProgressBar
  | IDonutChart
  | IPieChart
  | IGroupedVerticalBarChart
  | IVerticalBarChart
  | IHorizontalBarChart
  | IStackedHorizontalBarChart
  | ILineChart
  | IGaugeChart
  | ICodeBlock
  | IComUserMicrosoftGraphComponent
  | IComUsersMicrosoftGraphComponent
  | IComResourceMicrosoftGraphComponent
  | IComFileMicrosoftGraphComponent
  | IComEventMicrosoftGraphComponent
  | 'drop';

export type CardElementArray = (
  | IActionSet
  | IBadge
  | ICarousel
  | IDonutChart
  | IGaugeChart
  | IHorizontalBarChart
  | IStackedHorizontalBarChart
  | ILineChart
  | IPieChart
  | IVerticalBarChart
  | IGroupedVerticalBarChart
  | ICodeBlock
  | IColumnSet
  | IComEventMicrosoftGraphComponent
  | IComFileMicrosoftGraphComponent
  | IComResourceMicrosoftGraphComponent
  | IComUserMicrosoftGraphComponent
  | IComUsersMicrosoftGraphComponent
  | ICompoundButton
  | IContainer
  | IFactSet
  | IIcon
  | IImage
  | IImageSet
  | IChoiceSetInput
  | IDateInput
  | INumberInput
  | IRatingInput
  | ITextInput
  | ITimeInput
  | IToggleInput
  | IMedia
  | IProgressBar
  | IProgressRing
  | IRating
  | IRichTextBlock
  | ITable
  | ITextBlock
)[];

export type ImageSize = 'Small' | 'Medium' | 'Large';

export type TableCellArray = ITableCell[];

export type TableRowArray = ITableRow[];

export type RichTextBlockInlineArray = (
  | ITextRun
  | IIconRun
  | IImageRun
  | string
)[];

export type ColumnArray = IColumn[];

export type ActionArray = (
  | IExecuteAction
  | IInsertImageAction
  | IOpenUrlAction
  | IOpenUrlDialogAction
  | IPopoverAction
  | IResetInputsAction
  | IShowCardAction
  | ISubmitAction
  | IToggleVisibilityAction
)[];

export type PopoverPosition = 'Above' | 'Below' | 'Before' | 'After';

export type FallbackAction =
  | ISubmitAction
  | IOpenUrlAction
  | IExecuteAction
  | IToggleVisibilityAction
  | IShowCardAction
  | IResetInputsAction
  | IPopoverAction
  | IOpenUrlDialogAction
  | IInsertImageAction
  | 'drop';

export type ImageInsertPosition = 'Selection' | 'Top' | 'Bottom';

export type Version = '1.0' | '1.1' | '1.2' | '1.3' | '1.4' | '1.5' | '1.6';

export type TeamsCardWidth = 'full';

export type MentionType = 'Person' | 'Tag';

/**
 * An Adaptive Card, containing a free-form body of card elements, and an optional set of actions.
 */
export interface IAdaptiveCard {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **AdaptiveCard**.
   */
  readonly type: 'AdaptiveCard';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * A URL to the Adaptive Card schema the card is authored against.
   */
  $schema?: string;
  /**
   * The Adaptive Card schema version the card is authored against.
   */
  version?: Version;
  /**
   * The text that should be displayed if the client is not able to render the card.
   */
  fallbackText?: string;
  /**
   * The text that should be spoken for the entire card.
   */
  speak?: string;
  /**
   * Defines how the card can be refreshed by making a request to the target Bot.
   */
  refresh?: IRefreshDefinition;
  /**
   * Defines authentication information to enable on-behalf-of single-sign-on or just-in-time OAuth. This information is used in conjunction with the refresh property and Action.Execute in general.
   */
  authentication?: IAuthentication;
  /**
   * Teams-specific metadata associated with the card.
   */
  msteams?: ITeamsCardProperties;
  /**
   * Metadata associated with the card.
   */
  metadata?: ICardMetadata;
  /**
   * Resources card elements can reference.
   */
  resources?: IResources;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The body of the card, comprised of a list of elements displayed according to the layouts property. If the layouts property is not specified, a Layout.Stack is used.
   */
  body: CardElementArray;
  /**
   * The card level actions, which always appear at the bottom of the card.
   */
  actions?: ActionArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IAdaptiveCard.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of AdaptiveCard, false otherwise.
 */
export function isAdaptiveCard(value: unknown): value is IAdaptiveCard {
  const obj = value as IAdaptiveCard;
  return typeof obj === 'object' && obj.type === 'AdaptiveCard';
}

export type AdaptiveCardOptions = Partial<Omit<IAdaptiveCard, 'type' | 'body'>>;

/**
 * An Adaptive Card, containing a free-form body of card elements, and an optional set of actions.
 */
export class AdaptiveCard implements IAdaptiveCard {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **AdaptiveCard**.
   */
  readonly type = 'AdaptiveCard';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * A URL to the Adaptive Card schema the card is authored against.
   */
  $schema?: string;
  /**
   * The Adaptive Card schema version the card is authored against.
   */
  version?: Version = '1.5';
  /**
   * The text that should be displayed if the client is not able to render the card.
   */
  fallbackText?: string;
  /**
   * The text that should be spoken for the entire card.
   */
  speak?: string;
  /**
   * Defines how the card can be refreshed by making a request to the target Bot.
   */
  refresh?: IRefreshDefinition;
  /**
   * Defines authentication information to enable on-behalf-of single-sign-on or just-in-time OAuth. This information is used in conjunction with the refresh property and Action.Execute in general.
   */
  authentication?: IAuthentication;
  /**
   * Teams-specific metadata associated with the card.
   */
  msteams?: ITeamsCardProperties;
  /**
   * Metadata associated with the card.
   */
  metadata?: ICardMetadata;
  /**
   * Resources card elements can reference.
   */
  resources?: IResources;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The body of the card, comprised of a list of elements displayed according to the layouts property. If the layouts property is not specified, a Layout.Stack is used.
   */
  body: CardElementArray;
  /**
   * The card level actions, which always appear at the bottom of the card.
   */
  actions?: ActionArray;

  constructor(...body: CardElementArray) {
    this.body = body;
  }

  withOptions(value: AdaptiveCardOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withLayouts(
    ...layouts: (IStackLayout | IFlowLayout | IAreaGridLayout)[]
  ): this {
    this.layouts = layouts;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withBackgroundImage(backgroundImage: string | IBackgroundImage): this {
    this.backgroundImage = backgroundImage;
    return this;
  }

  withVerticalContentAlignment(
    verticalContentAlignment: VerticalAlignment,
  ): this {
    this.verticalContentAlignment = verticalContentAlignment;
    return this;
  }

  withRtl(rtl: boolean): this {
    this.rtl = rtl;
    return this;
  }

  with$schema($schema: string): this {
    this.$schema = $schema;
    return this;
  }

  withVersion(version: Version): this {
    this.version = version;
    return this;
  }

  withFallbackText(fallbackText: string): this {
    this.fallbackText = fallbackText;
    return this;
  }

  withSpeak(speak: string): this {
    this.speak = speak;
    return this;
  }

  withRefresh(refresh: IRefreshDefinition): this {
    this.refresh = refresh;
    return this;
  }

  withAuthentication(authentication: IAuthentication): this {
    this.authentication = authentication;
    return this;
  }

  withMsteams(msteams: ITeamsCardProperties): this {
    this.msteams = msteams;
    return this;
  }

  withMetadata(metadata: ICardMetadata): this {
    this.metadata = metadata;
    return this;
  }

  withResources(resources: IResources): this {
    this.resources = resources;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withBody(...body: CardElementArray): this {
    this.body = body;
    return this;
  }

  withActions(...actions: ActionArray): this {
    this.actions = actions;
    return this;
  }
}

/**
 * Represents a list of versioned capabilities a host application must support.
 */
export interface IHostCapabilities extends Record<string, string> {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
}

export type HostCapabilitiesOptions = Partial<IHostCapabilities>;

/**
 * Represents a list of versioned capabilities a host application must support.
 */
export class HostCapabilities implements IHostCapabilities {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */

  constructor(options: HostCapabilitiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IHostCapabilities): HostCapabilities {
    return new HostCapabilities(options);
  }
  [key: string]: string;
}

/**
 * Gathers input values, merges them with the data property if specified, and sends them to the Bot via an Invoke activity. The Bot can respond synchronously and return an updated Adaptive Card to be displayed by the client. Action.Execute works in all Adaptive Card hosts.
 */
export interface IExecuteAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.Execute**.
   */
  readonly type: 'Action.Execute';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The data to send to the Bot when the action is executed. When expressed as an object, `data` is sent back to the Bot when the action is executed, adorned with the values of the inputs expressed as key/value pairs, where the key is the Id of the input. If `data` is expressed as a string, input values are not sent to the Bot.
   */
  data?: string | ISubmitActionData;
  /**
   * The Ids of the inputs associated with the Action.Submit. When the action is executed, the values of the associated inputs are sent to the Bot. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  associatedInputs?: AssociatedInputs;
  /**
   * Controls if the action is enabled only if at least one required input has been filled by the user.
   */
  conditionallyEnabled?: boolean;
  /**
   * The verb of the action.
   */
  verb?: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IExecuteAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ExecuteAction, false otherwise.
 */
export function isExecuteAction(value: unknown): value is IExecuteAction {
  const obj = value as IExecuteAction;
  return typeof obj === 'object' && obj.type === 'Action.Execute';
}

export type ExecuteActionOptions = Partial<Omit<IExecuteAction, 'type'>>;

/**
 * Gathers input values, merges them with the data property if specified, and sends them to the Bot via an Invoke activity. The Bot can respond synchronously and return an updated Adaptive Card to be displayed by the client. Action.Execute works in all Adaptive Card hosts.
 */
export class ExecuteAction implements IExecuteAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.Execute**.
   */
  readonly type = 'Action.Execute';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The data to send to the Bot when the action is executed. When expressed as an object, `data` is sent back to the Bot when the action is executed, adorned with the values of the inputs expressed as key/value pairs, where the key is the Id of the input. If `data` is expressed as a string, input values are not sent to the Bot.
   */
  data?: string | ISubmitActionData;
  /**
   * The Ids of the inputs associated with the Action.Submit. When the action is executed, the values of the associated inputs are sent to the Bot. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  associatedInputs?: AssociatedInputs;
  /**
   * Controls if the action is enabled only if at least one required input has been filled by the user.
   */
  conditionallyEnabled?: boolean = false;
  /**
   * The verb of the action.
   */
  verb?: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: ExecuteActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IExecuteAction, 'type'>): ExecuteAction {
    return new ExecuteAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withData(data: string | ISubmitActionData): this {
    this.data = data;
    return this;
  }

  withAssociatedInputs(associatedInputs: AssociatedInputs): this {
    this.associatedInputs = associatedInputs;
    return this;
  }

  withConditionallyEnabled(conditionallyEnabled = true): this {
    this.conditionallyEnabled = conditionallyEnabled;
    return this;
  }

  withVerb(verb: string): this {
    this.verb = verb;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Inserts an image into the host application's canvas.
 */
export interface IInsertImageAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.InsertImage**.
   */
  readonly type: 'Action.InsertImage';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The URL of the image to insert.
   */
  url?: string;
  /**
   * The alternate text for the image.
   */
  altText?: string;
  /**
   * The position at which to insert the image.
   */
  insertPosition?: ImageInsertPosition;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IInsertImageAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of InsertImageAction, false otherwise.
 */
export function isInsertImageAction(
  value: unknown,
): value is IInsertImageAction {
  const obj = value as IInsertImageAction;
  return typeof obj === 'object' && obj.type === 'Action.InsertImage';
}

export type InsertImageActionOptions = Partial<
  Omit<IInsertImageAction, 'type'>
>;

/**
 * Inserts an image into the host application's canvas.
 */
export class InsertImageAction implements IInsertImageAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.InsertImage**.
   */
  readonly type = 'Action.InsertImage';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The URL of the image to insert.
   */
  url?: string;
  /**
   * The alternate text for the image.
   */
  altText?: string;
  /**
   * The position at which to insert the image.
   */
  insertPosition?: ImageInsertPosition = 'Selection';
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: InsertImageActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IInsertImageAction, 'type'>): InsertImageAction {
    return new InsertImageAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withAltText(altText: string): this {
    this.altText = altText;
    return this;
  }

  withInsertPosition(insertPosition: ImageInsertPosition): this {
    this.insertPosition = insertPosition;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Opens the provided URL in either a separate browser tab or within the host application.
 */
export interface IOpenUrlAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.OpenUrl**.
   */
  readonly type: 'Action.OpenUrl';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The URL to open.
   */
  url: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IOpenUrlAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of OpenUrlAction, false otherwise.
 */
export function isOpenUrlAction(value: unknown): value is IOpenUrlAction {
  const obj = value as IOpenUrlAction;
  return typeof obj === 'object' && obj.type === 'Action.OpenUrl';
}

export type OpenUrlActionOptions = Partial<
  Omit<IOpenUrlAction, 'type' | 'url'>
>;

/**
 * Opens the provided URL in either a separate browser tab or within the host application.
 */
export class OpenUrlAction implements IOpenUrlAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.OpenUrl**.
   */
  readonly type = 'Action.OpenUrl';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The URL to open.
   */
  url: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(url: string, options: OpenUrlActionOptions = {}) {
    Object.assign(this, options);
    this.url = url;
  }

  static from(options: Omit<IOpenUrlAction, 'type'>): OpenUrlAction {
    return new OpenUrlAction(options.url, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Opens a task module in a modal dialog hosting the content at a provided URL.
 */
export interface IOpenUrlDialogAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.OpenUrlDialog**.
   */
  readonly type: 'Action.OpenUrlDialog';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The title of the dialog to be displayed in the dialog header.
   */
  dialogTitle?: string;
  /**
   * The height of the dialog. To define height as a number of pixels, use the <number>px format.
   */
  dialogHeight?: 'small' | 'medium' | 'large' | string;
  /**
   * The width of the dialog. To define width as a number of pixels, use the <number>px format.
   */
  dialogWidth?: 'small' | 'medium' | 'large' | string;
  /**
   * The URL to open.
   */
  url?: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IOpenUrlDialogAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of OpenUrlDialogAction, false otherwise.
 */
export function isOpenUrlDialogAction(
  value: unknown,
): value is IOpenUrlDialogAction {
  const obj = value as IOpenUrlDialogAction;
  return typeof obj === 'object' && obj.type === 'Action.OpenUrlDialog';
}

export type OpenUrlDialogActionOptions = Partial<
  Omit<IOpenUrlDialogAction, 'type'>
>;

/**
 * Opens a task module in a modal dialog hosting the content at a provided URL.
 */
export class OpenUrlDialogAction implements IOpenUrlDialogAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.OpenUrlDialog**.
   */
  readonly type = 'Action.OpenUrlDialog';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The title of the dialog to be displayed in the dialog header.
   */
  dialogTitle?: string;
  /**
   * The height of the dialog. To define height as a number of pixels, use the <number>px format.
   */
  dialogHeight?: 'small' | 'medium' | 'large' | string;
  /**
   * The width of the dialog. To define width as a number of pixels, use the <number>px format.
   */
  dialogWidth?: 'small' | 'medium' | 'large' | string;
  /**
   * The URL to open.
   */
  url?: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: OpenUrlDialogActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IOpenUrlDialogAction, 'type'>,
  ): OpenUrlDialogAction {
    return new OpenUrlDialogAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withDialogTitle(dialogTitle: string): this {
    this.dialogTitle = dialogTitle;
    return this;
  }

  withDialogHeight(dialogHeight: 'small' | 'medium' | 'large' | string): this {
    this.dialogHeight = dialogHeight;
    return this;
  }

  withDialogWidth(dialogWidth: 'small' | 'medium' | 'large' | string): this {
    this.dialogWidth = dialogWidth;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Resets the values of the inputs in the card.
 */
export interface IResetInputsAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.ResetInputs**.
   */
  readonly type: 'Action.ResetInputs';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The Ids of the inputs that should be reset.
   */
  targetInputIds?: string[];
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IResetInputsAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ResetInputsAction, false otherwise.
 */
export function isResetInputsAction(
  value: unknown,
): value is IResetInputsAction {
  const obj = value as IResetInputsAction;
  return typeof obj === 'object' && obj.type === 'Action.ResetInputs';
}

export type ResetInputsActionOptions = Partial<
  Omit<IResetInputsAction, 'type'>
>;

/**
 * Resets the values of the inputs in the card.
 */
export class ResetInputsAction implements IResetInputsAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.ResetInputs**.
   */
  readonly type = 'Action.ResetInputs';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The Ids of the inputs that should be reset.
   */
  targetInputIds?: string[];
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: ResetInputsActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IResetInputsAction, 'type'>): ResetInputsAction {
    return new ResetInputsAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withTargetInputIds(...targetInputIds: string[]): this {
    this.targetInputIds = targetInputIds;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Gathers input values, merges them with the data property if specified, and sends them to the Bot via an Invoke activity. The Bot can only acknowledge is has received the request.
 */
export interface ISubmitAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.Submit**.
   */
  readonly type: 'Action.Submit';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The data to send to the Bot when the action is executed. When expressed as an object, `data` is sent back to the Bot when the action is executed, adorned with the values of the inputs expressed as key/value pairs, where the key is the Id of the input. If `data` is expressed as a string, input values are not sent to the Bot.
   */
  data?: string | ISubmitActionData;
  /**
   * The Ids of the inputs associated with the Action.Submit. When the action is executed, the values of the associated inputs are sent to the Bot. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  associatedInputs?: AssociatedInputs;
  /**
   * Controls if the action is enabled only if at least one required input has been filled by the user.
   */
  conditionallyEnabled?: boolean;
  /**
   * Teams-specific metadata associated with the action.
   */
  msteams?: ITeamsSubmitActionProperties;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ISubmitAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of SubmitAction, false otherwise.
 */
export function isSubmitAction(value: unknown): value is ISubmitAction {
  const obj = value as ISubmitAction;
  return typeof obj === 'object' && obj.type === 'Action.Submit';
}

export type SubmitActionOptions = Partial<Omit<ISubmitAction, 'type'>>;

/**
 * Gathers input values, merges them with the data property if specified, and sends them to the Bot via an Invoke activity. The Bot can only acknowledge is has received the request.
 */
export class SubmitAction implements ISubmitAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.Submit**.
   */
  readonly type = 'Action.Submit';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The data to send to the Bot when the action is executed. When expressed as an object, `data` is sent back to the Bot when the action is executed, adorned with the values of the inputs expressed as key/value pairs, where the key is the Id of the input. If `data` is expressed as a string, input values are not sent to the Bot.
   */
  data?: string | ISubmitActionData;
  /**
   * The Ids of the inputs associated with the Action.Submit. When the action is executed, the values of the associated inputs are sent to the Bot. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  associatedInputs?: AssociatedInputs;
  /**
   * Controls if the action is enabled only if at least one required input has been filled by the user.
   */
  conditionallyEnabled?: boolean = false;
  /**
   * Teams-specific metadata associated with the action.
   */
  msteams?: ITeamsSubmitActionProperties;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: SubmitActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ISubmitAction, 'type'>): SubmitAction {
    return new SubmitAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withData(data: string | ISubmitActionData): this {
    this.data = data;
    return this;
  }

  withAssociatedInputs(associatedInputs: AssociatedInputs): this {
    this.associatedInputs = associatedInputs;
    return this;
  }

  withConditionallyEnabled(conditionallyEnabled = true): this {
    this.conditionallyEnabled = conditionallyEnabled;
    return this;
  }

  withMsteams(msteams: ITeamsSubmitActionProperties): this {
    this.msteams = msteams;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Toggles the visibility of a set of elements. Action.ToggleVisibility is useful for creating "Show more" type UI patterns.
 */
export interface IToggleVisibilityAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.ToggleVisibility**.
   */
  readonly type: 'Action.ToggleVisibility';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The Ids of the elements to toggle the visibility of.
   */
  targetElements?: (string | ITargetElement)[];
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IToggleVisibilityAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ToggleVisibilityAction, false otherwise.
 */
export function isToggleVisibilityAction(
  value: unknown,
): value is IToggleVisibilityAction {
  const obj = value as IToggleVisibilityAction;
  return typeof obj === 'object' && obj.type === 'Action.ToggleVisibility';
}

export type ToggleVisibilityActionOptions = Partial<
  Omit<IToggleVisibilityAction, 'type'>
>;

/**
 * Toggles the visibility of a set of elements. Action.ToggleVisibility is useful for creating "Show more" type UI patterns.
 */
export class ToggleVisibilityAction implements IToggleVisibilityAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.ToggleVisibility**.
   */
  readonly type = 'Action.ToggleVisibility';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The Ids of the elements to toggle the visibility of.
   */
  targetElements?: (string | ITargetElement)[];
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: ToggleVisibilityActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IToggleVisibilityAction, 'type'>,
  ): ToggleVisibilityAction {
    return new ToggleVisibilityAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withTargetElements(...targetElements: (string | ITargetElement)[]): this {
    this.targetElements = targetElements;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Defines a theme-specific URL.
 */
export interface IThemedUrl {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The theme this URL applies to.
   */
  theme?: ThemeName;
  /**
   * The URL to use for the associated theme.
   */
  url?: string;
}

export type ThemedUrlOptions = Partial<IThemedUrl>;

/**
 * Defines a theme-specific URL.
 */
export class ThemedUrl implements IThemedUrl {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The theme this URL applies to.
   */
  theme?: ThemeName = 'Light';
  /**
   * The URL to use for the associated theme.
   */
  url?: string;

  constructor(options: ThemedUrlOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IThemedUrl): ThemedUrl {
    return new ThemedUrl(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTheme(theme: ThemeName): this {
    this.theme = theme;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }
}

/**
 * Defines a target element in an Action.ToggleVisibility.
 */
export interface ITargetElement {
  /**
   * The Id of the element to change the visibility of.
   */
  elementId?: string;
  /**
   * The new visibility state of the element.
   */
  isVisible?: boolean;
}

export type TargetElementOptions = Partial<ITargetElement>;

/**
 * Defines a target element in an Action.ToggleVisibility.
 */
export class TargetElement implements ITargetElement {
  /**
   * The Id of the element to change the visibility of.
   */
  elementId?: string;
  /**
   * The new visibility state of the element.
   */
  isVisible?: boolean;

  constructor(options: TargetElementOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ITargetElement): TargetElement {
    return new TargetElement(options);
  }

  withElementId(elementId: string): this {
    this.elementId = elementId;
    return this;
  }

  withIsVisible(isVisible: boolean): this {
    this.isVisible = isVisible;
    return this;
  }
}

/**
 * Expands or collapses an embedded card within the main card.
 */
export interface IShowCardAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.ShowCard**.
   */
  readonly type: 'Action.ShowCard';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
  /**
   * The card that should be displayed when the action is executed.
   */
  card?: IAdaptiveCard;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IShowCardAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ShowCardAction, false otherwise.
 */
export function isShowCardAction(value: unknown): value is IShowCardAction {
  const obj = value as IShowCardAction;
  return typeof obj === 'object' && obj.type === 'Action.ShowCard';
}

export type ShowCardActionOptions = Partial<Omit<IShowCardAction, 'type'>>;

/**
 * Expands or collapses an embedded card within the main card.
 */
export class ShowCardAction implements IShowCardAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.ShowCard**.
   */
  readonly type = 'Action.ShowCard';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * The actions to display in the overflow menu of a Split action button.
   */
  menuActions?: MenuActionArray;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
  /**
   * The card that should be displayed when the action is executed.
   */
  card?: IAdaptiveCard;

  constructor(options: ShowCardActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IShowCardAction, 'type'>): ShowCardAction {
    return new ShowCardAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withMenuActions(...menuActions: MenuActionArray): this {
    this.menuActions = menuActions;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }

  withCard(card: IAdaptiveCard): this {
    this.card = card;
    return this;
  }
}

/**
 * Shows a popover to display more information to the user.
 */
export interface IPopoverAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.Popover**.
   */
  readonly type: 'Action.Popover';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle;
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode;
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The content of the popover, which can be any element.
   */
  content?:
    | IActionSet
    | IBadge
    | ICarousel
    | IDonutChart
    | IGaugeChart
    | IHorizontalBarChart
    | IStackedHorizontalBarChart
    | ILineChart
    | IPieChart
    | IVerticalBarChart
    | IGroupedVerticalBarChart
    | ICodeBlock
    | IColumnSet
    | IComEventMicrosoftGraphComponent
    | IComFileMicrosoftGraphComponent
    | IComResourceMicrosoftGraphComponent
    | IComUserMicrosoftGraphComponent
    | IComUsersMicrosoftGraphComponent
    | ICompoundButton
    | IContainer
    | IFactSet
    | IIcon
    | IIconRun
    | IImage
    | IImageRun
    | IImageSet
    | IChoiceSetInput
    | IDateInput
    | INumberInput
    | IRatingInput
    | ITextInput
    | ITimeInput
    | IToggleInput
    | IMedia
    | IProgressBar
    | IProgressRing
    | IRating
    | IRichTextBlock
    | ITable
    | ITextBlock
    | ITextRun;
  /**
   * Controls if an arrow should be displayed towards the element that triggered the popover.
   */
  displayArrow?: boolean;
  /**
   * Controls where the popover should be displayed with regards to the element that triggered it.
   */
  position?: PopoverPosition;
  /**
   * The maximum width of the popover in pixels, in the `<number>px` format
   */
  maxPopoverWidth?: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IPopoverAction.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of PopoverAction, false otherwise.
 */
export function isPopoverAction(value: unknown): value is IPopoverAction {
  const obj = value as IPopoverAction;
  return typeof obj === 'object' && obj.type === 'Action.Popover';
}

export type PopoverActionOptions = Partial<Omit<IPopoverAction, 'type'>>;

/**
 * Shows a popover to display more information to the user.
 */
export class PopoverAction implements IPopoverAction {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Action.Popover**.
   */
  readonly type = 'Action.Popover';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The title of the action, as it appears on buttons.
   */
  title?: string;
  /**
   * A URL (or Base64-encoded Data URI) to a PNG, GIF, JPEG or SVG image to be displayed on the left of the action's title.
   *
   * `iconUrl` also accepts the `<icon-name>[,regular|filled]` format to display an icon from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) instead of an image.
   */
  iconUrl?: string;
  /**
   * Control the style of the action, affecting its visual and spoken representations.
   */
  style?: ActionStyle = 'default';
  /**
   * Controls if the action is primary or secondary. Secondary actions appear in an overflow menu.
   */
  mode?: ActionMode = 'primary';
  /**
   * The tooltip text to display when the action is hovered over.
   */
  tooltip?: string;
  /**
   * Controls the enabled state of the action. A disabled action cannot be clicked. If the action is represented as a button, the button's style will reflect this state.
   */
  isEnabled?: boolean = true;
  /**
   * A set of theme-specific icon URLs.
   */
  themedIconUrls?: IThemedUrl[];
  /**
   * The content of the popover, which can be any element.
   */
  content?:
    | IActionSet
    | IBadge
    | ICarousel
    | IDonutChart
    | IGaugeChart
    | IHorizontalBarChart
    | IStackedHorizontalBarChart
    | ILineChart
    | IPieChart
    | IVerticalBarChart
    | IGroupedVerticalBarChart
    | ICodeBlock
    | IColumnSet
    | IComEventMicrosoftGraphComponent
    | IComFileMicrosoftGraphComponent
    | IComResourceMicrosoftGraphComponent
    | IComUserMicrosoftGraphComponent
    | IComUsersMicrosoftGraphComponent
    | ICompoundButton
    | IContainer
    | IFactSet
    | IIcon
    | IIconRun
    | IImage
    | IImageRun
    | IImageSet
    | IChoiceSetInput
    | IDateInput
    | INumberInput
    | IRatingInput
    | ITextInput
    | ITimeInput
    | IToggleInput
    | IMedia
    | IProgressBar
    | IProgressRing
    | IRating
    | IRichTextBlock
    | ITable
    | ITextBlock
    | ITextRun;
  /**
   * Controls if an arrow should be displayed towards the element that triggered the popover.
   */
  displayArrow?: boolean = true;
  /**
   * Controls where the popover should be displayed with regards to the element that triggered it.
   */
  position?: PopoverPosition = 'Above';
  /**
   * The maximum width of the popover in pixels, in the `<number>px` format
   */
  maxPopoverWidth?: string;
  /**
   * An alternate action to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackAction;

  constructor(options: PopoverActionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IPopoverAction, 'type'>): PopoverAction {
    return new PopoverAction(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withIconUrl(iconUrl: string): this {
    this.iconUrl = iconUrl;
    return this;
  }

  withStyle(style: ActionStyle): this {
    this.style = style;
    return this;
  }

  withMode(mode: ActionMode): this {
    this.mode = mode;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withIsEnabled(isEnabled = false): this {
    this.isEnabled = isEnabled;
    return this;
  }

  withThemedIconUrls(...themedIconUrls: IThemedUrl[]): this {
    this.themedIconUrls = themedIconUrls;
    return this;
  }

  withContent(
    content:
      | IActionSet
      | IBadge
      | ICarousel
      | IDonutChart
      | IGaugeChart
      | IHorizontalBarChart
      | IStackedHorizontalBarChart
      | ILineChart
      | IPieChart
      | IVerticalBarChart
      | IGroupedVerticalBarChart
      | ICodeBlock
      | IColumnSet
      | IComEventMicrosoftGraphComponent
      | IComFileMicrosoftGraphComponent
      | IComResourceMicrosoftGraphComponent
      | IComUserMicrosoftGraphComponent
      | IComUsersMicrosoftGraphComponent
      | ICompoundButton
      | IContainer
      | IFactSet
      | IIcon
      | IIconRun
      | IImage
      | IImageRun
      | IImageSet
      | IChoiceSetInput
      | IDateInput
      | INumberInput
      | IRatingInput
      | ITextInput
      | ITimeInput
      | IToggleInput
      | IMedia
      | IProgressBar
      | IProgressRing
      | IRating
      | IRichTextBlock
      | ITable
      | ITextBlock
      | ITextRun,
  ): this {
    this.content = content;
    return this;
  }

  withDisplayArrow(displayArrow = false): this {
    this.displayArrow = displayArrow;
    return this;
  }

  withPosition(position: PopoverPosition): this {
    this.position = position;
    return this;
  }

  withMaxPopoverWidth(maxPopoverWidth: string): this {
    this.maxPopoverWidth = maxPopoverWidth;
    return this;
  }

  withFallback(fallback: FallbackAction): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Displays a set of action, which can be placed anywhere in the card.
 */
export interface IActionSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ActionSet**.
   */
  readonly type: 'ActionSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The actions in the set.
   */
  actions: ActionArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IActionSet.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ActionSet, false otherwise.
 */
export function isActionSet(value: unknown): value is IActionSet {
  const obj = value as IActionSet;
  return typeof obj === 'object' && obj.type === 'ActionSet';
}

export type ActionSetOptions = Partial<Omit<IActionSet, 'type' | 'actions'>>;

/**
 * Displays a set of action, which can be placed anywhere in the card.
 */
export class ActionSet implements IActionSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ActionSet**.
   */
  readonly type = 'ActionSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The actions in the set.
   */
  actions: ActionArray;

  constructor(...actions: ActionArray) {
    this.actions = actions;
  }

  withOptions(value: ActionSetOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withActions(...actions: ActionArray): this {
    this.actions = actions;
    return this;
  }
}

/**
 * A container for other elements. Use containers for styling purposes and/or to logically group a set of elements together, which can be especially useful when used with Action.ToggleVisibility.
 */
export interface IContainer {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Container**.
   */
  readonly type: 'Container';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The elements in the container.
   */
  items: CardElementArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IContainer.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Container, false otherwise.
 */
export function isContainer(value: unknown): value is IContainer {
  const obj = value as IContainer;
  return typeof obj === 'object' && obj.type === 'Container';
}

export type ContainerOptions = Partial<Omit<IContainer, 'type' | 'items'>>;

/**
 * A container for other elements. Use containers for styling purposes and/or to logically group a set of elements together, which can be especially useful when used with Action.ToggleVisibility.
 */
export class Container implements IContainer {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Container**.
   */
  readonly type = 'Container';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean = false;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean = false;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean = false;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The elements in the container.
   */
  items: CardElementArray;

  constructor(...items: CardElementArray) {
    this.items = items;
  }

  withOptions(value: ContainerOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withShowBorder(showBorder = true): this {
    this.showBorder = showBorder;
    return this;
  }

  withRoundedCorners(roundedCorners = true): this {
    this.roundedCorners = roundedCorners;
    return this;
  }

  withLayouts(
    ...layouts: (IStackLayout | IFlowLayout | IAreaGridLayout)[]
  ): this {
    this.layouts = layouts;
    return this;
  }

  withBleed(bleed = true): this {
    this.bleed = bleed;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withBackgroundImage(backgroundImage: string | IBackgroundImage): this {
    this.backgroundImage = backgroundImage;
    return this;
  }

  withVerticalContentAlignment(
    verticalContentAlignment: VerticalAlignment,
  ): this {
    this.verticalContentAlignment = verticalContentAlignment;
    return this;
  }

  withRtl(rtl: boolean): this {
    this.rtl = rtl;
    return this;
  }

  withMaxHeight(maxHeight: string): this {
    this.maxHeight = maxHeight;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withItems(...items: CardElementArray): this {
    this.items = items;
    return this;
  }
}

/**
 * A layout that stacks elements on top of each other. Layout.Stack is the default layout used by AdaptiveCard and all containers.
 */
export interface IStackLayout {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Layout.Stack**.
   */
  readonly type: 'Layout.Stack';
  /**
   * Controls for which card width the layout should be used.
   */
  targetWidth?: TargetWidth;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IStackLayout.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of StackLayout, false otherwise.
 */
export function isStackLayout(value: unknown): value is IStackLayout {
  const obj = value as IStackLayout;
  return typeof obj === 'object' && obj.type === 'Layout.Stack';
}

export type StackLayoutOptions = Partial<Omit<IStackLayout, 'type'>>;

/**
 * A layout that stacks elements on top of each other. Layout.Stack is the default layout used by AdaptiveCard and all containers.
 */
export class StackLayout implements IStackLayout {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Layout.Stack**.
   */
  readonly type = 'Layout.Stack';
  /**
   * Controls for which card width the layout should be used.
   */
  targetWidth?: TargetWidth;

  constructor(options: StackLayoutOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IStackLayout, 'type'>): StackLayout {
    return new StackLayout(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }
}

/**
 * A layout that spreads elements horizontally and wraps them across multiple rows, as needed.
 */
export interface IFlowLayout {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Layout.Flow**.
   */
  readonly type: 'Layout.Flow';
  /**
   * Controls for which card width the layout should be used.
   */
  targetWidth?: TargetWidth;
  /**
   * Controls how the content of the container should be horizontally aligned.
   */
  horizontalItemsAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of the container should be vertically aligned.
   */
  verticalItemsAlignment?: VerticalAlignment;
  /**
   * Controls how item should fit inside the container.
   */
  itemFit?: FlowLayoutItemFit;
  /**
   * The minimum width, in pixels, of each item, in the `<number>px` format. Should not be used if itemWidth is set.
   */
  minItemWidth?: string;
  /**
   * The maximum width, in pixels, of each item, in the `<number>px` format. Should not be used if itemWidth is set.
   */
  maxItemWidth?: string;
  /**
   * The width, in pixels, of each item, in the `<number>px` format. Should not be used if maxItemWidth and/or minItemWidth are set.
   */
  itemWidth?: string;
  /**
   * The space between items.
   */
  columnSpacing?: Spacing;
  /**
   * The space between rows of items.
   */
  rowSpacing?: Spacing;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IFlowLayout.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of FlowLayout, false otherwise.
 */
export function isFlowLayout(value: unknown): value is IFlowLayout {
  const obj = value as IFlowLayout;
  return typeof obj === 'object' && obj.type === 'Layout.Flow';
}

export type FlowLayoutOptions = Partial<Omit<IFlowLayout, 'type'>>;

/**
 * A layout that spreads elements horizontally and wraps them across multiple rows, as needed.
 */
export class FlowLayout implements IFlowLayout {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Layout.Flow**.
   */
  readonly type = 'Layout.Flow';
  /**
   * Controls for which card width the layout should be used.
   */
  targetWidth?: TargetWidth;
  /**
   * Controls how the content of the container should be horizontally aligned.
   */
  horizontalItemsAlignment?: HorizontalAlignment = 'Center';
  /**
   * Controls how the content of the container should be vertically aligned.
   */
  verticalItemsAlignment?: VerticalAlignment = 'Top';
  /**
   * Controls how item should fit inside the container.
   */
  itemFit?: FlowLayoutItemFit = 'Fit';
  /**
   * The minimum width, in pixels, of each item, in the `<number>px` format. Should not be used if itemWidth is set.
   */
  minItemWidth?: string;
  /**
   * The maximum width, in pixels, of each item, in the `<number>px` format. Should not be used if itemWidth is set.
   */
  maxItemWidth?: string;
  /**
   * The width, in pixels, of each item, in the `<number>px` format. Should not be used if maxItemWidth and/or minItemWidth are set.
   */
  itemWidth?: string;
  /**
   * The space between items.
   */
  columnSpacing?: Spacing = 'Default';
  /**
   * The space between rows of items.
   */
  rowSpacing?: Spacing = 'Default';

  constructor(options: FlowLayoutOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IFlowLayout, 'type'>): FlowLayout {
    return new FlowLayout(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withHorizontalItemsAlignment(
    horizontalItemsAlignment: HorizontalAlignment,
  ): this {
    this.horizontalItemsAlignment = horizontalItemsAlignment;
    return this;
  }

  withVerticalItemsAlignment(verticalItemsAlignment: VerticalAlignment): this {
    this.verticalItemsAlignment = verticalItemsAlignment;
    return this;
  }

  withItemFit(itemFit: FlowLayoutItemFit): this {
    this.itemFit = itemFit;
    return this;
  }

  withMinItemWidth(minItemWidth: string): this {
    this.minItemWidth = minItemWidth;
    return this;
  }

  withMaxItemWidth(maxItemWidth: string): this {
    this.maxItemWidth = maxItemWidth;
    return this;
  }

  withItemWidth(itemWidth: string): this {
    this.itemWidth = itemWidth;
    return this;
  }

  withColumnSpacing(columnSpacing: Spacing): this {
    this.columnSpacing = columnSpacing;
    return this;
  }

  withRowSpacing(rowSpacing: Spacing): this {
    this.rowSpacing = rowSpacing;
    return this;
  }
}

/**
 * A layout that divides a container into named areas into which elements can be placed.
 */
export interface IAreaGridLayout {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Layout.AreaGrid**.
   */
  readonly type: 'Layout.AreaGrid';
  /**
   * Controls for which card width the layout should be used.
   */
  targetWidth?: TargetWidth;
  /**
   * The columns in the grid layout, defined as a percentage of the available width or in pixels using the `<number>px` format.
   */
  columns?: (number | string)[];
  /**
   * The areas in the grid layout.
   */
  areas?: IGridArea[];
  /**
   * The space between columns.
   */
  columnSpacing?: Spacing;
  /**
   * The space between rows.
   */
  rowSpacing?: Spacing;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IAreaGridLayout.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of AreaGridLayout, false otherwise.
 */
export function isAreaGridLayout(value: unknown): value is IAreaGridLayout {
  const obj = value as IAreaGridLayout;
  return typeof obj === 'object' && obj.type === 'Layout.AreaGrid';
}

export type AreaGridLayoutOptions = Partial<Omit<IAreaGridLayout, 'type'>>;

/**
 * A layout that divides a container into named areas into which elements can be placed.
 */
export class AreaGridLayout implements IAreaGridLayout {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Layout.AreaGrid**.
   */
  readonly type = 'Layout.AreaGrid';
  /**
   * Controls for which card width the layout should be used.
   */
  targetWidth?: TargetWidth;
  /**
   * The columns in the grid layout, defined as a percentage of the available width or in pixels using the `<number>px` format.
   */
  columns?: (number | string)[];
  /**
   * The areas in the grid layout.
   */
  areas?: IGridArea[];
  /**
   * The space between columns.
   */
  columnSpacing?: Spacing = 'Default';
  /**
   * The space between rows.
   */
  rowSpacing?: Spacing = 'Default';

  constructor(options: AreaGridLayoutOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IAreaGridLayout, 'type'>): AreaGridLayout {
    return new AreaGridLayout(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withColumns(...columns: (number | string)[]): this {
    this.columns = columns;
    return this;
  }

  withAreas(...areas: IGridArea[]): this {
    this.areas = areas;
    return this;
  }

  withColumnSpacing(columnSpacing: Spacing): this {
    this.columnSpacing = columnSpacing;
    return this;
  }

  withRowSpacing(rowSpacing: Spacing): this {
    this.rowSpacing = rowSpacing;
    return this;
  }
}

/**
 * Defines an area in a Layout.AreaGrid layout.
 */
export interface IGridArea {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the area. To place an element in this area, set its `grid.area` property to match the name of the area.
   */
  name?: string;
  /**
   * The start column index of the area. Column indices start at 1.
   */
  column?: number;
  /**
   * Defines how many columns the area should span.
   */
  columnSpan?: number;
  /**
   * The start row index of the area. Row indices start at 1.
   */
  row?: number;
  /**
   * Defines how many rows the area should span.
   */
  rowSpan?: number;
}

export type GridAreaOptions = Partial<IGridArea>;

/**
 * Defines an area in a Layout.AreaGrid layout.
 */
export class GridArea implements IGridArea {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the area. To place an element in this area, set its `grid.area` property to match the name of the area.
   */
  name?: string;
  /**
   * The start column index of the area. Column indices start at 1.
   */
  column?: number = 1;
  /**
   * Defines how many columns the area should span.
   */
  columnSpan?: number = 1;
  /**
   * The start row index of the area. Row indices start at 1.
   */
  row?: number = 1;
  /**
   * Defines how many rows the area should span.
   */
  rowSpan?: number = 1;

  constructor(options: GridAreaOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IGridArea): GridArea {
    return new GridArea(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withColumn(column: number): this {
    this.column = column;
    return this;
  }

  withColumnSpan(columnSpan: number): this {
    this.columnSpan = columnSpan;
    return this;
  }

  withRow(row: number): this {
    this.row = row;
    return this;
  }

  withRowSpan(rowSpan: number): this {
    this.rowSpan = rowSpan;
    return this;
  }
}

/**
 * Defines a container's background image and the way it should be rendered.
 */
export interface IBackgroundImage {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The URL (or Base64-encoded Data URI) of the image. Acceptable formats are PNG, JPEG, GIF and SVG.
   */
  url?: string;
  /**
   * Controls how the image should fill the area.
   */
  fillMode?: FillMode;
  /**
   * Controls how the image should be aligned if it must be cropped or if using repeat fill mode.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls how the image should be aligned if it must be cropped or if using repeat fill mode.
   */
  verticalAlignment?: VerticalAlignment;
  /**
   * A set of theme-specific image URLs.
   */
  themedUrls?: IThemedUrl[];
}

export type BackgroundImageOptions = Partial<IBackgroundImage>;

/**
 * Defines a container's background image and the way it should be rendered.
 */
export class BackgroundImage implements IBackgroundImage {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The URL (or Base64-encoded Data URI) of the image. Acceptable formats are PNG, JPEG, GIF and SVG.
   */
  url?: string;
  /**
   * Controls how the image should fill the area.
   */
  fillMode?: FillMode = 'Cover';
  /**
   * Controls how the image should be aligned if it must be cropped or if using repeat fill mode.
   */
  horizontalAlignment?: HorizontalAlignment = 'Left';
  /**
   * Controls how the image should be aligned if it must be cropped or if using repeat fill mode.
   */
  verticalAlignment?: VerticalAlignment = 'Top';
  /**
   * A set of theme-specific image URLs.
   */
  themedUrls?: IThemedUrl[];

  constructor(options: BackgroundImageOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IBackgroundImage): BackgroundImage {
    return new BackgroundImage(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withFillMode(fillMode: FillMode): this {
    this.fillMode = fillMode;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withVerticalAlignment(verticalAlignment: VerticalAlignment): this {
    this.verticalAlignment = verticalAlignment;
    return this;
  }

  withThemedUrls(...themedUrls: IThemedUrl[]): this {
    this.themedUrls = themedUrls;
    return this;
  }
}

/**
 * Splits the available horizontal space into separate columns, so elements can be organized in a row.
 */
export interface IColumnSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ColumnSet**.
   */
  readonly type: 'ColumnSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean;
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * The minimum width of the column set. `auto` will automatically adjust the column set's minimum width according to its content and using the `<number>px` format will give the column set an explicit minimum width in pixels. A scrollbar will be displayed if the available width is less than the specified minimum width.
   */
  minWidth?: 'auto' | string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The columns in the set.
   */
  columns?: ColumnArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IColumnSet.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ColumnSet, false otherwise.
 */
export function isColumnSet(value: unknown): value is IColumnSet {
  const obj = value as IColumnSet;
  return typeof obj === 'object' && obj.type === 'ColumnSet';
}

export type ColumnSetOptions = Partial<Omit<IColumnSet, 'type'>>;

/**
 * Splits the available horizontal space into separate columns, so elements can be organized in a row.
 */
export class ColumnSet implements IColumnSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ColumnSet**.
   */
  readonly type = 'ColumnSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean = false;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean = false;
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean = false;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * The minimum width of the column set. `auto` will automatically adjust the column set's minimum width according to its content and using the `<number>px` format will give the column set an explicit minimum width in pixels. A scrollbar will be displayed if the available width is less than the specified minimum width.
   */
  minWidth?: 'auto' | string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The columns in the set.
   */
  columns?: ColumnArray;

  constructor(options: ColumnSetOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IColumnSet, 'type'>): ColumnSet {
    return new ColumnSet(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withShowBorder(showBorder = true): this {
    this.showBorder = showBorder;
    return this;
  }

  withRoundedCorners(roundedCorners = true): this {
    this.roundedCorners = roundedCorners;
    return this;
  }

  withBleed(bleed = true): this {
    this.bleed = bleed;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withMinWidth(minWidth: 'auto' | string): this {
    this.minWidth = minWidth;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withColumns(...columns: ColumnArray): this {
    this.columns = columns;
    return this;
  }
}

/**
 * A media element, that makes it possible to embed videos inside a card.
 */
export interface IMedia {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Media**.
   */
  readonly type: 'Media';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The sources for the media. For YouTube, Dailymotion and Vimeo, only one source can be specified.
   */
  sources?: IMediaSource[];
  /**
   * The caption sources for the media. Caption sources are not used for YouTube, Dailymotion or Vimeo sources.
   */
  captionSources?: ICaptionSource[];
  /**
   * The URL of the poster image to display.
   */
  poster?: string;
  /**
   * The alternate text for the media, used for accessibility purposes.
   */
  altText?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IMedia.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Media, false otherwise.
 */
export function isMedia(value: unknown): value is IMedia {
  const obj = value as IMedia;
  return typeof obj === 'object' && obj.type === 'Media';
}

export type MediaOptions = Partial<Omit<IMedia, 'type'>>;

/**
 * A media element, that makes it possible to embed videos inside a card.
 */
export class Media implements IMedia {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Media**.
   */
  readonly type = 'Media';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The sources for the media. For YouTube, Dailymotion and Vimeo, only one source can be specified.
   */
  sources?: IMediaSource[];
  /**
   * The caption sources for the media. Caption sources are not used for YouTube, Dailymotion or Vimeo sources.
   */
  captionSources?: ICaptionSource[];
  /**
   * The URL of the poster image to display.
   */
  poster?: string;
  /**
   * The alternate text for the media, used for accessibility purposes.
   */
  altText?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: MediaOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IMedia, 'type'>): Media {
    return new Media(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSources(...sources: IMediaSource[]): this {
    this.sources = sources;
    return this;
  }

  withCaptionSources(...captionSources: ICaptionSource[]): this {
    this.captionSources = captionSources;
    return this;
  }

  withPoster(poster: string): this {
    this.poster = poster;
    return this;
  }

  withAltText(altText: string): this {
    this.altText = altText;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Defines the source URL of a media stream. YouTube, Dailymotion, Vimeo and Microsoft Stream URLs are supported.
 */
export interface IMediaSource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The MIME type of the source.
   */
  mimeType?: string;
  /**
   * The URL of the source.
   */
  url?: string;
}

export type MediaSourceOptions = Partial<IMediaSource>;

/**
 * Defines the source URL of a media stream. YouTube, Dailymotion, Vimeo and Microsoft Stream URLs are supported.
 */
export class MediaSource implements IMediaSource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The MIME type of the source.
   */
  mimeType?: string;
  /**
   * The URL of the source.
   */
  url?: string;

  constructor(options: MediaSourceOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IMediaSource): MediaSource {
    return new MediaSource(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withMimeType(mimeType: string): this {
    this.mimeType = mimeType;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }
}

/**
 * Defines a source URL for a video captions.
 */
export interface ICaptionSource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The MIME type of the source.
   */
  mimeType?: string;
  /**
   * The URL of the source.
   */
  url?: string;
  /**
   * The label of this caption source.
   */
  label?: string;
}

export type CaptionSourceOptions = Partial<ICaptionSource>;

/**
 * Defines a source URL for a video captions.
 */
export class CaptionSource implements ICaptionSource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The MIME type of the source.
   */
  mimeType?: string;
  /**
   * The URL of the source.
   */
  url?: string;
  /**
   * The label of this caption source.
   */
  label?: string;

  constructor(options: CaptionSourceOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ICaptionSource): CaptionSource {
    return new CaptionSource(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withMimeType(mimeType: string): this {
    this.mimeType = mimeType;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }
}

/**
 * A rich text block that displays formatted text.
 */
export interface IRichTextBlock {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **RichTextBlock**.
   */
  readonly type: 'RichTextBlock';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The Id of the input the RichTextBlock should act as the label of.
   */
  labelFor?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The inlines making up the rich text block.
   */
  inlines?: RichTextBlockInlineArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IRichTextBlock.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of RichTextBlock, false otherwise.
 */
export function isRichTextBlock(value: unknown): value is IRichTextBlock {
  const obj = value as IRichTextBlock;
  return typeof obj === 'object' && obj.type === 'RichTextBlock';
}

export type RichTextBlockOptions = Partial<Omit<IRichTextBlock, 'type'>>;

/**
 * A rich text block that displays formatted text.
 */
export class RichTextBlock implements IRichTextBlock {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **RichTextBlock**.
   */
  readonly type = 'RichTextBlock';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The Id of the input the RichTextBlock should act as the label of.
   */
  labelFor?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The inlines making up the rich text block.
   */
  inlines?: RichTextBlockInlineArray;

  constructor(options: RichTextBlockOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IRichTextBlock, 'type'>): RichTextBlock {
    return new RichTextBlock(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabelFor(labelFor: string): this {
    this.labelFor = labelFor;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withInlines(...inlines: RichTextBlockInlineArray): this {
    this.inlines = inlines;
    return this;
  }
}

/**
 * Use tables to display data in a tabular way, with rows, columns and cells.
 */
export interface ITable {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Table**.
   */
  readonly type: 'Table';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean;
  /**
   * The columns in the table.
   */
  columns?: IColumnDefinition[];
  /**
   * The minimum width of the table in pixels. `auto` will automatically adjust the table's minimum width according to its content and using the `<number>px` format will give the table an explicit minimum width in pixels. A scrollbar will be displayed if the available width is less than the specified minimum width.
   */
  minWidth?: 'auto' | string;
  /**
   * Controls whether the first row of the table should be treated as a header.
   */
  firstRowAsHeaders?: boolean;
  /**
   * Controls if grid lines should be displayed.
   */
  showGridLines?: boolean;
  /**
   * The style of the grid lines between cells.
   */
  gridStyle?: ContainerStyle;
  /**
   * Controls how the content of every cell in the table should be horizontally aligned by default.
   */
  horizontalCellContentAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of every cell in the table should be vertically aligned by default.
   */
  verticalCellContentAlignment?: VerticalAlignment;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The rows of the table.
   */
  rows?: TableRowArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITable.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Table, false otherwise.
 */
export function isTable(value: unknown): value is ITable {
  const obj = value as ITable;
  return typeof obj === 'object' && obj.type === 'Table';
}

export type TableOptions = Partial<Omit<ITable, 'type'>>;

/**
 * Use tables to display data in a tabular way, with rows, columns and cells.
 */
export class Table implements ITable {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Table**.
   */
  readonly type = 'Table';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean = false;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean = false;
  /**
   * The columns in the table.
   */
  columns?: IColumnDefinition[];
  /**
   * The minimum width of the table in pixels. `auto` will automatically adjust the table's minimum width according to its content and using the `<number>px` format will give the table an explicit minimum width in pixels. A scrollbar will be displayed if the available width is less than the specified minimum width.
   */
  minWidth?: 'auto' | string;
  /**
   * Controls whether the first row of the table should be treated as a header.
   */
  firstRowAsHeaders?: boolean = true;
  /**
   * Controls if grid lines should be displayed.
   */
  showGridLines?: boolean = true;
  /**
   * The style of the grid lines between cells.
   */
  gridStyle?: ContainerStyle;
  /**
   * Controls how the content of every cell in the table should be horizontally aligned by default.
   */
  horizontalCellContentAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of every cell in the table should be vertically aligned by default.
   */
  verticalCellContentAlignment?: VerticalAlignment;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The rows of the table.
   */
  rows?: TableRowArray;

  constructor(options: TableOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ITable, 'type'>): Table {
    return new Table(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withShowBorder(showBorder = true): this {
    this.showBorder = showBorder;
    return this;
  }

  withRoundedCorners(roundedCorners = true): this {
    this.roundedCorners = roundedCorners;
    return this;
  }

  withColumns(...columns: IColumnDefinition[]): this {
    this.columns = columns;
    return this;
  }

  withMinWidth(minWidth: 'auto' | string): this {
    this.minWidth = minWidth;
    return this;
  }

  withFirstRowAsHeaders(firstRowAsHeaders = false): this {
    this.firstRowAsHeaders = firstRowAsHeaders;
    return this;
  }

  withShowGridLines(showGridLines = false): this {
    this.showGridLines = showGridLines;
    return this;
  }

  withGridStyle(gridStyle: ContainerStyle): this {
    this.gridStyle = gridStyle;
    return this;
  }

  withHorizontalCellContentAlignment(
    horizontalCellContentAlignment: HorizontalAlignment,
  ): this {
    this.horizontalCellContentAlignment = horizontalCellContentAlignment;
    return this;
  }

  withVerticalCellContentAlignment(
    verticalCellContentAlignment: VerticalAlignment,
  ): this {
    this.verticalCellContentAlignment = verticalCellContentAlignment;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withRows(...rows: TableRowArray): this {
    this.rows = rows;
    return this;
  }
}

/**
 * Defines a column in a Table element.
 */
export interface IColumnDefinition {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Controls how the content of every cell in the table should be horizontally aligned by default. This property overrides the horizontalCellContentAlignment property of the table.
   */
  horizontalCellContentAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of every cell in the column should be vertically aligned by default. This property overrides the verticalCellContentAlignment property of the table.
   */
  verticalCellContentAlignment?: VerticalAlignment;
  /**
   * The width of the column in the table. If expressed as a number, represents the relative weight of the column in the table. If expressed as a string, `auto` will automatically adjust the column's width according to its content and using the `<number>px` format will give the column an explicit width in pixels.
   */
  width?: 'auto' | string | number;
}

export type ColumnDefinitionOptions = Partial<IColumnDefinition>;

/**
 * Defines a column in a Table element.
 */
export class ColumnDefinition implements IColumnDefinition {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Controls how the content of every cell in the table should be horizontally aligned by default. This property overrides the horizontalCellContentAlignment property of the table.
   */
  horizontalCellContentAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of every cell in the column should be vertically aligned by default. This property overrides the verticalCellContentAlignment property of the table.
   */
  verticalCellContentAlignment?: VerticalAlignment;
  /**
   * The width of the column in the table. If expressed as a number, represents the relative weight of the column in the table. If expressed as a string, `auto` will automatically adjust the column's width according to its content and using the `<number>px` format will give the column an explicit width in pixels.
   */
  width?: 'auto' | string | number;

  constructor(options: ColumnDefinitionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IColumnDefinition): ColumnDefinition {
    return new ColumnDefinition(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withHorizontalCellContentAlignment(
    horizontalCellContentAlignment: HorizontalAlignment,
  ): this {
    this.horizontalCellContentAlignment = horizontalCellContentAlignment;
    return this;
  }

  withVerticalCellContentAlignment(
    verticalCellContentAlignment: VerticalAlignment,
  ): this {
    this.verticalCellContentAlignment = verticalCellContentAlignment;
    return this;
  }

  withWidth(width: 'auto' | string | number): this {
    this.width = width;
    return this;
  }
}

/**
 * A block of text, optionally formatted using Markdown.
 */
export interface ITextBlock {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TextBlock**.
   */
  readonly type: 'TextBlock';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The text to display. A subset of markdown is supported.
   */
  text: string;
  /**
   * The size of the text.
   */
  size?: TextSize;
  /**
   * The weight of the text.
   */
  weight?: TextWeight;
  /**
   * The color of the text.
   */
  color?: TextColor;
  /**
   * Controls whether the text should be renderer using a subtler variant of the select color.
   */
  isSubtle?: boolean;
  /**
   * The type of font to use for rendering.
   */
  fontType?: FontType;
  /**
   * Controls if the text should wrap.
   */
  wrap?: boolean;
  /**
   * The maximum number of lines to display.
   */
  maxLines?: number;
  /**
   * The style of the text.
   */
  style?: TextBlockStyle;
  /**
   * The Id of the input the TextBlock should act as the label of.
   */
  labelFor?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITextBlock.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TextBlock, false otherwise.
 */
export function isTextBlock(value: unknown): value is ITextBlock {
  const obj = value as ITextBlock;
  return typeof obj === 'object' && obj.type === 'TextBlock';
}

export type TextBlockOptions = Partial<Omit<ITextBlock, 'type' | 'text'>>;

/**
 * A block of text, optionally formatted using Markdown.
 */
export class TextBlock implements ITextBlock {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TextBlock**.
   */
  readonly type = 'TextBlock';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The text to display. A subset of markdown is supported.
   */
  text: string;
  /**
   * The size of the text.
   */
  size?: TextSize;
  /**
   * The weight of the text.
   */
  weight?: TextWeight;
  /**
   * The color of the text.
   */
  color?: TextColor;
  /**
   * Controls whether the text should be renderer using a subtler variant of the select color.
   */
  isSubtle?: boolean;
  /**
   * The type of font to use for rendering.
   */
  fontType?: FontType;
  /**
   * Controls if the text should wrap.
   */
  wrap?: boolean = false;
  /**
   * The maximum number of lines to display.
   */
  maxLines?: number;
  /**
   * The style of the text.
   */
  style?: TextBlockStyle;
  /**
   * The Id of the input the TextBlock should act as the label of.
   */
  labelFor?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(text: string, options: TextBlockOptions = {}) {
    Object.assign(this, options);
    this.text = text;
  }

  static from(options: Omit<ITextBlock, 'type'>): TextBlock {
    return new TextBlock(options.text, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withText(text: string): this {
    this.text = text;
    return this;
  }

  withSize(size: TextSize): this {
    this.size = size;
    return this;
  }

  withWeight(weight: TextWeight): this {
    this.weight = weight;
    return this;
  }

  withColor(color: TextColor): this {
    this.color = color;
    return this;
  }

  withIsSubtle(isSubtle: boolean): this {
    this.isSubtle = isSubtle;
    return this;
  }

  withFontType(fontType: FontType): this {
    this.fontType = fontType;
    return this;
  }

  withWrap(wrap = true): this {
    this.wrap = wrap;
    return this;
  }

  withMaxLines(maxLines: number): this {
    this.maxLines = maxLines;
    return this;
  }

  withStyle(style: TextBlockStyle): this {
    this.style = style;
    return this;
  }

  withLabelFor(labelFor: string): this {
    this.labelFor = labelFor;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A set of facts, displayed as a table or a vertical list when horizontal space is constrained.
 */
export interface IFactSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **FactSet**.
   */
  readonly type: 'FactSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The facts in the set.
   */
  facts: IFact[];
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IFactSet.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of FactSet, false otherwise.
 */
export function isFactSet(value: unknown): value is IFactSet {
  const obj = value as IFactSet;
  return typeof obj === 'object' && obj.type === 'FactSet';
}

export type FactSetOptions = Partial<Omit<IFactSet, 'type' | 'facts'>>;

/**
 * A set of facts, displayed as a table or a vertical list when horizontal space is constrained.
 */
export class FactSet implements IFactSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **FactSet**.
   */
  readonly type = 'FactSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The facts in the set.
   */
  facts: IFact[];
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(...facts: IFact[]) {
    this.facts = facts;
  }

  withOptions(value: FactSetOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withFacts(...facts: IFact[]): this {
    this.facts = facts;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A fact in a FactSet element.
 */
export interface IFact {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The fact's title.
   */
  title: string;
  /**
   * The fact's value.
   */
  value: string;
}

export type FactOptions = Partial<IFact>;

/**
 * A fact in a FactSet element.
 */
export class Fact implements IFact {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The fact's title.
   */
  title: string;
  /**
   * The fact's value.
   */
  value: string;

  constructor(title: string, value: string, options: FactOptions = {}) {
    Object.assign(this, options);
    this.title = title;
    this.value = value;
  }

  static from(options: IFact): Fact {
    return new Fact(options.title, options.value, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }
}

/**
 * A set of images, displayed side-by-side and wrapped across multiple rows as needed.
 */
export interface IImageSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ImageSet**.
   */
  readonly type: 'ImageSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The images in the set.
   */
  images: IImage[];
  /**
   * The size to use to render all images in the set.
   */
  imageSize?: ImageSize;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IImageSet.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ImageSet, false otherwise.
 */
export function isImageSet(value: unknown): value is IImageSet {
  const obj = value as IImageSet;
  return typeof obj === 'object' && obj.type === 'ImageSet';
}

export type ImageSetOptions = Partial<Omit<IImageSet, 'type' | 'images'>>;

/**
 * A set of images, displayed side-by-side and wrapped across multiple rows as needed.
 */
export class ImageSet implements IImageSet {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ImageSet**.
   */
  readonly type = 'ImageSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The images in the set.
   */
  images: IImage[];
  /**
   * The size to use to render all images in the set.
   */
  imageSize?: ImageSize = 'Medium';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(...images: IImage[]) {
    this.images = images;
  }

  withOptions(value: ImageSetOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withImages(...images: IImage[]): this {
    this.images = images;
    return this;
  }

  withImageSize(imageSize: ImageSize): this {
    this.imageSize = imageSize;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A standalone image element.
 */
export interface IImage {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Image**.
   */
  readonly type: 'Image';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The URL (or Base64-encoded Data URI) of the image. Acceptable formats are PNG, JPEG, GIF and SVG.
   */
  url: string;
  /**
   * The alternate text for the image, used for accessibility purposes.
   */
  altText?: string;
  /**
   * The background color of the image.
   */
  backgroundColor?: string;
  /**
   * The style of the image.
   */
  style?: ImageStyle;
  /**
   * The size of the image.
   */
  size?: Size;
  /**
   * The width of the image.
   */
  width?: 'auto' | 'stretch' | string;
  /**
   * An Action that will be invoked when the image is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * Controls if the image can be expanded to full screen.
   */
  allowExpand?: boolean;
  /**
   * Teams-specific metadata associated with the image.
   */
  msteams?: ITeamsImageProperties;
  /**
   * A set of theme-specific image URLs.
   */
  themedUrls?: IThemedUrl[];
  /**
   * Controls how the image should be fitted inside its bounding box. imageFit is only meaningful when both the width and height properties are set. When fitMode is set to contain, the default style is always used.
   */
  fitMode?: ImageFitMode;
  /**
   * Controls the horizontal position of the image within its bounding box. horizontalContentAlignment is only meaningful when both the width and height properties are set and fitMode is set to either cover or contain.
   */
  horizontalContentAlignment?: HorizontalAlignment;
  /**
   * Controls the vertical position of the image within its bounding box. verticalContentAlignment is only meaningful when both the width and height properties are set and fitMode is set to either cover or contain.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * The height of the image.
   */
  height?: 'auto' | 'stretch' | string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IImage.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Image, false otherwise.
 */
export function isImage(value: unknown): value is IImage {
  const obj = value as IImage;
  return typeof obj === 'object' && obj.type === 'Image';
}

export type ImageOptions = Partial<Omit<IImage, 'type' | 'url'>>;

/**
 * A standalone image element.
 */
export class Image implements IImage {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Image**.
   */
  readonly type = 'Image';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The URL (or Base64-encoded Data URI) of the image. Acceptable formats are PNG, JPEG, GIF and SVG.
   */
  url: string;
  /**
   * The alternate text for the image, used for accessibility purposes.
   */
  altText?: string;
  /**
   * The background color of the image.
   */
  backgroundColor?: string;
  /**
   * The style of the image.
   */
  style?: ImageStyle = 'Default';
  /**
   * The size of the image.
   */
  size?: Size = 'Auto';
  /**
   * The width of the image.
   */
  width?: 'auto' | 'stretch' | string = 'auto';
  /**
   * An Action that will be invoked when the image is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * Controls if the image can be expanded to full screen.
   */
  allowExpand?: boolean = false;
  /**
   * Teams-specific metadata associated with the image.
   */
  msteams?: ITeamsImageProperties;
  /**
   * A set of theme-specific image URLs.
   */
  themedUrls?: IThemedUrl[];
  /**
   * Controls how the image should be fitted inside its bounding box. imageFit is only meaningful when both the width and height properties are set. When fitMode is set to contain, the default style is always used.
   */
  fitMode?: ImageFitMode = 'Fill';
  /**
   * Controls the horizontal position of the image within its bounding box. horizontalContentAlignment is only meaningful when both the width and height properties are set and fitMode is set to either cover or contain.
   */
  horizontalContentAlignment?: HorizontalAlignment = 'Left';
  /**
   * Controls the vertical position of the image within its bounding box. verticalContentAlignment is only meaningful when both the width and height properties are set and fitMode is set to either cover or contain.
   */
  verticalContentAlignment?: VerticalAlignment = 'Top';
  /**
   * The height of the image.
   */
  height?: 'auto' | 'stretch' | string = 'auto';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(url: string, options: ImageOptions = {}) {
    Object.assign(this, options);
    this.url = url;
  }

  static from(options: Omit<IImage, 'type'>): Image {
    return new Image(options.url, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withAltText(altText: string): this {
    this.altText = altText;
    return this;
  }

  withBackgroundColor(backgroundColor: string): this {
    this.backgroundColor = backgroundColor;
    return this;
  }

  withStyle(style: ImageStyle): this {
    this.style = style;
    return this;
  }

  withSize(size: Size): this {
    this.size = size;
    return this;
  }

  withWidth(width: 'auto' | 'stretch' | string): this {
    this.width = width;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withAllowExpand(allowExpand = true): this {
    this.allowExpand = allowExpand;
    return this;
  }

  withMsteams(msteams: ITeamsImageProperties): this {
    this.msteams = msteams;
    return this;
  }

  withThemedUrls(...themedUrls: IThemedUrl[]): this {
    this.themedUrls = themedUrls;
    return this;
  }

  withFitMode(fitMode: ImageFitMode): this {
    this.fitMode = fitMode;
    return this;
  }

  withHorizontalContentAlignment(
    horizontalContentAlignment: HorizontalAlignment,
  ): this {
    this.horizontalContentAlignment = horizontalContentAlignment;
    return this;
  }

  withVerticalContentAlignment(
    verticalContentAlignment: VerticalAlignment,
  ): this {
    this.verticalContentAlignment = verticalContentAlignment;
    return this;
  }

  withHeight(height: 'auto' | 'stretch' | string): this {
    this.height = height;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents a set of Teams-specific properties on an image.
 */
export interface ITeamsImageProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Controls if the image is expandable in Teams. This property is equivalent to the Image.allowExpand property.
   */
  allowExpand?: boolean;
}

export type TeamsImagePropertiesOptions = Partial<ITeamsImageProperties>;

/**
 * Represents a set of Teams-specific properties on an image.
 */
export class TeamsImageProperties implements ITeamsImageProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Controls if the image is expandable in Teams. This property is equivalent to the Image.allowExpand property.
   */
  allowExpand?: boolean;

  constructor(options: TeamsImagePropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ITeamsImageProperties): TeamsImageProperties {
    return new TeamsImageProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withAllowExpand(allowExpand: boolean): this {
    this.allowExpand = allowExpand;
    return this;
  }
}

/**
 * An input to allow the user to enter text.
 */
export interface ITextInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Text**.
   */
  readonly type: 'Input.Text';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: string;
  /**
   * The maximum length of the text in the input.
   */
  maxLength?: number;
  /**
   * Controls if the input should allow multiple lines of text.
   */
  isMultiline?: boolean;
  /**
   * The text to display as a placeholder when the user hasn't entered a value.
   */
  placeholder?: string;
  /**
   * The style of the input.
   */
  style?: InputTextStyle;
  /**
   * The action that should be displayed as a button alongside the input. Action.ShowCard is not supported.
   */
  inlineAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The regular expression to validate the input.
   */
  regex?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITextInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TextInput, false otherwise.
 */
export function isTextInput(value: unknown): value is ITextInput {
  const obj = value as ITextInput;
  return typeof obj === 'object' && obj.type === 'Input.Text';
}

export type TextInputOptions = Partial<Omit<ITextInput, 'type'>>;

/**
 * An input to allow the user to enter text.
 */
export class TextInput implements ITextInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Text**.
   */
  readonly type = 'Input.Text';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: string;
  /**
   * The maximum length of the text in the input.
   */
  maxLength?: number;
  /**
   * Controls if the input should allow multiple lines of text.
   */
  isMultiline?: boolean = false;
  /**
   * The text to display as a placeholder when the user hasn't entered a value.
   */
  placeholder?: string;
  /**
   * The style of the input.
   */
  style?: InputTextStyle = 'Text';
  /**
   * The action that should be displayed as a button alongside the input. Action.ShowCard is not supported.
   */
  inlineAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The regular expression to validate the input.
   */
  regex?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: TextInputOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ITextInput, 'type'>): TextInput {
    return new TextInput(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withMaxLength(maxLength: number): this {
    this.maxLength = maxLength;
    return this;
  }

  withIsMultiline(isMultiline = true): this {
    this.isMultiline = isMultiline;
    return this;
  }

  withPlaceholder(placeholder: string): this {
    this.placeholder = placeholder;
    return this;
  }

  withStyle(style: InputTextStyle): this {
    this.style = style;
    return this;
  }

  withInlineAction(
    inlineAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.inlineAction = inlineAction;
    return this;
  }

  withRegex(regex: string): this {
    this.regex = regex;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An input to allow the user to select a date.
 */
export interface IDateInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Date**.
   */
  readonly type: 'Input.Date';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input, in the `YYYY-MM-DD` format.
   */
  value?: string;
  /**
   * The text to display as a placeholder when the user has not selected a date.
   */
  placeholder?: string;
  /**
   * The minimum date that can be selected.
   */
  min?: string;
  /**
   * The maximum date that can be selected.
   */
  max?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IDateInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of DateInput, false otherwise.
 */
export function isDateInput(value: unknown): value is IDateInput {
  const obj = value as IDateInput;
  return typeof obj === 'object' && obj.type === 'Input.Date';
}

export type DateInputOptions = Partial<Omit<IDateInput, 'type'>>;

/**
 * An input to allow the user to select a date.
 */
export class DateInput implements IDateInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Date**.
   */
  readonly type = 'Input.Date';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input, in the `YYYY-MM-DD` format.
   */
  value?: string;
  /**
   * The text to display as a placeholder when the user has not selected a date.
   */
  placeholder?: string;
  /**
   * The minimum date that can be selected.
   */
  min?: string;
  /**
   * The maximum date that can be selected.
   */
  max?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: DateInputOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IDateInput, 'type'>): DateInput {
    return new DateInput(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withPlaceholder(placeholder: string): this {
    this.placeholder = placeholder;
    return this;
  }

  withMin(min: string): this {
    this.min = min;
    return this;
  }

  withMax(max: string): this {
    this.max = max;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An input to allow the user to select a time.
 */
export interface ITimeInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Time**.
   */
  readonly type: 'Input.Time';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input, in the `HH:MM` format.
   */
  value?: string;
  /**
   * The text to display as a placeholder when the user hasn't entered a value.
   */
  placeholder?: string;
  /**
   * The minimum time that can be selected, in the `HH:MM` format.
   */
  min?: string;
  /**
   * The maximum time that can be selected, in the `HH:MM` format.
   */
  max?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITimeInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TimeInput, false otherwise.
 */
export function isTimeInput(value: unknown): value is ITimeInput {
  const obj = value as ITimeInput;
  return typeof obj === 'object' && obj.type === 'Input.Time';
}

export type TimeInputOptions = Partial<Omit<ITimeInput, 'type'>>;

/**
 * An input to allow the user to select a time.
 */
export class TimeInput implements ITimeInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Time**.
   */
  readonly type = 'Input.Time';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input, in the `HH:MM` format.
   */
  value?: string;
  /**
   * The text to display as a placeholder when the user hasn't entered a value.
   */
  placeholder?: string;
  /**
   * The minimum time that can be selected, in the `HH:MM` format.
   */
  min?: string;
  /**
   * The maximum time that can be selected, in the `HH:MM` format.
   */
  max?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: TimeInputOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ITimeInput, 'type'>): TimeInput {
    return new TimeInput(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withPlaceholder(placeholder: string): this {
    this.placeholder = placeholder;
    return this;
  }

  withMin(min: string): this {
    this.min = min;
    return this;
  }

  withMax(max: string): this {
    this.max = max;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An input to allow the user to enter a number.
 */
export interface INumberInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Number**.
   */
  readonly type: 'Input.Number';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: number;
  /**
   * The text to display as a placeholder when the user hasn't entered a value.
   */
  placeholder?: string;
  /**
   * The minimum value that can be entered.
   */
  min?: number;
  /**
   * The maximum value that can be entered.
   */
  max?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type INumberInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of NumberInput, false otherwise.
 */
export function isNumberInput(value: unknown): value is INumberInput {
  const obj = value as INumberInput;
  return typeof obj === 'object' && obj.type === 'Input.Number';
}

export type NumberInputOptions = Partial<Omit<INumberInput, 'type'>>;

/**
 * An input to allow the user to enter a number.
 */
export class NumberInput implements INumberInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Number**.
   */
  readonly type = 'Input.Number';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: number;
  /**
   * The text to display as a placeholder when the user hasn't entered a value.
   */
  placeholder?: string;
  /**
   * The minimum value that can be entered.
   */
  min?: number;
  /**
   * The maximum value that can be entered.
   */
  max?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: NumberInputOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<INumberInput, 'type'>): NumberInput {
    return new NumberInput(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withPlaceholder(placeholder: string): this {
    this.placeholder = placeholder;
    return this;
  }

  withMin(min: number): this {
    this.min = min;
    return this;
  }

  withMax(max: number): this {
    this.max = max;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An input to allow the user to select between on/off states.
 */
export interface IToggleInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Toggle**.
   */
  readonly type: 'Input.Toggle';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: string;
  /**
   * The title (caption) to display next to the toggle.
   */
  title: string;
  /**
   * The value to send to the Bot when the toggle is on.
   */
  valueOn?: string;
  /**
   * The value to send to the Bot when the toggle is off.
   */
  valueOff?: string;
  /**
   * Controls if the title should wrap.
   */
  wrap?: boolean;
  /**
   * Controls whether the title is visually displayed. When set to false, the title is hidden from view but remains accessible to screen readers for accessibility purposes.
   */
  showTitle?: boolean;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IToggleInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ToggleInput, false otherwise.
 */
export function isToggleInput(value: unknown): value is IToggleInput {
  const obj = value as IToggleInput;
  return typeof obj === 'object' && obj.type === 'Input.Toggle';
}

export type ToggleInputOptions = Partial<Omit<IToggleInput, 'type' | 'title'>>;

/**
 * An input to allow the user to select between on/off states.
 */
export class ToggleInput implements IToggleInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Toggle**.
   */
  readonly type = 'Input.Toggle';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: string = 'false';
  /**
   * The title (caption) to display next to the toggle.
   */
  title: string;
  /**
   * The value to send to the Bot when the toggle is on.
   */
  valueOn?: string = 'true';
  /**
   * The value to send to the Bot when the toggle is off.
   */
  valueOff?: string = 'false';
  /**
   * Controls if the title should wrap.
   */
  wrap?: boolean = true;
  /**
   * Controls whether the title is visually displayed. When set to false, the title is hidden from view but remains accessible to screen readers for accessibility purposes.
   */
  showTitle?: boolean = true;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(title: string, options: ToggleInputOptions = {}) {
    Object.assign(this, options);
    this.title = title;
  }

  static from(options: Omit<IToggleInput, 'type'>): ToggleInput {
    return new ToggleInput(options.title, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withValueOn(valueOn: string): this {
    this.valueOn = valueOn;
    return this;
  }

  withValueOff(valueOff: string): this {
    this.valueOff = valueOff;
    return this;
  }

  withWrap(wrap = false): this {
    this.wrap = wrap;
    return this;
  }

  withShowTitle(showTitle = false): this {
    this.showTitle = showTitle;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An input to allow the user to select one or more values.
 */
export interface IChoiceSetInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.ChoiceSet**.
   */
  readonly type: 'Input.ChoiceSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: string;
  /**
   * The choices associated with the input.
   */
  choices: IChoice[];
  /**
   * A Data.Query object that defines the dataset from which to dynamically fetch the choices for the input.
   */
  'choices.data'?: IQueryData;
  /**
   * Controls whether the input should be displayed as a dropdown (compact) or a list of radio buttons or checkboxes (expanded).
   */
  style?: ChoiceSetInputStyle;
  /**
   * Controls whether multiple choices can be selected.
   */
  isMultiSelect?: boolean;
  /**
   * The text to display as a placeholder when the user has not entered any value.
   */
  placeholder?: string;
  /**
   * Controls if choice titles should wrap.
   */
  wrap?: boolean;
  /**
   * Controls whether choice items are arranged in multiple columns in expanded mode, or in a single column. Default is false.
   */
  useMultipleColumns?: boolean;
  /**
   * The minimum width, in pixels, for each column when using a multi-column layout. This ensures that choice items remain readable even when horizontal space is limited. Default is 100 pixels.
   */
  minColumnWidth?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IChoiceSetInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ChoiceSetInput, false otherwise.
 */
export function isChoiceSetInput(value: unknown): value is IChoiceSetInput {
  const obj = value as IChoiceSetInput;
  return typeof obj === 'object' && obj.type === 'Input.ChoiceSet';
}

export type ChoiceSetInputOptions = Partial<
  Omit<IChoiceSetInput, 'type' | 'choices'>
>;

/**
 * An input to allow the user to select one or more values.
 */
export class ChoiceSetInput implements IChoiceSetInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.ChoiceSet**.
   */
  readonly type = 'Input.ChoiceSet';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: string;
  /**
   * The choices associated with the input.
   */
  choices: IChoice[];
  /**
   * A Data.Query object that defines the dataset from which to dynamically fetch the choices for the input.
   */
  'choices.data'?: IQueryData;
  /**
   * Controls whether the input should be displayed as a dropdown (compact) or a list of radio buttons or checkboxes (expanded).
   */
  style?: ChoiceSetInputStyle = 'compact';
  /**
   * Controls whether multiple choices can be selected.
   */
  isMultiSelect?: boolean = false;
  /**
   * The text to display as a placeholder when the user has not entered any value.
   */
  placeholder?: string;
  /**
   * Controls if choice titles should wrap.
   */
  wrap?: boolean = true;
  /**
   * Controls whether choice items are arranged in multiple columns in expanded mode, or in a single column. Default is false.
   */
  useMultipleColumns?: boolean = false;
  /**
   * The minimum width, in pixels, for each column when using a multi-column layout. This ensures that choice items remain readable even when horizontal space is limited. Default is 100 pixels.
   */
  minColumnWidth?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(...choices: IChoice[]) {
    this.choices = choices;
  }

  withOptions(value: ChoiceSetInputOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withChoices(...choices: IChoice[]): this {
    this.choices = choices;
    return this;
  }

  withStyle(style: ChoiceSetInputStyle): this {
    this.style = style;
    return this;
  }

  withIsMultiSelect(isMultiSelect = true): this {
    this.isMultiSelect = isMultiSelect;
    return this;
  }

  withPlaceholder(placeholder: string): this {
    this.placeholder = placeholder;
    return this;
  }

  withWrap(wrap = false): this {
    this.wrap = wrap;
    return this;
  }

  withUseMultipleColumns(useMultipleColumns = true): this {
    this.useMultipleColumns = useMultipleColumns;
    return this;
  }

  withMinColumnWidth(minColumnWidth: string): this {
    this.minColumnWidth = minColumnWidth;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A choice as used by the Input.ChoiceSet input.
 */
export interface IChoice {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The text to display for the choice.
   */
  title?: string;
  /**
   * The value associated with the choice, as sent to the Bot when an Action.Submit or Action.Execute is invoked
   */
  value?: string;
}

export type ChoiceOptions = Partial<IChoice>;

/**
 * A choice as used by the Input.ChoiceSet input.
 */
export class Choice implements IChoice {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The text to display for the choice.
   */
  title?: string;
  /**
   * The value associated with the choice, as sent to the Bot when an Action.Submit or Action.Execute is invoked
   */
  value?: string;

  constructor(options: ChoiceOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IChoice): Choice {
    return new Choice(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }
}

/**
 * Defines a query to dynamically fetch data from a Bot.
 */
export interface IQueryData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Data.Query**.
   */
  readonly type: 'Data.Query';
  /**
   * The dataset from which to fetch the data.
   */
  dataset?: string;
  /**
   * Controls which inputs are associated with the Data.Query. When a Data.Query is executed, the values of the associated inputs are sent to the Bot, allowing it to perform filtering operations based on the user's input.
   */
  associatedInputs?: AssociatedInputs;
  /**
   * The maximum number of data items that should be returned by the query. Card authors should not specify this property in their card payload. It is determined by the client and sent to the Bot to enable pagination.
   */
  count?: number;
  /**
   * The number of data items to be skipped by the query. Card authors should not specify this property in their card payload. It is determined by the client and sent to the Bot to enable pagination.
   */
  skip?: number;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IQueryData.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of QueryData, false otherwise.
 */
export function isQueryData(value: unknown): value is IQueryData {
  const obj = value as IQueryData;
  return typeof obj === 'object' && obj.type === 'Data.Query';
}

export type QueryDataOptions = Partial<Omit<IQueryData, 'type'>>;

/**
 * Defines a query to dynamically fetch data from a Bot.
 */
export class QueryData implements IQueryData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Data.Query**.
   */
  readonly type = 'Data.Query';
  /**
   * The dataset from which to fetch the data.
   */
  dataset?: string;
  /**
   * Controls which inputs are associated with the Data.Query. When a Data.Query is executed, the values of the associated inputs are sent to the Bot, allowing it to perform filtering operations based on the user's input.
   */
  associatedInputs?: AssociatedInputs;
  /**
   * The maximum number of data items that should be returned by the query. Card authors should not specify this property in their card payload. It is determined by the client and sent to the Bot to enable pagination.
   */
  count?: number;
  /**
   * The number of data items to be skipped by the query. Card authors should not specify this property in their card payload. It is determined by the client and sent to the Bot to enable pagination.
   */
  skip?: number;

  constructor(options: QueryDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IQueryData, 'type'>): QueryData {
    return new QueryData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withDataset(dataset: string): this {
    this.dataset = dataset;
    return this;
  }

  withAssociatedInputs(associatedInputs: AssociatedInputs): this {
    this.associatedInputs = associatedInputs;
    return this;
  }

  withCount(count: number): this {
    this.count = count;
    return this;
  }

  withSkip(skip: number): this {
    this.skip = skip;
    return this;
  }
}

/**
 * An input to allow the user to rate something using stars.
 */
export interface IRatingInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Rating**.
   */
  readonly type: 'Input.Rating';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: number;
  /**
   * The number of stars to display.
   */
  max?: number;
  /**
   * Controls if the user can select half stars.
   */
  allowHalfSteps?: boolean;
  /**
   * The size of the stars.
   */
  size?: RatingSize;
  /**
   * The color of the stars.
   */
  color?: RatingColor;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IRatingInput.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of RatingInput, false otherwise.
 */
export function isRatingInput(value: unknown): value is IRatingInput {
  const obj = value as IRatingInput;
  return typeof obj === 'object' && obj.type === 'Input.Rating';
}

export type RatingInputOptions = Partial<Omit<IRatingInput, 'type'>>;

/**
 * An input to allow the user to rate something using stars.
 */
export class RatingInput implements IRatingInput {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Input.Rating**.
   */
  readonly type = 'Input.Rating';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the input.
   *
   * A label should **always** be provided to ensure the best user experience especially for users of assistive technology.
   */
  label?: string;
  /**
   * Controls whether the input is required. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  isRequired?: boolean = false;
  /**
   * The error message to display when the input fails validation. See [Input validation](https://adaptivecards.microsoft.com/?topic=input-validation) for more details.
   */
  errorMessage?: string;
  /**
   * An Action.ResetInputs action that will be executed when the value of the input changes.
   */
  valueChangedAction?:
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction;
  /**
   * The default value of the input.
   */
  value?: number;
  /**
   * The number of stars to display.
   */
  max?: number = 5;
  /**
   * Controls if the user can select half stars.
   */
  allowHalfSteps?: boolean = false;
  /**
   * The size of the stars.
   */
  size?: RatingSize = 'Large';
  /**
   * The color of the stars.
   */
  color?: RatingColor = 'Neutral';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: RatingInputOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IRatingInput, 'type'>): RatingInput {
    return new RatingInput(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withIsRequired(isRequired = true): this {
    this.isRequired = isRequired;
    return this;
  }

  withErrorMessage(errorMessage: string): this {
    this.errorMessage = errorMessage;
    return this;
  }

  withValueChangedAction(
    valueChangedAction:
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction,
  ): this {
    this.valueChangedAction = valueChangedAction;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withMax(max: number): this {
    this.max = max;
    return this;
  }

  withAllowHalfSteps(allowHalfSteps = true): this {
    this.allowHalfSteps = allowHalfSteps;
    return this;
  }

  withSize(size: RatingSize): this {
    this.size = size;
    return this;
  }

  withColor(color: RatingColor): this {
    this.color = color;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A read-only star rating element, to display the rating of something.
 */
export interface IRating {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Rating**.
   */
  readonly type: 'Rating';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The value of the rating. Must be between 0 and max.
   */
  value?: number;
  /**
   * The number of "votes" associated with the rating.
   */
  count?: number;
  /**
   * The number of stars to display.
   */
  max?: number;
  /**
   * The size of the stars.
   */
  size?: RatingSize;
  /**
   * The color of the stars.
   */
  color?: RatingColor;
  /**
   * The style of the stars.
   */
  style?: RatingStyle;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IRating.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Rating, false otherwise.
 */
export function isRating(value: unknown): value is IRating {
  const obj = value as IRating;
  return typeof obj === 'object' && obj.type === 'Rating';
}

export type RatingOptions = Partial<Omit<IRating, 'type'>>;

/**
 * A read-only star rating element, to display the rating of something.
 */
export class Rating implements IRating {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Rating**.
   */
  readonly type = 'Rating';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The value of the rating. Must be between 0 and max.
   */
  value?: number;
  /**
   * The number of "votes" associated with the rating.
   */
  count?: number;
  /**
   * The number of stars to display.
   */
  max?: number = 5;
  /**
   * The size of the stars.
   */
  size?: RatingSize = 'Large';
  /**
   * The color of the stars.
   */
  color?: RatingColor = 'Neutral';
  /**
   * The style of the stars.
   */
  style?: RatingStyle = 'Default';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: RatingOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IRating, 'type'>): Rating {
    return new Rating(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withCount(count: number): this {
    this.count = count;
    return this;
  }

  withMax(max: number): this {
    this.max = max;
    return this;
  }

  withSize(size: RatingSize): this {
    this.size = size;
    return this;
  }

  withColor(color: RatingColor): this {
    this.color = color;
    return this;
  }

  withStyle(style: RatingStyle): this {
    this.style = style;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A special type of button with an icon, title and description.
 */
export interface ICompoundButton {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **CompoundButton**.
   */
  readonly type: 'CompoundButton';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The icon to show on the button.
   */
  icon?: IIconInfo;
  /**
   * The badge to show on the button.
   */
  badge?: string;
  /**
   * The title of the button.
   */
  title?: string;
  /**
   * The description text of the button.
   */
  description?: string;
  /**
   * An Action that will be invoked when the button is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ICompoundButton.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of CompoundButton, false otherwise.
 */
export function isCompoundButton(value: unknown): value is ICompoundButton {
  const obj = value as ICompoundButton;
  return typeof obj === 'object' && obj.type === 'CompoundButton';
}

export type CompoundButtonOptions = Partial<Omit<ICompoundButton, 'type'>>;

/**
 * A special type of button with an icon, title and description.
 */
export class CompoundButton implements ICompoundButton {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **CompoundButton**.
   */
  readonly type = 'CompoundButton';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The icon to show on the button.
   */
  icon?: IIconInfo;
  /**
   * The badge to show on the button.
   */
  badge?: string;
  /**
   * The title of the button.
   */
  title?: string;
  /**
   * The description text of the button.
   */
  description?: string;
  /**
   * An Action that will be invoked when the button is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: CompoundButtonOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ICompoundButton, 'type'>): CompoundButton {
    return new CompoundButton(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withIcon(icon: IIconInfo): this {
    this.icon = icon;
    return this;
  }

  withBadge(badge: string): this {
    this.badge = badge;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withDescription(description: string): this {
    this.description = description;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Defines information about a Fluent icon and how it should be rendered.
 */
export interface IIconInfo {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the icon to display.
   */
  name?: string;
  /**
   * The size of the icon.
   */
  size?: IconSize;
  /**
   * The style of the icon.
   */
  style?: IconStyle;
  /**
   * The color of the icon.
   */
  color?: TextColor;
}

export type IconInfoOptions = Partial<IIconInfo>;

/**
 * Defines information about a Fluent icon and how it should be rendered.
 */
export class IconInfo implements IIconInfo {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the icon to display.
   */
  name?: string;
  /**
   * The size of the icon.
   */
  size?: IconSize = 'xSmall';
  /**
   * The style of the icon.
   */
  style?: IconStyle = 'Regular';
  /**
   * The color of the icon.
   */
  color?: TextColor = 'Default';

  constructor(options: IconInfoOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IIconInfo): IconInfo {
    return new IconInfo(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withSize(size: IconSize): this {
    this.size = size;
    return this;
  }

  withStyle(style: IconStyle): this {
    this.style = style;
    return this;
  }

  withColor(color: TextColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A standalone icon element. Icons can be picked from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog).
 */
export interface IIcon {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Icon**.
   */
  readonly type: 'Icon';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The name of the icon to display.
   */
  name: string;
  /**
   * The size of the icon.
   */
  size?: IconSize;
  /**
   * The style of the icon.
   */
  style?: IconStyle;
  /**
   * The color of the icon.
   */
  color?: TextColor;
  /**
   * An Action that will be invoked when the icon is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IIcon.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Icon, false otherwise.
 */
export function isIcon(value: unknown): value is IIcon {
  const obj = value as IIcon;
  return typeof obj === 'object' && obj.type === 'Icon';
}

export type IconOptions = Partial<Omit<IIcon, 'type' | 'name'>>;

/**
 * A standalone icon element. Icons can be picked from the vast [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog).
 */
export class Icon implements IIcon {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Icon**.
   */
  readonly type = 'Icon';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The name of the icon to display.
   */
  name: string;
  /**
   * The size of the icon.
   */
  size?: IconSize = 'Standard';
  /**
   * The style of the icon.
   */
  style?: IconStyle = 'Regular';
  /**
   * The color of the icon.
   */
  color?: TextColor = 'Default';
  /**
   * An Action that will be invoked when the icon is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(name: string, options: IconOptions = {}) {
    Object.assign(this, options);
    this.name = name;
  }

  static from(options: Omit<IIcon, 'type'>): Icon {
    return new Icon(options.name, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withSize(size: IconSize): this {
    this.size = size;
    return this;
  }

  withStyle(style: IconStyle): this {
    this.style = style;
    return this;
  }

  withColor(color: TextColor): this {
    this.color = color;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A carousel with sliding pages.
 */
export interface ICarousel {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Carousel**.
   */
  readonly type: 'Carousel';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Controls the type of animation to use to navigate between pages.
   */
  pageAnimation?: CarouselPageAnimation;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The pages in the carousel.
   */
  pages?: ICarouselPage[];
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ICarousel.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Carousel, false otherwise.
 */
export function isCarousel(value: unknown): value is ICarousel {
  const obj = value as ICarousel;
  return typeof obj === 'object' && obj.type === 'Carousel';
}

export type CarouselOptions = Partial<Omit<ICarousel, 'type'>>;

/**
 * A carousel with sliding pages.
 */
export class Carousel implements ICarousel {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Carousel**.
   */
  readonly type = 'Carousel';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean = false;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Controls the type of animation to use to navigate between pages.
   */
  pageAnimation?: CarouselPageAnimation = 'Slide';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The pages in the carousel.
   */
  pages?: ICarouselPage[];

  constructor(options: CarouselOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ICarousel, 'type'>): Carousel {
    return new Carousel(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withBleed(bleed = true): this {
    this.bleed = bleed;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withPageAnimation(pageAnimation: CarouselPageAnimation): this {
    this.pageAnimation = pageAnimation;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withPages(...pages: ICarouselPage[]): this {
    this.pages = pages;
    return this;
  }
}

/**
 * A badge element to show an icon and/or text in a compact form over a colored background.
 */
export interface IBadge {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Badge**.
   */
  readonly type: 'Badge';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The text to display.
   */
  text?: string;
  /**
   * The name of an icon from the [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) to display, in the `<icon-name>[,regular|filled]` format. If the style is not specified, the regular style is used.
   */
  icon?: string;
  /**
   * Controls the position of the icon.
   */
  iconPosition?: BadgeIconPosition;
  /**
   * Controls the strength of the background color.
   */
  appearance?: BadgeAppearance;
  /**
   * The size of the badge.
   */
  size?: BadgeSize;
  /**
   * Controls the shape of the badge.
   */
  shape?: BadgeShape;
  /**
   * The style of the badge.
   */
  style?: BadgeStyle;
  /**
   * Controls the tooltip text to display when the badge is hovered over.
   */
  tooltip?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IBadge.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Badge, false otherwise.
 */
export function isBadge(value: unknown): value is IBadge {
  const obj = value as IBadge;
  return typeof obj === 'object' && obj.type === 'Badge';
}

export type BadgeOptions = Partial<Omit<IBadge, 'type'>>;

/**
 * A badge element to show an icon and/or text in a compact form over a colored background.
 */
export class Badge implements IBadge {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Badge**.
   */
  readonly type = 'Badge';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The text to display.
   */
  text?: string;
  /**
   * The name of an icon from the [Adaptive Card icon catalog](https://adaptivecards.microsoft.com/?topic=icon-catalog) to display, in the `<icon-name>[,regular|filled]` format. If the style is not specified, the regular style is used.
   */
  icon?: string;
  /**
   * Controls the position of the icon.
   */
  iconPosition?: BadgeIconPosition = 'Before';
  /**
   * Controls the strength of the background color.
   */
  appearance?: BadgeAppearance = 'Filled';
  /**
   * The size of the badge.
   */
  size?: BadgeSize = 'Medium';
  /**
   * Controls the shape of the badge.
   */
  shape?: BadgeShape = 'Circular';
  /**
   * The style of the badge.
   */
  style?: BadgeStyle = 'Default';
  /**
   * Controls the tooltip text to display when the badge is hovered over.
   */
  tooltip?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: BadgeOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IBadge, 'type'>): Badge {
    return new Badge(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withText(text: string): this {
    this.text = text;
    return this;
  }

  withIcon(icon: string): this {
    this.icon = icon;
    return this;
  }

  withIconPosition(iconPosition: BadgeIconPosition): this {
    this.iconPosition = iconPosition;
    return this;
  }

  withAppearance(appearance: BadgeAppearance): this {
    this.appearance = appearance;
    return this;
  }

  withSize(size: BadgeSize): this {
    this.size = size;
    return this;
  }

  withShape(shape: BadgeShape): this {
    this.shape = shape;
    return this;
  }

  withStyle(style: BadgeStyle): this {
    this.style = style;
    return this;
  }

  withTooltip(tooltip: string): this {
    this.tooltip = tooltip;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A spinning ring element, to indicate progress.
 */
export interface IProgressRing {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ProgressRing**.
   */
  readonly type: 'ProgressRing';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The label of the progress ring.
   */
  label?: string;
  /**
   * Controls the relative position of the label to the progress ring.
   */
  labelPosition?: ProgressRingLabelPosition;
  /**
   * The size of the progress ring.
   */
  size?: ProgressRingSize;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IProgressRing.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ProgressRing, false otherwise.
 */
export function isProgressRing(value: unknown): value is IProgressRing {
  const obj = value as IProgressRing;
  return typeof obj === 'object' && obj.type === 'ProgressRing';
}

export type ProgressRingOptions = Partial<Omit<IProgressRing, 'type'>>;

/**
 * A spinning ring element, to indicate progress.
 */
export class ProgressRing implements IProgressRing {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ProgressRing**.
   */
  readonly type = 'ProgressRing';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The label of the progress ring.
   */
  label?: string;
  /**
   * Controls the relative position of the label to the progress ring.
   */
  labelPosition?: ProgressRingLabelPosition = 'Below';
  /**
   * The size of the progress ring.
   */
  size?: ProgressRingSize = 'Medium';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ProgressRingOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IProgressRing, 'type'>): ProgressRing {
    return new ProgressRing(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withLabel(label: string): this {
    this.label = label;
    return this;
  }

  withLabelPosition(labelPosition: ProgressRingLabelPosition): this {
    this.labelPosition = labelPosition;
    return this;
  }

  withSize(size: ProgressRingSize): this {
    this.size = size;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A progress bar element, to represent a value within a range.
 */
export interface IProgressBar {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ProgressBar**.
   */
  readonly type: 'ProgressBar';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The value of the progress bar. Must be between 0 and max.
   */
  value?: number;
  /**
   * The maximum value of the progress bar.
   */
  max?: number;
  /**
   * The color of the progress bar. `color` has no effect when the `ProgressBar` is in indeterminate mode, in which case the "accent" color is always used.
   */
  color?: ProgressBarColor;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IProgressBar.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ProgressBar, false otherwise.
 */
export function isProgressBar(value: unknown): value is IProgressBar {
  const obj = value as IProgressBar;
  return typeof obj === 'object' && obj.type === 'ProgressBar';
}

export type ProgressBarOptions = Partial<Omit<IProgressBar, 'type'>>;

/**
 * A progress bar element, to represent a value within a range.
 */
export class ProgressBar implements IProgressBar {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ProgressBar**.
   */
  readonly type = 'ProgressBar';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The value of the progress bar. Must be between 0 and max.
   */
  value?: number;
  /**
   * The maximum value of the progress bar.
   */
  max?: number = 100;
  /**
   * The color of the progress bar. `color` has no effect when the `ProgressBar` is in indeterminate mode, in which case the "accent" color is always used.
   */
  color?: ProgressBarColor = 'Accent';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ProgressBarOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IProgressBar, 'type'>): ProgressBar {
    return new ProgressBar(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withMax(max: number): this {
    this.max = max;
    return this;
  }

  withColor(color: ProgressBarColor): this {
    this.color = color;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A donut chart.
 */
export interface IDonutChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Donut**.
   */
  readonly type: 'Chart.Donut';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The data to display in the chart.
   */
  data?: IDonutChartData[];
  /**
   * The value that should be displayed in the center of a Donut chart. `value` is ignored for Pie charts.
   */
  value?: string;
  /**
   * Controls the color of the value displayed in the center of a Donut chart.
   */
  valueColor?: ChartColor;
  /**
   * Controls the thickness of the donut segments. Default is **Thick**.
   */
  thickness?: DonutThickness;
  /**
   * Controls whether the outlines of the donut segments are displayed.
   */
  showOutlines?: boolean;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IDonutChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of DonutChart, false otherwise.
 */
export function isDonutChart(value: unknown): value is IDonutChart {
  const obj = value as IDonutChart;
  return typeof obj === 'object' && obj.type === 'Chart.Donut';
}

export type DonutChartOptions = Partial<Omit<IDonutChart, 'type'>>;

/**
 * A donut chart.
 */
export class DonutChart implements IDonutChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Donut**.
   */
  readonly type = 'Chart.Donut';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The data to display in the chart.
   */
  data?: IDonutChartData[];
  /**
   * The value that should be displayed in the center of a Donut chart. `value` is ignored for Pie charts.
   */
  value?: string;
  /**
   * Controls the color of the value displayed in the center of a Donut chart.
   */
  valueColor?: ChartColor;
  /**
   * Controls the thickness of the donut segments. Default is **Thick**.
   */
  thickness?: DonutThickness;
  /**
   * Controls whether the outlines of the donut segments are displayed.
   */
  showOutlines?: boolean = true;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: DonutChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IDonutChart, 'type'>): DonutChart {
    return new DonutChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withData(...data: IDonutChartData[]): this {
    this.data = data;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withValueColor(valueColor: ChartColor): this {
    this.valueColor = valueColor;
    return this;
  }

  withThickness(thickness: DonutThickness): this {
    this.thickness = thickness;
    return this;
  }

  withShowOutlines(showOutlines = false): this {
    this.showOutlines = showOutlines;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A data point in a Donut chart.
 */
export interface IDonutChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend of the chart.
   */
  legend?: string;
  /**
   * The value associated with the data point.
   */
  value?: number;
  /**
   * The color to use for the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type DonutChartDataOptions = Partial<IDonutChartData>;

/**
 * A data point in a Donut chart.
 */
export class DonutChartData implements IDonutChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend of the chart.
   */
  legend?: string;
  /**
   * The value associated with the data point.
   */
  value?: number = 0;
  /**
   * The color to use for the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: DonutChartDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IDonutChartData): DonutChartData {
    return new DonutChartData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withLegend(legend: string): this {
    this.legend = legend;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A pie chart.
 */
export interface IPieChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Pie**.
   */
  readonly type: 'Chart.Pie';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The data to display in the chart.
   */
  data?: IDonutChartData[];
  /**
   * The value that should be displayed in the center of a Donut chart. `value` is ignored for Pie charts.
   */
  value?: string;
  /**
   * Controls the color of the value displayed in the center of a Donut chart.
   */
  valueColor?: ChartColor;
  /**
   * Controls the thickness of the donut segments. Default is **Thick**.
   */
  thickness?: DonutThickness;
  /**
   * Controls whether the outlines of the donut segments are displayed.
   */
  showOutlines?: boolean;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IPieChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of PieChart, false otherwise.
 */
export function isPieChart(value: unknown): value is IPieChart {
  const obj = value as IPieChart;
  return typeof obj === 'object' && obj.type === 'Chart.Pie';
}

export type PieChartOptions = Partial<Omit<IPieChart, 'type'>>;

/**
 * A pie chart.
 */
export class PieChart implements IPieChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Pie**.
   */
  readonly type = 'Chart.Pie';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The data to display in the chart.
   */
  data?: IDonutChartData[];
  /**
   * The value that should be displayed in the center of a Donut chart. `value` is ignored for Pie charts.
   */
  value?: string;
  /**
   * Controls the color of the value displayed in the center of a Donut chart.
   */
  valueColor?: ChartColor;
  /**
   * Controls the thickness of the donut segments. Default is **Thick**.
   */
  thickness?: DonutThickness;
  /**
   * Controls whether the outlines of the donut segments are displayed.
   */
  showOutlines?: boolean = true;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: PieChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IPieChart, 'type'>): PieChart {
    return new PieChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withData(...data: IDonutChartData[]): this {
    this.data = data;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }

  withValueColor(valueColor: ChartColor): this {
    this.valueColor = valueColor;
    return this;
  }

  withThickness(thickness: DonutThickness): this {
    this.thickness = thickness;
    return this;
  }

  withShowOutlines(showOutlines = false): this {
    this.showOutlines = showOutlines;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A grouped vertical bar chart.
 */
export interface IGroupedVerticalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.VerticalBar.Grouped**.
   */
  readonly type: 'Chart.VerticalBar.Grouped';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * Controls if bars in the chart should  be displayed as stacks instead of groups.
   *
   * **Note:** stacked vertical bar charts do not support custom Y ranges nor negative Y values.
   */
  stacked?: boolean;
  /**
   * The data points in a series.
   */
  data?: IGroupedVerticalBarChartData[];
  /**
   * Controls if values should be displayed on each bar.
   */
  showBarValues?: boolean;
  /**
   * The requested minimum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   *
   * `yMin` is ignored if `stacked` is set to `true`.
   */
  yMin?: number;
  /**
   * The requested maximum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   *
   * `yMax` is ignored if `stacked` is set to `true`.
   */
  yMax?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IGroupedVerticalBarChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of GroupedVerticalBarChart, false otherwise.
 */
export function isGroupedVerticalBarChart(
  value: unknown,
): value is IGroupedVerticalBarChart {
  const obj = value as IGroupedVerticalBarChart;
  return typeof obj === 'object' && obj.type === 'Chart.VerticalBar.Grouped';
}

export type GroupedVerticalBarChartOptions = Partial<
  Omit<IGroupedVerticalBarChart, 'type'>
>;

/**
 * A grouped vertical bar chart.
 */
export class GroupedVerticalBarChart implements IGroupedVerticalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.VerticalBar.Grouped**.
   */
  readonly type = 'Chart.VerticalBar.Grouped';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * Controls if bars in the chart should  be displayed as stacks instead of groups.
   *
   * **Note:** stacked vertical bar charts do not support custom Y ranges nor negative Y values.
   */
  stacked?: boolean = false;
  /**
   * The data points in a series.
   */
  data?: IGroupedVerticalBarChartData[];
  /**
   * Controls if values should be displayed on each bar.
   */
  showBarValues?: boolean = false;
  /**
   * The requested minimum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   *
   * `yMin` is ignored if `stacked` is set to `true`.
   */
  yMin?: number;
  /**
   * The requested maximum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   *
   * `yMax` is ignored if `stacked` is set to `true`.
   */
  yMax?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: GroupedVerticalBarChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IGroupedVerticalBarChart, 'type'>,
  ): GroupedVerticalBarChart {
    return new GroupedVerticalBarChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withXAxisTitle(xAxisTitle: string): this {
    this.xAxisTitle = xAxisTitle;
    return this;
  }

  withYAxisTitle(yAxisTitle: string): this {
    this.yAxisTitle = yAxisTitle;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }

  withStacked(stacked = true): this {
    this.stacked = stacked;
    return this;
  }

  withData(...data: IGroupedVerticalBarChartData[]): this {
    this.data = data;
    return this;
  }

  withShowBarValues(showBarValues = true): this {
    this.showBarValues = showBarValues;
    return this;
  }

  withYMin(yMin: number): this {
    this.yMin = yMin;
    return this;
  }

  withYMax(yMax: number): this {
    this.yMax = yMax;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents a series of data points.
 */
export interface IGroupedVerticalBarChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend of the chart.
   */
  legend?: string;
  /**
   * The data points in the series.
   */
  values?: IBarChartDataValue[];
  /**
   * The color to use for all data points in the series. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type GroupedVerticalBarChartDataOptions =
  Partial<IGroupedVerticalBarChartData>;

/**
 * Represents a series of data points.
 */
export class GroupedVerticalBarChartData implements IGroupedVerticalBarChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend of the chart.
   */
  legend?: string;
  /**
   * The data points in the series.
   */
  values?: IBarChartDataValue[];
  /**
   * The color to use for all data points in the series. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: GroupedVerticalBarChartDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: IGroupedVerticalBarChartData,
  ): GroupedVerticalBarChartData {
    return new GroupedVerticalBarChartData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withLegend(legend: string): this {
    this.legend = legend;
    return this;
  }

  withValues(...values: IBarChartDataValue[]): this {
    this.values = values;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A single data point in a bar chart.
 */
export interface IBarChartDataValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   */
  x?: string;
  /**
   * The y axis value of the data point.
   */
  y?: number;
}

export type BarChartDataValueOptions = Partial<IBarChartDataValue>;

/**
 * A single data point in a bar chart.
 */
export class BarChartDataValue implements IBarChartDataValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   */
  x?: string;
  /**
   * The y axis value of the data point.
   */
  y?: number = 0;

  constructor(options: BarChartDataValueOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IBarChartDataValue): BarChartDataValue {
    return new BarChartDataValue(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withX(x: string): this {
    this.x = x;
    return this;
  }

  withY(y: number): this {
    this.y = y;
    return this;
  }
}

/**
 * A vertical bar chart.
 */
export interface IVerticalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.VerticalBar**.
   */
  readonly type: 'Chart.VerticalBar';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The data to display in the chart.
   */
  data?: IVerticalBarChartDataValue[];
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * Controls if the bar values should be displayed.
   */
  showBarValues?: boolean;
  /**
   * The requested minimum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   */
  yMin?: number;
  /**
   * The requested maximum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   */
  yMax?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IVerticalBarChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of VerticalBarChart, false otherwise.
 */
export function isVerticalBarChart(value: unknown): value is IVerticalBarChart {
  const obj = value as IVerticalBarChart;
  return typeof obj === 'object' && obj.type === 'Chart.VerticalBar';
}

export type VerticalBarChartOptions = Partial<Omit<IVerticalBarChart, 'type'>>;

/**
 * A vertical bar chart.
 */
export class VerticalBarChart implements IVerticalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.VerticalBar**.
   */
  readonly type = 'Chart.VerticalBar';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The data to display in the chart.
   */
  data?: IVerticalBarChartDataValue[];
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * Controls if the bar values should be displayed.
   */
  showBarValues?: boolean = false;
  /**
   * The requested minimum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   */
  yMin?: number;
  /**
   * The requested maximum for the Y axis range. The value used at runtime may be different to optimize visual presentation.
   */
  yMax?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: VerticalBarChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IVerticalBarChart, 'type'>): VerticalBarChart {
    return new VerticalBarChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withXAxisTitle(xAxisTitle: string): this {
    this.xAxisTitle = xAxisTitle;
    return this;
  }

  withYAxisTitle(yAxisTitle: string): this {
    this.yAxisTitle = yAxisTitle;
    return this;
  }

  withData(...data: IVerticalBarChartDataValue[]): this {
    this.data = data;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }

  withShowBarValues(showBarValues = true): this {
    this.showBarValues = showBarValues;
    return this;
  }

  withYMin(yMin: number): this {
    this.yMin = yMin;
    return this;
  }

  withYMax(yMax: number): this {
    this.yMax = yMax;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents a data point in a vertical bar chart.
 */
export interface IVerticalBarChartDataValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   */
  x?: string | number;
  /**
   * The y axis value of the data point.
   */
  y?: number;
  /**
   * The color to use for the bar associated with the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type VerticalBarChartDataValueOptions =
  Partial<IVerticalBarChartDataValue>;

/**
 * Represents a data point in a vertical bar chart.
 */
export class VerticalBarChartDataValue implements IVerticalBarChartDataValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   */
  x?: string | number;
  /**
   * The y axis value of the data point.
   */
  y?: number = 0;
  /**
   * The color to use for the bar associated with the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: VerticalBarChartDataValueOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IVerticalBarChartDataValue): VerticalBarChartDataValue {
    return new VerticalBarChartDataValue(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withX(x: string | number): this {
    this.x = x;
    return this;
  }

  withY(y: number): this {
    this.y = y;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A horizontal bar chart.
 */
export interface IHorizontalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.HorizontalBar**.
   */
  readonly type: 'Chart.HorizontalBar';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * The data points in the chart.
   */
  data?: IHorizontalBarChartDataValue[];
  /**
   * Controls how the chart should be visually laid out.
   */
  displayMode?: HorizontalBarChartDisplayMode;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IHorizontalBarChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of HorizontalBarChart, false otherwise.
 */
export function isHorizontalBarChart(
  value: unknown,
): value is IHorizontalBarChart {
  const obj = value as IHorizontalBarChart;
  return typeof obj === 'object' && obj.type === 'Chart.HorizontalBar';
}

export type HorizontalBarChartOptions = Partial<
  Omit<IHorizontalBarChart, 'type'>
>;

/**
 * A horizontal bar chart.
 */
export class HorizontalBarChart implements IHorizontalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.HorizontalBar**.
   */
  readonly type = 'Chart.HorizontalBar';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * The data points in the chart.
   */
  data?: IHorizontalBarChartDataValue[];
  /**
   * Controls how the chart should be visually laid out.
   */
  displayMode?: HorizontalBarChartDisplayMode = 'AbsoluteWithAxis';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: HorizontalBarChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IHorizontalBarChart, 'type'>): HorizontalBarChart {
    return new HorizontalBarChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withXAxisTitle(xAxisTitle: string): this {
    this.xAxisTitle = xAxisTitle;
    return this;
  }

  withYAxisTitle(yAxisTitle: string): this {
    this.yAxisTitle = yAxisTitle;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }

  withData(...data: IHorizontalBarChartDataValue[]): this {
    this.data = data;
    return this;
  }

  withDisplayMode(displayMode: HorizontalBarChartDisplayMode): this {
    this.displayMode = displayMode;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents a single data point in a horizontal bar chart.
 */
export interface IHorizontalBarChartDataValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   */
  x?: string;
  /**
   * The y axis value of the data point.
   */
  y?: number;
  /**
   * The color of the bar associated with the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type HorizontalBarChartDataValueOptions =
  Partial<IHorizontalBarChartDataValue>;

/**
 * Represents a single data point in a horizontal bar chart.
 */
export class HorizontalBarChartDataValue implements IHorizontalBarChartDataValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   */
  x?: string;
  /**
   * The y axis value of the data point.
   */
  y?: number = 0;
  /**
   * The color of the bar associated with the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: HorizontalBarChartDataValueOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: IHorizontalBarChartDataValue,
  ): HorizontalBarChartDataValue {
    return new HorizontalBarChartDataValue(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withX(x: string): this {
    this.x = x;
    return this;
  }

  withY(y: number): this {
    this.y = y;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A stacked horizontal bar chart.
 */
export interface IStackedHorizontalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.HorizontalBar.Stacked**.
   */
  readonly type: 'Chart.HorizontalBar.Stacked';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * The data to display in the chart.
   */
  data?: IStackedHorizontalBarChartData[];
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IStackedHorizontalBarChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of StackedHorizontalBarChart, false otherwise.
 */
export function isStackedHorizontalBarChart(
  value: unknown,
): value is IStackedHorizontalBarChart {
  const obj = value as IStackedHorizontalBarChart;
  return typeof obj === 'object' && obj.type === 'Chart.HorizontalBar.Stacked';
}

export type StackedHorizontalBarChartOptions = Partial<
  Omit<IStackedHorizontalBarChart, 'type'>
>;

/**
 * A stacked horizontal bar chart.
 */
export class StackedHorizontalBarChart implements IStackedHorizontalBarChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.HorizontalBar.Stacked**.
   */
  readonly type = 'Chart.HorizontalBar.Stacked';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * The data to display in the chart.
   */
  data?: IStackedHorizontalBarChartData[];
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: StackedHorizontalBarChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IStackedHorizontalBarChart, 'type'>,
  ): StackedHorizontalBarChart {
    return new StackedHorizontalBarChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withXAxisTitle(xAxisTitle: string): this {
    this.xAxisTitle = xAxisTitle;
    return this;
  }

  withYAxisTitle(yAxisTitle: string): this {
    this.yAxisTitle = yAxisTitle;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }

  withData(...data: IStackedHorizontalBarChartData[]): this {
    this.data = data;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Defines the collection of data series to display in as a stacked horizontal bar chart.
 */
export interface IStackedHorizontalBarChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The title of the series.
   */
  title?: string;
  /**
   * The data points in the series.
   */
  data?: IStackedHorizontalBarChartDataPoint[];
}

export type StackedHorizontalBarChartDataOptions =
  Partial<IStackedHorizontalBarChartData>;

/**
 * Defines the collection of data series to display in as a stacked horizontal bar chart.
 */
export class StackedHorizontalBarChartData implements IStackedHorizontalBarChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The title of the series.
   */
  title?: string;
  /**
   * The data points in the series.
   */
  data?: IStackedHorizontalBarChartDataPoint[];

  constructor(options: StackedHorizontalBarChartDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: IStackedHorizontalBarChartData,
  ): StackedHorizontalBarChartData {
    return new StackedHorizontalBarChartData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withData(...data: IStackedHorizontalBarChartDataPoint[]): this {
    this.data = data;
    return this;
  }
}

/**
 * A data point in a series.
 */
export interface IStackedHorizontalBarChartDataPoint {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend associated with the data point.
   */
  legend?: string;
  /**
   * The value of the data point.
   */
  value?: number;
  /**
   * The color to use to render the bar associated with the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type StackedHorizontalBarChartDataPointOptions =
  Partial<IStackedHorizontalBarChartDataPoint>;

/**
 * A data point in a series.
 */
export class StackedHorizontalBarChartDataPoint implements IStackedHorizontalBarChartDataPoint {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend associated with the data point.
   */
  legend?: string;
  /**
   * The value of the data point.
   */
  value?: number = 0;
  /**
   * The color to use to render the bar associated with the data point. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: StackedHorizontalBarChartDataPointOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: IStackedHorizontalBarChartDataPoint,
  ): StackedHorizontalBarChartDataPoint {
    return new StackedHorizontalBarChartDataPoint(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withLegend(legend: string): this {
    this.legend = legend;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A line chart.
 */
export interface ILineChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Line**.
   */
  readonly type: 'Chart.Line';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * The data point series in the line chart.
   */
  data?: ILineChartData[];
  /**
   * The maximum y range.
   */
  yMin?: number;
  /**
   * The minimum y range.
   */
  yMax?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ILineChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of LineChart, false otherwise.
 */
export function isLineChart(value: unknown): value is ILineChart {
  const obj = value as ILineChart;
  return typeof obj === 'object' && obj.type === 'Chart.Line';
}

export type LineChartOptions = Partial<Omit<ILineChart, 'type'>>;

/**
 * A line chart.
 */
export class LineChart implements ILineChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Line**.
   */
  readonly type = 'Chart.Line';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The title of the x axis.
   */
  xAxisTitle?: string;
  /**
   * The title of the y axis.
   */
  yAxisTitle?: string;
  /**
   * The color to use for all data points. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
  /**
   * The data point series in the line chart.
   */
  data?: ILineChartData[];
  /**
   * The maximum y range.
   */
  yMin?: number;
  /**
   * The minimum y range.
   */
  yMax?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: LineChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ILineChart, 'type'>): LineChart {
    return new LineChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withXAxisTitle(xAxisTitle: string): this {
    this.xAxisTitle = xAxisTitle;
    return this;
  }

  withYAxisTitle(yAxisTitle: string): this {
    this.yAxisTitle = yAxisTitle;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }

  withData(...data: ILineChartData[]): this {
    this.data = data;
    return this;
  }

  withYMin(yMin: number): this {
    this.yMin = yMin;
    return this;
  }

  withYMax(yMax: number): this {
    this.yMax = yMax;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents a collection of data points series in a line chart.
 */
export interface ILineChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend of the chart.
   */
  legend?: string;
  /**
   * The data points in the series.
   */
  values?: ILineChartValue[];
  /**
   * The color all data points in the series. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type LineChartDataOptions = Partial<ILineChartData>;

/**
 * Represents a collection of data points series in a line chart.
 */
export class LineChartData implements ILineChartData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The legend of the chart.
   */
  legend?: string;
  /**
   * The data points in the series.
   */
  values?: ILineChartValue[];
  /**
   * The color all data points in the series. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: LineChartDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ILineChartData): LineChartData {
    return new LineChartData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withLegend(legend: string): this {
    this.legend = legend;
    return this;
  }

  withValues(...values: ILineChartValue[]): this {
    this.values = values;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * Represents a single data point in a line chart.
 */
export interface ILineChartValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   *
   * If all x values of the x [Chart.Line](https://adaptivecards.microsoft.com/?topic=Chart.Line) are expressed as a number, or if all x values are expressed as a date string in the `YYYY-MM-DD` format, the chart will be rendered as a time series chart, i.e. x axis values will span across the minimum x value to maximum x value range.
   *
   * Otherwise, if x values are represented as a mix of numbers and strings or if at least one x value isn't in the `YYYY-MM-DD` format, the chart will be rendered as a categorical chart, i.e. x axis values will be displayed as categories.
   */
  x?: number | string;
  /**
   * The y axis value of the data point.
   */
  y?: number;
}

export type LineChartValueOptions = Partial<ILineChartValue>;

/**
 * Represents a single data point in a line chart.
 */
export class LineChartValue implements ILineChartValue {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The x axis value of the data point.
   *
   * If all x values of the x [Chart.Line](https://adaptivecards.microsoft.com/?topic=Chart.Line) are expressed as a number, or if all x values are expressed as a date string in the `YYYY-MM-DD` format, the chart will be rendered as a time series chart, i.e. x axis values will span across the minimum x value to maximum x value range.
   *
   * Otherwise, if x values are represented as a mix of numbers and strings or if at least one x value isn't in the `YYYY-MM-DD` format, the chart will be rendered as a categorical chart, i.e. x axis values will be displayed as categories.
   */
  x?: number | string;
  /**
   * The y axis value of the data point.
   */
  y?: number = 0;

  constructor(options: LineChartValueOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ILineChartValue): LineChartValue {
    return new LineChartValue(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withX(x: number | string): this {
    this.x = x;
    return this;
  }

  withY(y: number): this {
    this.y = y;
    return this;
  }
}

/**
 * A gauge chart.
 */
export interface IGaugeChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Gauge**.
   */
  readonly type: 'Chart.Gauge';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean;
  /**
   * The minimum value of the gauge.
   */
  min?: number;
  /**
   * The maximum value of the gauge.
   */
  max?: number;
  /**
   * The sub-label of the gauge.
   */
  subLabel?: string;
  /**
   * Controls whether the min/max values should be displayed.
   */
  showMinMax?: boolean;
  /**
   * Controls whether the gauge's needle is displayed. Default is **true**.
   */
  showNeedle?: boolean;
  /**
   * Controls whether the outlines of the gauge segments are displayed.
   */
  showOutlines?: boolean;
  /**
   * The segments to display in the gauge.
   */
  segments?: IGaugeChartLegend[];
  /**
   * The value of the gauge.
   */
  value?: number;
  /**
   * The format used to display the gauge's value.
   */
  valueFormat?: GaugeChartValueFormat;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IGaugeChart.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of GaugeChart, false otherwise.
 */
export function isGaugeChart(value: unknown): value is IGaugeChart {
  const obj = value as IGaugeChart;
  return typeof obj === 'object' && obj.type === 'Chart.Gauge';
}

export type GaugeChartOptions = Partial<Omit<IGaugeChart, 'type'>>;

/**
 * A gauge chart.
 */
export class GaugeChart implements IGaugeChart {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Chart.Gauge**.
   */
  readonly type = 'Chart.Gauge';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The title of the chart.
   */
  title?: string;
  /**
   * Controls whether the chart's title should be displayed. Defaults to `false`.
   */
  showTitle?: boolean = false;
  /**
   * The name of the set of colors to use to render the chart. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  colorSet?: ChartColorSet;
  /**
   * The maximum width, in pixels, of the chart, in the `<number>px` format.
   */
  maxWidth?: string;
  /**
   * Controls whether the chart's legend should be displayed.
   */
  showLegend?: boolean = true;
  /**
   * The minimum value of the gauge.
   */
  min?: number = 0;
  /**
   * The maximum value of the gauge.
   */
  max?: number;
  /**
   * The sub-label of the gauge.
   */
  subLabel?: string;
  /**
   * Controls whether the min/max values should be displayed.
   */
  showMinMax?: boolean = true;
  /**
   * Controls whether the gauge's needle is displayed. Default is **true**.
   */
  showNeedle?: boolean = true;
  /**
   * Controls whether the outlines of the gauge segments are displayed.
   */
  showOutlines?: boolean = true;
  /**
   * The segments to display in the gauge.
   */
  segments?: IGaugeChartLegend[];
  /**
   * The value of the gauge.
   */
  value?: number = 0;
  /**
   * The format used to display the gauge's value.
   */
  valueFormat?: GaugeChartValueFormat = 'Percentage';
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: GaugeChartOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IGaugeChart, 'type'>): GaugeChart {
    return new GaugeChart(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withShowTitle(showTitle = true): this {
    this.showTitle = showTitle;
    return this;
  }

  withColorSet(colorSet: ChartColorSet): this {
    this.colorSet = colorSet;
    return this;
  }

  withMaxWidth(maxWidth: string): this {
    this.maxWidth = maxWidth;
    return this;
  }

  withShowLegend(showLegend = false): this {
    this.showLegend = showLegend;
    return this;
  }

  withMin(min: number): this {
    this.min = min;
    return this;
  }

  withMax(max: number): this {
    this.max = max;
    return this;
  }

  withSubLabel(subLabel: string): this {
    this.subLabel = subLabel;
    return this;
  }

  withShowMinMax(showMinMax = false): this {
    this.showMinMax = showMinMax;
    return this;
  }

  withShowNeedle(showNeedle = false): this {
    this.showNeedle = showNeedle;
    return this;
  }

  withShowOutlines(showOutlines = false): this {
    this.showOutlines = showOutlines;
    return this;
  }

  withSegments(...segments: IGaugeChartLegend[]): this {
    this.segments = segments;
    return this;
  }

  withValue(value: number): this {
    this.value = value;
    return this;
  }

  withValueFormat(valueFormat: GaugeChartValueFormat): this {
    this.valueFormat = valueFormat;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * The legend of the chart.
 */
export interface IGaugeChartLegend {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The size of the segment.
   */
  size?: number;
  /**
   * The legend text associated with the segment.
   */
  legend?: string;
  /**
   * The color to use for the segment. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;
}

export type GaugeChartLegendOptions = Partial<IGaugeChartLegend>;

/**
 * The legend of the chart.
 */
export class GaugeChartLegend implements IGaugeChartLegend {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The size of the segment.
   */
  size?: number = 0;
  /**
   * The legend text associated with the segment.
   */
  legend?: string;
  /**
   * The color to use for the segment. See [Chart colors reference](https://adaptivecards.microsoft.com/?topic=chart-colors-reference).
   */
  color?: ChartColor;

  constructor(options: GaugeChartLegendOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IGaugeChartLegend): GaugeChartLegend {
    return new GaugeChartLegend(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withSize(size: number): this {
    this.size = size;
    return this;
  }

  withLegend(legend: string): this {
    this.legend = legend;
    return this;
  }

  withColor(color: ChartColor): this {
    this.color = color;
    return this;
  }
}

/**
 * A formatted and syntax-colored code block.
 */
export interface ICodeBlock {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **CodeBlock**.
   */
  readonly type: 'CodeBlock';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The code snippet to display.
   */
  codeSnippet?: string;
  /**
   * The language the code snippet is expressed in.
   */
  language?: CodeLanguage;
  /**
   * A number that represents the line in the file from where the code snippet was extracted.
   */
  startLineNumber?: number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ICodeBlock.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of CodeBlock, false otherwise.
 */
export function isCodeBlock(value: unknown): value is ICodeBlock {
  const obj = value as ICodeBlock;
  return typeof obj === 'object' && obj.type === 'CodeBlock';
}

export type CodeBlockOptions = Partial<Omit<ICodeBlock, 'type'>>;

/**
 * A formatted and syntax-colored code block.
 */
export class CodeBlock implements ICodeBlock {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **CodeBlock**.
   */
  readonly type = 'CodeBlock';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The code snippet to display.
   */
  codeSnippet?: string;
  /**
   * The language the code snippet is expressed in.
   */
  language?: CodeLanguage = 'PlainText';
  /**
   * A number that represents the line in the file from where the code snippet was extracted.
   */
  startLineNumber?: number = 1;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: CodeBlockOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ICodeBlock, 'type'>): CodeBlock {
    return new CodeBlock(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withCodeSnippet(codeSnippet: string): this {
    this.codeSnippet = codeSnippet;
    return this;
  }

  withLanguage(language: CodeLanguage): this {
    this.language = language;
    return this;
  }

  withStartLineNumber(startLineNumber: number): this {
    this.startLineNumber = startLineNumber;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Displays a user's information, including their profile picture.
 */
export interface IComUserMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type: 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Must be **graph.microsoft.com/user**.
   */
  readonly name: 'graph.microsoft.com/user';
  /**
   * The properties of the Persona component.
   */
  properties?: IPersonaProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IComUserMicrosoftGraphComponent.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ComUserMicrosoftGraphComponent, false otherwise.
 */
export function isComUserMicrosoftGraphComponent(
  value: unknown,
): value is IComUserMicrosoftGraphComponent {
  const obj = value as IComUserMicrosoftGraphComponent;
  return (
    typeof obj === 'object' &&
    obj.type === 'Component' &&
    obj.name === 'graph.microsoft.com/user'
  );
}

export type ComUserMicrosoftGraphComponentOptions = Partial<
  Omit<IComUserMicrosoftGraphComponent, 'type' | 'name'>
>;

/**
 * Displays a user's information, including their profile picture.
 */
export class ComUserMicrosoftGraphComponent implements IComUserMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type = 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Must be **graph.microsoft.com/user**.
   */
  readonly name = 'graph.microsoft.com/user';
  /**
   * The properties of the Persona component.
   */
  properties?: IPersonaProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ComUserMicrosoftGraphComponentOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IComUserMicrosoftGraphComponent, 'type' | 'name'>,
  ): ComUserMicrosoftGraphComponent {
    return new ComUserMicrosoftGraphComponent(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withProperties(properties: IPersonaProperties): this {
    this.properties = properties;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents the properties of a Persona component.
 */
export interface IPersonaProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Id of the persona.
   */
  id?: string;
  /**
   * The UPN of the persona.
   */
  userPrincipalName?: string;
  /**
   * The display name of the persona.
   */
  displayName?: string;
  /**
   * Defines the style of the icon for the persona.
   */
  iconStyle?: PersonaIconStyle;
  /**
   * Defines how the persona should be displayed.
   */
  style?: PersonaDisplayStyle;
}

export type PersonaPropertiesOptions = Partial<IPersonaProperties>;

/**
 * Represents the properties of a Persona component.
 */
export class PersonaProperties implements IPersonaProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Id of the persona.
   */
  id?: string;
  /**
   * The UPN of the persona.
   */
  userPrincipalName?: string;
  /**
   * The display name of the persona.
   */
  displayName?: string;
  /**
   * Defines the style of the icon for the persona.
   */
  iconStyle?: PersonaIconStyle;
  /**
   * Defines how the persona should be displayed.
   */
  style?: PersonaDisplayStyle;

  constructor(options: PersonaPropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IPersonaProperties): PersonaProperties {
    return new PersonaProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withUserPrincipalName(userPrincipalName: string): this {
    this.userPrincipalName = userPrincipalName;
    return this;
  }

  withDisplayName(displayName: string): this {
    this.displayName = displayName;
    return this;
  }

  withIconStyle(iconStyle: PersonaIconStyle): this {
    this.iconStyle = iconStyle;
    return this;
  }

  withStyle(style: PersonaDisplayStyle): this {
    this.style = style;
    return this;
  }
}

/**
 * Displays multiple users' information, including their profile pictures.
 */
export interface IComUsersMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type: 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Must be **graph.microsoft.com/users**.
   */
  readonly name: 'graph.microsoft.com/users';
  /**
   * The properties of the PersonaSet component.
   */
  properties?: IPersonaSetProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IComUsersMicrosoftGraphComponent.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ComUsersMicrosoftGraphComponent, false otherwise.
 */
export function isComUsersMicrosoftGraphComponent(
  value: unknown,
): value is IComUsersMicrosoftGraphComponent {
  const obj = value as IComUsersMicrosoftGraphComponent;
  return (
    typeof obj === 'object' &&
    obj.type === 'Component' &&
    obj.name === 'graph.microsoft.com/users'
  );
}

export type ComUsersMicrosoftGraphComponentOptions = Partial<
  Omit<IComUsersMicrosoftGraphComponent, 'type' | 'name'>
>;

/**
 * Displays multiple users' information, including their profile pictures.
 */
export class ComUsersMicrosoftGraphComponent implements IComUsersMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type = 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Must be **graph.microsoft.com/users**.
   */
  readonly name = 'graph.microsoft.com/users';
  /**
   * The properties of the PersonaSet component.
   */
  properties?: IPersonaSetProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ComUsersMicrosoftGraphComponentOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IComUsersMicrosoftGraphComponent, 'type' | 'name'>,
  ): ComUsersMicrosoftGraphComponent {
    return new ComUsersMicrosoftGraphComponent(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withProperties(properties: IPersonaSetProperties): this {
    this.properties = properties;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents the properties of a PersonaSet component.
 */
export interface IPersonaSetProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The users a PersonaSet component should display.
   */
  users?: IPersonaProperties[];
  /**
   * Defines the style of the icon for the personas in the set.
   */
  iconStyle?: PersonaIconStyle;
  /**
   * Defines how each persona in the set should be displayed.
   */
  style?: PersonaDisplayStyle;
}

export type PersonaSetPropertiesOptions = Partial<IPersonaSetProperties>;

/**
 * Represents the properties of a PersonaSet component.
 */
export class PersonaSetProperties implements IPersonaSetProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The users a PersonaSet component should display.
   */
  users?: IPersonaProperties[];
  /**
   * Defines the style of the icon for the personas in the set.
   */
  iconStyle?: PersonaIconStyle;
  /**
   * Defines how each persona in the set should be displayed.
   */
  style?: PersonaDisplayStyle;

  constructor(options: PersonaSetPropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IPersonaSetProperties): PersonaSetProperties {
    return new PersonaSetProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withUsers(...users: IPersonaProperties[]): this {
    this.users = users;
    return this;
  }

  withIconStyle(iconStyle: PersonaIconStyle): this {
    this.iconStyle = iconStyle;
    return this;
  }

  withStyle(style: PersonaDisplayStyle): this {
    this.style = style;
    return this;
  }
}

/**
 * Displays information about a generic graph resource.
 */
export interface IComResourceMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type: 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Must be **graph.microsoft.com/resource**.
   */
  readonly name: 'graph.microsoft.com/resource';
  /**
   * The properties of the resource.
   */
  properties?: IResourceProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IComResourceMicrosoftGraphComponent.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ComResourceMicrosoftGraphComponent, false otherwise.
 */
export function isComResourceMicrosoftGraphComponent(
  value: unknown,
): value is IComResourceMicrosoftGraphComponent {
  const obj = value as IComResourceMicrosoftGraphComponent;
  return (
    typeof obj === 'object' &&
    obj.type === 'Component' &&
    obj.name === 'graph.microsoft.com/resource'
  );
}

export type ComResourceMicrosoftGraphComponentOptions = Partial<
  Omit<IComResourceMicrosoftGraphComponent, 'type' | 'name'>
>;

/**
 * Displays information about a generic graph resource.
 */
export class ComResourceMicrosoftGraphComponent implements IComResourceMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type = 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Must be **graph.microsoft.com/resource**.
   */
  readonly name = 'graph.microsoft.com/resource';
  /**
   * The properties of the resource.
   */
  properties?: IResourceProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ComResourceMicrosoftGraphComponentOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IComResourceMicrosoftGraphComponent, 'type' | 'name'>,
  ): ComResourceMicrosoftGraphComponent {
    return new ComResourceMicrosoftGraphComponent(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withProperties(properties: IResourceProperties): this {
    this.properties = properties;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents the properties of a resource component.
 */
export interface IResourceProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Id of the resource.
   */
  id?: string;
  /**
   * The reference to the resource.
   */
  resourceReference?: Record<string, string>;
  /**
   * The visualization of the resource.
   */
  resourceVisualization?: IResourceVisualization;
}

export type ResourcePropertiesOptions = Partial<IResourceProperties>;

/**
 * Represents the properties of a resource component.
 */
export class ResourceProperties implements IResourceProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Id of the resource.
   */
  id?: string;
  /**
   * The reference to the resource.
   */
  resourceReference?: Record<string, string>;
  /**
   * The visualization of the resource.
   */
  resourceVisualization?: IResourceVisualization;

  constructor(options: ResourcePropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IResourceProperties): ResourceProperties {
    return new ResourceProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withResourceReference(resourceReference: Record<string, string>): this {
    this.resourceReference = resourceReference;
    return this;
  }

  withResourceVisualization(
    resourceVisualization: IResourceVisualization,
  ): this {
    this.resourceVisualization = resourceVisualization;
    return this;
  }
}

/**
 * Represents a visualization of a resource.
 */
export interface IResourceVisualization {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The media associated with the resource.
   */
  media?: string;
}

export type ResourceVisualizationOptions = Partial<IResourceVisualization>;

/**
 * Represents a visualization of a resource.
 */
export class ResourceVisualization implements IResourceVisualization {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The media associated with the resource.
   */
  media?: string;

  constructor(options: ResourceVisualizationOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IResourceVisualization): ResourceVisualization {
    return new ResourceVisualization(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withMedia(media: string): this {
    this.media = media;
    return this;
  }
}

/**
 * Displays information about a file resource.
 */
export interface IComFileMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type: 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Must be **graph.microsoft.com/file**.
   */
  readonly name: 'graph.microsoft.com/file';
  /**
   * The properties of the file.
   */
  properties?: IFileProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IComFileMicrosoftGraphComponent.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ComFileMicrosoftGraphComponent, false otherwise.
 */
export function isComFileMicrosoftGraphComponent(
  value: unknown,
): value is IComFileMicrosoftGraphComponent {
  const obj = value as IComFileMicrosoftGraphComponent;
  return (
    typeof obj === 'object' &&
    obj.type === 'Component' &&
    obj.name === 'graph.microsoft.com/file'
  );
}

export type ComFileMicrosoftGraphComponentOptions = Partial<
  Omit<IComFileMicrosoftGraphComponent, 'type' | 'name'>
>;

/**
 * Displays information about a file resource.
 */
export class ComFileMicrosoftGraphComponent implements IComFileMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type = 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Must be **graph.microsoft.com/file**.
   */
  readonly name = 'graph.microsoft.com/file';
  /**
   * The properties of the file.
   */
  properties?: IFileProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ComFileMicrosoftGraphComponentOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IComFileMicrosoftGraphComponent, 'type' | 'name'>,
  ): ComFileMicrosoftGraphComponent {
    return new ComFileMicrosoftGraphComponent(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withProperties(properties: IFileProperties): this {
    this.properties = properties;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * Represents the properties of a file component.
 */
export interface IFileProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the file.
   */
  name?: string;
  /**
   * The file extension.
   */
  extension?: string;
  /**
   * The URL of the file.
   */
  url?: string;
}

export type FilePropertiesOptions = Partial<IFileProperties>;

/**
 * Represents the properties of a file component.
 */
export class FileProperties implements IFileProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the file.
   */
  name?: string;
  /**
   * The file extension.
   */
  extension?: string;
  /**
   * The URL of the file.
   */
  url?: string;

  constructor(options: FilePropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IFileProperties): FileProperties {
    return new FileProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withExtension(extension: string): this {
    this.extension = extension;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }
}

/**
 * Displays information about a calendar event.
 */
export interface IComEventMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type: 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Must be **graph.microsoft.com/event**.
   */
  readonly name: 'graph.microsoft.com/event';
  /**
   * The properties of the event.
   */
  properties?: ICalendarEventProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IComEventMicrosoftGraphComponent.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ComEventMicrosoftGraphComponent, false otherwise.
 */
export function isComEventMicrosoftGraphComponent(
  value: unknown,
): value is IComEventMicrosoftGraphComponent {
  const obj = value as IComEventMicrosoftGraphComponent;
  return (
    typeof obj === 'object' &&
    obj.type === 'Component' &&
    obj.name === 'graph.microsoft.com/event'
  );
}

export type ComEventMicrosoftGraphComponentOptions = Partial<
  Omit<IComEventMicrosoftGraphComponent, 'type' | 'name'>
>;

/**
 * Displays information about a calendar event.
 */
export class ComEventMicrosoftGraphComponent implements IComEventMicrosoftGraphComponent {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **Component**.
   */
  readonly type = 'Component';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Must be **graph.microsoft.com/event**.
   */
  readonly name = 'graph.microsoft.com/event';
  /**
   * The properties of the event.
   */
  properties?: ICalendarEventProperties;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ComEventMicrosoftGraphComponentOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IComEventMicrosoftGraphComponent, 'type' | 'name'>,
  ): ComEventMicrosoftGraphComponent {
    return new ComEventMicrosoftGraphComponent(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withProperties(properties: ICalendarEventProperties): this {
    this.properties = properties;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * The properties of a calendar event.
 */
export interface ICalendarEventProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The ID of the event.
   */
  id?: string;
  /**
   * The title of the event.
   */
  title?: string;
  /**
   * The start date and time of the event.
   */
  start?: string;
  /**
   * The end date and time of the event.
   */
  end?: string;
  /**
   * The status of the event.
   */
  status?: string;
  /**
   * The locations of the event.
   */
  locations?: string[];
  /**
   * The URL of the online meeting.
   */
  onlineMeetingUrl?: string;
  /**
   * Indicates if the event is all day.
   */
  isAllDay?: boolean;
  /**
   * The extension of the event.
   */
  extension?: string;
  /**
   * The URL of the event.
   */
  url?: string;
  /**
   * The attendees of the event.
   */
  attendees?: ICalendarEventAttendee[];
  /**
   * The organizer of the event.
   */
  organizer?: ICalendarEventAttendee;
}

export type CalendarEventPropertiesOptions = Partial<ICalendarEventProperties>;

/**
 * The properties of a calendar event.
 */
export class CalendarEventProperties implements ICalendarEventProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The ID of the event.
   */
  id?: string;
  /**
   * The title of the event.
   */
  title?: string;
  /**
   * The start date and time of the event.
   */
  start?: string;
  /**
   * The end date and time of the event.
   */
  end?: string;
  /**
   * The status of the event.
   */
  status?: string;
  /**
   * The locations of the event.
   */
  locations?: string[];
  /**
   * The URL of the online meeting.
   */
  onlineMeetingUrl?: string;
  /**
   * Indicates if the event is all day.
   */
  isAllDay?: boolean;
  /**
   * The extension of the event.
   */
  extension?: string;
  /**
   * The URL of the event.
   */
  url?: string;
  /**
   * The attendees of the event.
   */
  attendees?: ICalendarEventAttendee[];
  /**
   * The organizer of the event.
   */
  organizer?: ICalendarEventAttendee;

  constructor(options: CalendarEventPropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ICalendarEventProperties): CalendarEventProperties {
    return new CalendarEventProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withStart(start: string): this {
    this.start = start;
    return this;
  }

  withEnd(end: string): this {
    this.end = end;
    return this;
  }

  withStatus(status: string): this {
    this.status = status;
    return this;
  }

  withLocations(...locations: string[]): this {
    this.locations = locations;
    return this;
  }

  withOnlineMeetingUrl(onlineMeetingUrl: string): this {
    this.onlineMeetingUrl = onlineMeetingUrl;
    return this;
  }

  withIsAllDay(isAllDay: boolean): this {
    this.isAllDay = isAllDay;
    return this;
  }

  withExtension(extension: string): this {
    this.extension = extension;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withAttendees(...attendees: ICalendarEventAttendee[]): this {
    this.attendees = attendees;
    return this;
  }

  withOrganizer(organizer: ICalendarEventAttendee): this {
    this.organizer = organizer;
    return this;
  }
}

/**
 * Represents a calendar event attendee.
 */
export interface ICalendarEventAttendee {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the attendee.
   */
  name?: string;
  /**
   * The email address of the attendee.
   */
  email?: string;
  /**
   * The title of the attendee.
   */
  title?: string;
  /**
   * The type of the attendee.
   */
  type?: string;
  /**
   * The status of the attendee.
   */
  status?: string;
}

export type CalendarEventAttendeeOptions = Partial<ICalendarEventAttendee>;

/**
 * Represents a calendar event attendee.
 */
export class CalendarEventAttendee implements ICalendarEventAttendee {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The name of the attendee.
   */
  name?: string;
  /**
   * The email address of the attendee.
   */
  email?: string;
  /**
   * The title of the attendee.
   */
  title?: string;
  /**
   * The type of the attendee.
   */
  type?: string;
  /**
   * The status of the attendee.
   */
  status?: string;

  constructor(options: CalendarEventAttendeeOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ICalendarEventAttendee): CalendarEventAttendee {
    return new CalendarEventAttendee(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withEmail(email: string): this {
    this.email = email;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withType(type: string): this {
    this.type = type;
    return this;
  }

  withStatus(status: string): this {
    this.status = status;
    return this;
  }
}

/**
 * A page inside a Carousel element.
 */
export interface ICarouselPage {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **CarouselPage**.
   */
  readonly type: 'CarouselPage';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The elements in the page.
   */
  items: CardElementArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ICarouselPage.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of CarouselPage, false otherwise.
 */
export function isCarouselPage(value: unknown): value is ICarouselPage {
  const obj = value as ICarouselPage;
  return typeof obj === 'object' && obj.type === 'CarouselPage';
}

export type CarouselPageOptions = Partial<
  Omit<ICarouselPage, 'type' | 'items'>
>;

/**
 * A page inside a Carousel element.
 */
export class CarouselPage implements ICarouselPage {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **CarouselPage**.
   */
  readonly type = 'CarouselPage';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean = false;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean = false;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The elements in the page.
   */
  items: CardElementArray;

  constructor(...items: CardElementArray) {
    this.items = items;
  }

  withOptions(value: CarouselPageOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withShowBorder(showBorder = true): this {
    this.showBorder = showBorder;
    return this;
  }

  withRoundedCorners(roundedCorners = true): this {
    this.roundedCorners = roundedCorners;
    return this;
  }

  withLayouts(
    ...layouts: (IStackLayout | IFlowLayout | IAreaGridLayout)[]
  ): this {
    this.layouts = layouts;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withBackgroundImage(backgroundImage: string | IBackgroundImage): this {
    this.backgroundImage = backgroundImage;
    return this;
  }

  withVerticalContentAlignment(
    verticalContentAlignment: VerticalAlignment,
  ): this {
    this.verticalContentAlignment = verticalContentAlignment;
    return this;
  }

  withRtl(rtl: boolean): this {
    this.rtl = rtl;
    return this;
  }

  withMaxHeight(maxHeight: string): this {
    this.maxHeight = maxHeight;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withItems(...items: CardElementArray): this {
    this.items = items;
    return this;
  }
}

/**
 * Represents a row of cells in a table.
 */
export interface ITableRow {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TableRow**.
   */
  readonly type: 'TableRow';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls how the content of every cell in the row should be horizontally aligned by default. This property overrides the horizontalCellContentAlignment property of the table and columns.
   */
  horizontalCellContentAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of every cell in the row should be vertically aligned by default. This property overrides the verticalCellContentAlignment property of the table and columns.
   */
  verticalCellContentAlignment?: VerticalAlignment;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The cells in the row.
   */
  cells?: TableCellArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITableRow.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TableRow, false otherwise.
 */
export function isTableRow(value: unknown): value is ITableRow {
  const obj = value as ITableRow;
  return typeof obj === 'object' && obj.type === 'TableRow';
}

export type TableRowOptions = Partial<Omit<ITableRow, 'type'>>;

/**
 * Represents a row of cells in a table.
 */
export class TableRow implements ITableRow {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TableRow**.
   */
  readonly type = 'TableRow';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean = false;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean = false;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls how the content of every cell in the row should be horizontally aligned by default. This property overrides the horizontalCellContentAlignment property of the table and columns.
   */
  horizontalCellContentAlignment?: HorizontalAlignment;
  /**
   * Controls how the content of every cell in the row should be vertically aligned by default. This property overrides the verticalCellContentAlignment property of the table and columns.
   */
  verticalCellContentAlignment?: VerticalAlignment;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The cells in the row.
   */
  cells?: TableCellArray;

  constructor(options: TableRowOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<ITableRow, 'type'>): TableRow {
    return new TableRow(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withShowBorder(showBorder = true): this {
    this.showBorder = showBorder;
    return this;
  }

  withRoundedCorners(roundedCorners = true): this {
    this.roundedCorners = roundedCorners;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withHorizontalCellContentAlignment(
    horizontalCellContentAlignment: HorizontalAlignment,
  ): this {
    this.horizontalCellContentAlignment = horizontalCellContentAlignment;
    return this;
  }

  withVerticalCellContentAlignment(
    verticalCellContentAlignment: VerticalAlignment,
  ): this {
    this.verticalCellContentAlignment = verticalCellContentAlignment;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withCells(...cells: TableCellArray): this {
    this.cells = cells;
    return this;
  }
}

/**
 * Represents a cell in a table row.
 */
export interface ITableCell {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TableCell**.
   */
  readonly type: 'TableCell';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The items (elements) in the cell.
   */
  items: CardElementArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITableCell.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TableCell, false otherwise.
 */
export function isTableCell(value: unknown): value is ITableCell {
  const obj = value as ITableCell;
  return typeof obj === 'object' && obj.type === 'TableCell';
}

export type TableCellOptions = Partial<Omit<ITableCell, 'type' | 'items'>>;

/**
 * Represents a cell in a table row.
 */
export class TableCell implements ITableCell {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TableCell**.
   */
  readonly type = 'TableCell';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean = false;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The items (elements) in the cell.
   */
  items: CardElementArray;

  constructor(...items: CardElementArray) {
    this.items = items;
  }

  withOptions(value: TableCellOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withLayouts(
    ...layouts: (IStackLayout | IFlowLayout | IAreaGridLayout)[]
  ): this {
    this.layouts = layouts;
    return this;
  }

  withBleed(bleed = true): this {
    this.bleed = bleed;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withBackgroundImage(backgroundImage: string | IBackgroundImage): this {
    this.backgroundImage = backgroundImage;
    return this;
  }

  withVerticalContentAlignment(
    verticalContentAlignment: VerticalAlignment,
  ): this {
    this.verticalContentAlignment = verticalContentAlignment;
    return this;
  }

  withRtl(rtl: boolean): this {
    this.rtl = rtl;
    return this;
  }

  withMaxHeight(maxHeight: string): this {
    this.maxHeight = maxHeight;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withItems(...items: CardElementArray): this {
    this.items = items;
    return this;
  }
}

/**
 * A block of text inside a RichTextBlock element.
 */
export interface ITextRun {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TextRun**.
   */
  readonly type: 'TextRun';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The text to display. A subset of markdown is supported.
   */
  text: string;
  /**
   * The size of the text.
   */
  size?: TextSize;
  /**
   * The weight of the text.
   */
  weight?: TextWeight;
  /**
   * The color of the text.
   */
  color?: TextColor;
  /**
   * Controls whether the text should be renderer using a subtler variant of the select color.
   */
  isSubtle?: boolean;
  /**
   * The type of font to use for rendering.
   */
  fontType?: FontType;
  /**
   * Controls if the text should be italicized.
   */
  italic?: boolean;
  /**
   * Controls if the text should be struck through.
   */
  strikethrough?: boolean;
  /**
   * Controls if the text should be highlighted.
   */
  highlight?: boolean;
  /**
   * Controls if the text should be underlined.
   */
  underline?: boolean;
  /**
   * An Action that will be invoked when the text is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITextRun.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TextRun, false otherwise.
 */
export function isTextRun(value: unknown): value is ITextRun {
  const obj = value as ITextRun;
  return typeof obj === 'object' && obj.type === 'TextRun';
}

export type TextRunOptions = Partial<Omit<ITextRun, 'type' | 'text'>>;

/**
 * A block of text inside a RichTextBlock element.
 */
export class TextRun implements ITextRun {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **TextRun**.
   */
  readonly type = 'TextRun';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The text to display. A subset of markdown is supported.
   */
  text: string;
  /**
   * The size of the text.
   */
  size?: TextSize;
  /**
   * The weight of the text.
   */
  weight?: TextWeight;
  /**
   * The color of the text.
   */
  color?: TextColor;
  /**
   * Controls whether the text should be renderer using a subtler variant of the select color.
   */
  isSubtle?: boolean;
  /**
   * The type of font to use for rendering.
   */
  fontType?: FontType;
  /**
   * Controls if the text should be italicized.
   */
  italic?: boolean = false;
  /**
   * Controls if the text should be struck through.
   */
  strikethrough?: boolean = false;
  /**
   * Controls if the text should be highlighted.
   */
  highlight?: boolean = false;
  /**
   * Controls if the text should be underlined.
   */
  underline?: boolean = false;
  /**
   * An Action that will be invoked when the text is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(text: string, options: TextRunOptions = {}) {
    Object.assign(this, options);
    this.text = text;
  }

  static from(options: Omit<ITextRun, 'type'>): TextRun {
    return new TextRun(options.text, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withText(text: string): this {
    this.text = text;
    return this;
  }

  withSize(size: TextSize): this {
    this.size = size;
    return this;
  }

  withWeight(weight: TextWeight): this {
    this.weight = weight;
    return this;
  }

  withColor(color: TextColor): this {
    this.color = color;
    return this;
  }

  withIsSubtle(isSubtle: boolean): this {
    this.isSubtle = isSubtle;
    return this;
  }

  withFontType(fontType: FontType): this {
    this.fontType = fontType;
    return this;
  }

  withItalic(italic = true): this {
    this.italic = italic;
    return this;
  }

  withStrikethrough(strikethrough = true): this {
    this.strikethrough = strikethrough;
    return this;
  }

  withHighlight(highlight = true): this {
    this.highlight = highlight;
    return this;
  }

  withUnderline(underline = true): this {
    this.underline = underline;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An inline icon inside a RichTextBlock element.
 */
export interface IIconRun {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **IconRun**.
   */
  readonly type: 'IconRun';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The name of the inline icon to display.
   */
  name?: string;
  /**
   * The size of the inline icon.
   */
  size?: 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge';
  /**
   * The style of the inline icon.
   */
  style?: IconStyle;
  /**
   * The color of the inline icon.
   */
  color?: TextColor;
  /**
   * An Action that will be invoked when the inline icon is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IIconRun.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of IconRun, false otherwise.
 */
export function isIconRun(value: unknown): value is IIconRun {
  const obj = value as IIconRun;
  return typeof obj === 'object' && obj.type === 'IconRun';
}

export type IconRunOptions = Partial<Omit<IIconRun, 'type'>>;

/**
 * An inline icon inside a RichTextBlock element.
 */
export class IconRun implements IIconRun {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **IconRun**.
   */
  readonly type = 'IconRun';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The name of the inline icon to display.
   */
  name?: string;
  /**
   * The size of the inline icon.
   */
  size?: 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge' = 'Default';
  /**
   * The style of the inline icon.
   */
  style?: IconStyle = 'Regular';
  /**
   * The color of the inline icon.
   */
  color?: TextColor = 'Default';
  /**
   * An Action that will be invoked when the inline icon is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: IconRunOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IIconRun, 'type'>): IconRun {
    return new IconRun(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withSize(
    size: 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge',
  ): this {
    this.size = size;
    return this;
  }

  withStyle(style: IconStyle): this {
    this.style = style;
    return this;
  }

  withColor(color: TextColor): this {
    this.color = color;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * An inline image inside a RichTextBlock element.
 */
export interface IImageRun {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ImageRun**.
   */
  readonly type: 'ImageRun';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * The URL (or Base64-encoded Data URI) of the image. Acceptable formats are PNG, JPEG, GIF and SVG.
   */
  url?: string;
  /**
   * The size of the inline image.
   */
  size?: 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge';
  /**
   * The style of the inline image.
   */
  style?: ImageStyle;
  /**
   * An Action that will be invoked when the image is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * A set of theme-specific image URLs.
   */
  themedUrls?: IThemedUrl[];
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IImageRun.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ImageRun, false otherwise.
 */
export function isImageRun(value: unknown): value is IImageRun {
  const obj = value as IImageRun;
  return typeof obj === 'object' && obj.type === 'ImageRun';
}

export type ImageRunOptions = Partial<Omit<IImageRun, 'type'>>;

/**
 * An inline image inside a RichTextBlock element.
 */
export class ImageRun implements IImageRun {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **ImageRun**.
   */
  readonly type = 'ImageRun';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * The URL (or Base64-encoded Data URI) of the image. Acceptable formats are PNG, JPEG, GIF and SVG.
   */
  url?: string;
  /**
   * The size of the inline image.
   */
  size?: 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge' = 'Default';
  /**
   * The style of the inline image.
   */
  style?: ImageStyle = 'Default';
  /**
   * An Action that will be invoked when the image is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * A set of theme-specific image URLs.
   */
  themedUrls?: IThemedUrl[];
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;

  constructor(options: ImageRunOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IImageRun, 'type'>): ImageRun {
    return new ImageRun(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withUrl(url: string): this {
    this.url = url;
    return this;
  }

  withSize(
    size: 'Small' | 'Default' | 'Medium' | 'Large' | 'ExtraLarge',
  ): this {
    this.size = size;
    return this;
  }

  withStyle(style: ImageStyle): this {
    this.style = style;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withThemedUrls(...themedUrls: IThemedUrl[]): this {
    this.themedUrls = themedUrls;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }
}

/**
 * A column in a ColumnSet element.
 */
export interface IColumn {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Optional. If specified, must be **Column**.
   */
  readonly type: 'Column';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities;
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight;
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing;
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The width of the column. If expressed as a number, represents the relative weight of the column in the set. If expressed as a string, `auto` will automatically adjust the column's width according to its content, `stretch` will make the column use the remaining horizontal space (shared with other columns with width set to `stretch`) and using the `<number>px` format will give the column an explicit width in pixels.
   */
  width?: 'auto' | 'stretch' | string | number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The elements in the column.
   */
  items: CardElementArray;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IColumn.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Column, false otherwise.
 */
export function isColumn(value: unknown): value is IColumn {
  const obj = value as IColumn;
  return typeof obj === 'object' && obj.type === 'Column';
}

export type ColumnOptions = Partial<Omit<IColumn, 'type' | 'items'>>;

/**
 * A column in a ColumnSet element.
 */
export class Column implements IColumn {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Optional. If specified, must be **Column**.
   */
  readonly type = 'Column';
  /**
   * A unique identifier for the element or action. Input elements must have an id, otherwise they will not be validated and their values will not be sent to the Bot.
   */
  id?: string;
  /**
   * A list of capabilities the element requires the host application to support. If the host application doesn't support at least one of the listed capabilities, the element is not rendered (or its fallback is rendered if provided).
   */
  requires?: IHostCapabilities = {};
  /**
   * The locale associated with the element.
   */
  lang?: string;
  /**
   * Controls the visibility of the element.
   */
  isVisible?: boolean = true;
  /**
   * Controls whether a separator line should be displayed above the element to visually separate it from the previous element. No separator will be displayed for the first element in a container, even if this property is set to true.
   */
  separator?: boolean = false;
  /**
   * The height of the element. When set to stretch, the element will use the remaining vertical space in its container.
   */
  height?: ElementHeight = 'auto';
  /**
   * Controls how the element should be horizontally aligned.
   */
  horizontalAlignment?: HorizontalAlignment;
  /**
   * Controls the amount of space between this element and the previous one. No space will be added for the first element in a container.
   */
  spacing?: Spacing = 'Default';
  /**
   * Controls for which card width the element should be displayed. If targetWidth isn't specified, the element is rendered at all card widths. Using targetWidth makes it possible to author responsive cards that adapt their layout to the available horizontal space. For more details, see [Responsive layout](https://adaptivecards.microsoft.com/?topic=responsive-layout).
   */
  targetWidth?: TargetWidth;
  /**
   * Controls whether the element should be used as a sort key by elements that allow sorting across a collection of elements.
   */
  isSortKey?: boolean = false;
  /**
   * An Action that will be invoked when the element is tapped or clicked. Action.ShowCard is not supported.
   */
  selectAction?:
    | IExecuteAction
    | IInsertImageAction
    | IOpenUrlAction
    | IOpenUrlDialogAction
    | IPopoverAction
    | IResetInputsAction
    | ISubmitAction
    | IToggleVisibilityAction;
  /**
   * The style of the container. Container styles control the colors of the background, border and text inside the container, in such a way that contrast requirements are always met.
   */
  style?: ContainerStyle;
  /**
   * Controls if a border should be displayed around the container.
   */
  showBorder?: boolean = false;
  /**
   * Controls if the container should have rounded corners.
   */
  roundedCorners?: boolean = false;
  /**
   * The layouts associated with the container. The container can dynamically switch from one layout to another as the card's width changes. See [Container layouts](https://adaptivecards.microsoft.com/?topic=container-layouts) for more details.
   */
  layouts?: (IStackLayout | IFlowLayout | IAreaGridLayout)[];
  /**
   * Controls if the container should bleed into its parent. A bleeding container extends into its parent's padding.
   */
  bleed?: boolean = false;
  /**
   * The minimum height, in pixels, of the container, in the `<number>px` format.
   */
  minHeight?: string;
  /**
   * Defines the container's background image.
   */
  backgroundImage?: string | IBackgroundImage;
  /**
   * Controls how the container's content should be vertically aligned.
   */
  verticalContentAlignment?: VerticalAlignment;
  /**
   * Controls if the content of the card is to be rendered left-to-right or right-to-left.
   */
  rtl?: boolean;
  /**
   * The maximum height, in pixels, of the container, in the `<number>px` format. When the content of a container exceeds the container's maximum height, a vertical scrollbar is displayed.
   */
  maxHeight?: string;
  /**
   * The width of the column. If expressed as a number, represents the relative weight of the column in the set. If expressed as a string, `auto` will automatically adjust the column's width according to its content, `stretch` will make the column use the remaining horizontal space (shared with other columns with width set to `stretch`) and using the `<number>px` format will give the column an explicit width in pixels.
   */
  width?: 'auto' | 'stretch' | string | number;
  /**
   * The area of a Layout.AreaGrid layout in which an element should be displayed.
   */
  'grid.area'?: string;
  /**
   * An alternate element to render if the type of this one is unsupported or if the host application doesn't support all the capabilities specified in the requires property.
   */
  fallback?: FallbackElement;
  /**
   * The elements in the column.
   */
  items: CardElementArray;

  constructor(...items: CardElementArray) {
    this.items = items;
  }

  withOptions(value: ColumnOptions): this {
    Object.assign(this, value);
    return this;
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withRequires(requires: IHostCapabilities): this {
    this.requires = requires;
    return this;
  }

  withLang(lang: string): this {
    this.lang = lang;
    return this;
  }

  withIsVisible(isVisible = false): this {
    this.isVisible = isVisible;
    return this;
  }

  withSeparator(separator = true): this {
    this.separator = separator;
    return this;
  }

  withHeight(height: ElementHeight): this {
    this.height = height;
    return this;
  }

  withHorizontalAlignment(horizontalAlignment: HorizontalAlignment): this {
    this.horizontalAlignment = horizontalAlignment;
    return this;
  }

  withSpacing(spacing: Spacing): this {
    this.spacing = spacing;
    return this;
  }

  withTargetWidth(targetWidth: TargetWidth): this {
    this.targetWidth = targetWidth;
    return this;
  }

  withIsSortKey(isSortKey = true): this {
    this.isSortKey = isSortKey;
    return this;
  }

  withSelectAction(
    selectAction:
      | IExecuteAction
      | IInsertImageAction
      | IOpenUrlAction
      | IOpenUrlDialogAction
      | IPopoverAction
      | IResetInputsAction
      | ISubmitAction
      | IToggleVisibilityAction,
  ): this {
    this.selectAction = selectAction;
    return this;
  }

  withStyle(style: ContainerStyle): this {
    this.style = style;
    return this;
  }

  withShowBorder(showBorder = true): this {
    this.showBorder = showBorder;
    return this;
  }

  withRoundedCorners(roundedCorners = true): this {
    this.roundedCorners = roundedCorners;
    return this;
  }

  withLayouts(
    ...layouts: (IStackLayout | IFlowLayout | IAreaGridLayout)[]
  ): this {
    this.layouts = layouts;
    return this;
  }

  withBleed(bleed = true): this {
    this.bleed = bleed;
    return this;
  }

  withMinHeight(minHeight: string): this {
    this.minHeight = minHeight;
    return this;
  }

  withBackgroundImage(backgroundImage: string | IBackgroundImage): this {
    this.backgroundImage = backgroundImage;
    return this;
  }

  withVerticalContentAlignment(
    verticalContentAlignment: VerticalAlignment,
  ): this {
    this.verticalContentAlignment = verticalContentAlignment;
    return this;
  }

  withRtl(rtl: boolean): this {
    this.rtl = rtl;
    return this;
  }

  withMaxHeight(maxHeight: string): this {
    this.maxHeight = maxHeight;
    return this;
  }

  withWidth(width: 'auto' | 'stretch' | string | number): this {
    this.width = width;
    return this;
  }

  withFallback(fallback: FallbackElement): this {
    this.fallback = fallback;
    return this;
  }

  withItems(...items: CardElementArray): this {
    this.items = items;
    return this;
  }
}

/**
 * Represents the data of an Action.Submit.
 */
export interface ISubmitActionData extends Record<string, any> {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  /**
   * Defines the optional Teams-specific portion of the action's data.
   */
}

export type SubmitActionDataOptions = Partial<ISubmitActionData>;

/**
 * Represents the data of an Action.Submit.
 */
export class SubmitActionData implements ISubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  /**
   * Defines the optional Teams-specific portion of the action's data.
   */

  constructor(options: SubmitActionDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ISubmitActionData): SubmitActionData {
    return new SubmitActionData(options);
  }
  [key: string]: any;
}

/**
 * Represents Teams-specific data in an Action.Submit to send an Instant Message back to the Bot.
 */
export interface IImBackSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **imBack**.
   */
  readonly type: 'imBack';
  /**
   * The value that will be sent to the Bot.
   */
  value: string;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IImBackSubmitActionData.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of ImBackSubmitActionData, false otherwise.
 */
export function isImBackSubmitActionData(
  value: unknown,
): value is IImBackSubmitActionData {
  const obj = value as IImBackSubmitActionData;
  return typeof obj === 'object' && obj.type === 'imBack';
}

export type ImBackSubmitActionDataOptions = Partial<
  Omit<IImBackSubmitActionData, 'type' | 'value'>
>;

/**
 * Represents Teams-specific data in an Action.Submit to send an Instant Message back to the Bot.
 */
export class ImBackSubmitActionData implements IImBackSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **imBack**.
   */
  readonly type = 'imBack';
  /**
   * The value that will be sent to the Bot.
   */
  value: string;

  constructor(value: string, options: ImBackSubmitActionDataOptions = {}) {
    Object.assign(this, options);
    this.value = value;
  }

  static from(
    options: Omit<IImBackSubmitActionData, 'type'>,
  ): ImBackSubmitActionData {
    return new ImBackSubmitActionData(options.value, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }
}

/**
 * Represents Teams-specific data in an Action.Submit to make an Invoke request to the Bot.
 */
export interface IInvokeSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **invoke**.
   */
  readonly type: 'invoke';
  /**
   * The object to send to the Bot with the Invoke request. Can be strongly typed as one of the below values to trigger a specific action in Teams.
   */
  value: any | ICollabStageInvokeDataValue;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IInvokeSubmitActionData.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of InvokeSubmitActionData, false otherwise.
 */
export function isInvokeSubmitActionData(
  value: unknown,
): value is IInvokeSubmitActionData {
  const obj = value as IInvokeSubmitActionData;
  return typeof obj === 'object' && obj.type === 'invoke';
}

export type InvokeSubmitActionDataOptions = Partial<
  Omit<IInvokeSubmitActionData, 'type' | 'value'>
>;

/**
 * Represents Teams-specific data in an Action.Submit to make an Invoke request to the Bot.
 */
export class InvokeSubmitActionData implements IInvokeSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **invoke**.
   */
  readonly type = 'invoke';
  /**
   * The object to send to the Bot with the Invoke request. Can be strongly typed as one of the below values to trigger a specific action in Teams.
   */
  value: any | ICollabStageInvokeDataValue;

  constructor(
    value?: any | ICollabStageInvokeDataValue,
    options: InvokeSubmitActionDataOptions = {},
  ) {
    Object.assign(this, options);
    this.value = value;
  }

  static from(
    options: Omit<IInvokeSubmitActionData, 'type'>,
  ): InvokeSubmitActionData {
    return new InvokeSubmitActionData(options.value, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withValue(value: any | ICollabStageInvokeDataValue): this {
    this.value = value;
    return this;
  }
}

/**
 * Data for invoking a collaboration stage action.
 */
export interface ICollabStageInvokeDataValue {
  /**
   * Must be **tab/tabInfoAction**.
   */
  readonly type: 'tab/tabInfoAction';
  /**
   * Provides information about the iFrame content, rendered in the collab stage popout window.
   */
  tabInfo?: ITabInfo;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ICollabStageInvokeDataValue.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of CollabStageInvokeDataValue, false otherwise.
 */
export function isCollabStageInvokeDataValue(
  value: unknown,
): value is ICollabStageInvokeDataValue {
  const obj = value as ICollabStageInvokeDataValue;
  return typeof obj === 'object' && obj.type === 'tab/tabInfoAction';
}

export type CollabStageInvokeDataValueOptions = Partial<
  Omit<ICollabStageInvokeDataValue, 'type'>
>;

/**
 * Data for invoking a collaboration stage action.
 */
export class CollabStageInvokeDataValue implements ICollabStageInvokeDataValue {
  /**
   * Must be **tab/tabInfoAction**.
   */
  readonly type = 'tab/tabInfoAction';
  /**
   * Provides information about the iFrame content, rendered in the collab stage popout window.
   */
  tabInfo?: ITabInfo;

  constructor(options: CollabStageInvokeDataValueOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<ICollabStageInvokeDataValue, 'type'>,
  ): CollabStageInvokeDataValue {
    return new CollabStageInvokeDataValue(options);
  }

  withTabInfo(tabInfo: ITabInfo): this {
    this.tabInfo = tabInfo;
    return this;
  }
}

/**
 * Represents information about the iFrame content, rendered in the collab stage popout window.
 */
export interface ITabInfo {
  /**
   * The name for the content. This will be displayed as the title of the window hosting the iFrame.
   */
  name?: string;
  /**
   * The URL to open in an iFrame.
   */
  contentUrl?: string;
  /**
   * The unique entity id for this content (e.g., random UUID).
   */
  entityId?: string;
  /**
   * An optional website URL to the content, allowing users to open this content in the browser (if they prefer).
   */
  websiteUrl?: string;
}

export type TabInfoOptions = Partial<ITabInfo>;

/**
 * Represents information about the iFrame content, rendered in the collab stage popout window.
 */
export class TabInfo implements ITabInfo {
  /**
   * The name for the content. This will be displayed as the title of the window hosting the iFrame.
   */
  name?: string;
  /**
   * The URL to open in an iFrame.
   */
  contentUrl?: string;
  /**
   * The unique entity id for this content (e.g., random UUID).
   */
  entityId?: string;
  /**
   * An optional website URL to the content, allowing users to open this content in the browser (if they prefer).
   */
  websiteUrl?: string;

  constructor(options: TabInfoOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ITabInfo): TabInfo {
    return new TabInfo(options);
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withContentUrl(contentUrl: string): this {
    this.contentUrl = contentUrl;
    return this;
  }

  withEntityId(entityId: string): this {
    this.entityId = entityId;
    return this;
  }

  withWebsiteUrl(websiteUrl: string): this {
    this.websiteUrl = websiteUrl;
    return this;
  }
}

/**
 * Represents Teams-specific data in an Action.Submit to send a message back to the Bot.
 */
export interface IMessageBackSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **messageBack**.
   */
  readonly type: 'messageBack';
  /**
   * The text that will be sent to the Bot.
   */
  text?: string;
  /**
   * The optional text that will be displayed as a new message in the conversation, as if the end-user sent it. `displayText` is not sent to the Bot.
   */
  displayText?: string;
  /**
   * Optional additional value that will be sent to the Bot. For instance, `value` can encode specific context for the action, such as unique identifiers or a JSON object.
   */
  value?: any;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IMessageBackSubmitActionData.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of MessageBackSubmitActionData, false otherwise.
 */
export function isMessageBackSubmitActionData(
  value: unknown,
): value is IMessageBackSubmitActionData {
  const obj = value as IMessageBackSubmitActionData;
  return typeof obj === 'object' && obj.type === 'messageBack';
}

export type MessageBackSubmitActionDataOptions = Partial<
  Omit<IMessageBackSubmitActionData, 'type'>
>;

/**
 * Represents Teams-specific data in an Action.Submit to send a message back to the Bot.
 */
export class MessageBackSubmitActionData implements IMessageBackSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **messageBack**.
   */
  readonly type = 'messageBack';
  /**
   * The text that will be sent to the Bot.
   */
  text?: string;
  /**
   * The optional text that will be displayed as a new message in the conversation, as if the end-user sent it. `displayText` is not sent to the Bot.
   */
  displayText?: string;
  /**
   * Optional additional value that will be sent to the Bot. For instance, `value` can encode specific context for the action, such as unique identifiers or a JSON object.
   */
  value?: any;

  constructor(options: MessageBackSubmitActionDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<IMessageBackSubmitActionData, 'type'>,
  ): MessageBackSubmitActionData {
    return new MessageBackSubmitActionData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withText(text: string): this {
    this.text = text;
    return this;
  }

  withDisplayText(displayText: string): this {
    this.displayText = displayText;
    return this;
  }

  withValue(value: any): this {
    this.value = value;
    return this;
  }
}

/**
 * Represents Teams-specific data in an Action.Submit to sign in a user.
 */
export interface ISigninSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **signin**.
   */
  readonly type: 'signin';
  /**
   * The URL to redirect the end-user for signing in.
   */
  value: string;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ISigninSubmitActionData.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of SigninSubmitActionData, false otherwise.
 */
export function isSigninSubmitActionData(
  value: unknown,
): value is ISigninSubmitActionData {
  const obj = value as ISigninSubmitActionData;
  return typeof obj === 'object' && obj.type === 'signin';
}

export type SigninSubmitActionDataOptions = Partial<
  Omit<ISigninSubmitActionData, 'type' | 'value'>
>;

/**
 * Represents Teams-specific data in an Action.Submit to sign in a user.
 */
export class SigninSubmitActionData implements ISigninSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **signin**.
   */
  readonly type = 'signin';
  /**
   * The URL to redirect the end-user for signing in.
   */
  value: string;

  constructor(value: string, options: SigninSubmitActionDataOptions = {}) {
    Object.assign(this, options);
    this.value = value;
  }

  static from(
    options: Omit<ISigninSubmitActionData, 'type'>,
  ): SigninSubmitActionData {
    return new SigninSubmitActionData(options.value, options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }
}

/**
 * Represents Teams-specific data in an Action.Submit to open a task module.
 */
export interface ITaskFetchSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **task/fetch**.
   */
  readonly type: 'task/fetch';
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type ITaskFetchSubmitActionData.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of TaskFetchSubmitActionData, false otherwise.
 */
export function isTaskFetchSubmitActionData(
  value: unknown,
): value is ITaskFetchSubmitActionData {
  const obj = value as ITaskFetchSubmitActionData;
  return typeof obj === 'object' && obj.type === 'task/fetch';
}

export type TaskFetchSubmitActionDataOptions = Partial<
  Omit<ITaskFetchSubmitActionData, 'type'>
>;

/**
 * Represents Teams-specific data in an Action.Submit to open a task module.
 */
export class TaskFetchSubmitActionData implements ITaskFetchSubmitActionData {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **task/fetch**.
   */
  readonly type = 'task/fetch';

  constructor(options: TaskFetchSubmitActionDataOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: Omit<ITaskFetchSubmitActionData, 'type'>,
  ): TaskFetchSubmitActionData {
    return new TaskFetchSubmitActionData(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }
}

/**
 * Teams-specific properties associated with the action.
 */
export interface ITeamsSubmitActionProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Defines how feedback is provided to the end-user when the action is executed.
   */
  feedback?: ITeamsSubmitActionFeedback;
}

export type TeamsSubmitActionPropertiesOptions =
  Partial<ITeamsSubmitActionProperties>;

/**
 * Teams-specific properties associated with the action.
 */
export class TeamsSubmitActionProperties implements ITeamsSubmitActionProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Defines how feedback is provided to the end-user when the action is executed.
   */
  feedback?: ITeamsSubmitActionFeedback;

  constructor(options: TeamsSubmitActionPropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(
    options: ITeamsSubmitActionProperties,
  ): TeamsSubmitActionProperties {
    return new TeamsSubmitActionProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withFeedback(feedback: ITeamsSubmitActionFeedback): this {
    this.feedback = feedback;
    return this;
  }
}

/**
 * Represents feedback options for an [Action.Submit](https://adaptivecards.microsoft.com/?topic=Action.Submit).
 */
export interface ITeamsSubmitActionFeedback {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Defines if a feedback message should be displayed after the action is executed.
   */
  hide?: boolean;
}

export type TeamsSubmitActionFeedbackOptions =
  Partial<ITeamsSubmitActionFeedback>;

/**
 * Represents feedback options for an [Action.Submit](https://adaptivecards.microsoft.com/?topic=Action.Submit).
 */
export class TeamsSubmitActionFeedback implements ITeamsSubmitActionFeedback {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Defines if a feedback message should be displayed after the action is executed.
   */
  hide?: boolean;

  constructor(options: TeamsSubmitActionFeedbackOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ITeamsSubmitActionFeedback): TeamsSubmitActionFeedback {
    return new TeamsSubmitActionFeedback(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withHide(hide: boolean): this {
    this.hide = hide;
    return this;
  }
}

/**
 * Defines how a card can be refreshed by making a request to the target Bot.
 */
export interface IRefreshDefinition {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Action.Execute action to invoke to refresh the card.
   */
  action?: IExecuteAction;
  /**
   * The list of user Ids for which the card will be automatically refreshed. In Teams, in chats or channels with more than 60 users, the card will automatically refresh only for users specified in the userIds list. Other users will have to manually click on a "refresh" button. In contexts with fewer than 60 users, the card will automatically refresh for all users.
   */
  userIds?: string[];
}

export type RefreshDefinitionOptions = Partial<IRefreshDefinition>;

/**
 * Defines how a card can be refreshed by making a request to the target Bot.
 */
export class RefreshDefinition implements IRefreshDefinition {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Action.Execute action to invoke to refresh the card.
   */
  action?: IExecuteAction;
  /**
   * The list of user Ids for which the card will be automatically refreshed. In Teams, in chats or channels with more than 60 users, the card will automatically refresh only for users specified in the userIds list. Other users will have to manually click on a "refresh" button. In contexts with fewer than 60 users, the card will automatically refresh for all users.
   */
  userIds?: string[];

  constructor(options: RefreshDefinitionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IRefreshDefinition): RefreshDefinition {
    return new RefreshDefinition(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withAction(action: IExecuteAction): this {
    this.action = action;
    return this;
  }

  withUserIds(...userIds: string[]): this {
    this.userIds = userIds;
    return this;
  }
}

/**
 * Defines authentication information associated with a card. For more information, refer to the [Bot Framework OAuthCard type](https://docs.microsoft.com/dotnet/api/microsoft.bot.schema.oauthcard)
 */
export interface IAuthentication {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The text that can be displayed to the end user when prompting them to authenticate.
   */
  text?: string;
  /**
   * The identifier for registered OAuth connection setting information.
   */
  connectionName?: string;
  /**
   * The buttons that should be displayed to the user when prompting for authentication. The array MUST contain one button of type “signin”. Other button types are not currently supported.
   */
  buttons?: IAuthCardButton[];
  /**
   * Provides information required to enable on-behalf-of single sign-on user authentication.
   */
  tokenExchangeResource?: ITokenExchangeResource;
}

export type AuthenticationOptions = Partial<IAuthentication>;

/**
 * Defines authentication information associated with a card. For more information, refer to the [Bot Framework OAuthCard type](https://docs.microsoft.com/dotnet/api/microsoft.bot.schema.oauthcard)
 */
export class Authentication implements IAuthentication {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The text that can be displayed to the end user when prompting them to authenticate.
   */
  text?: string;
  /**
   * The identifier for registered OAuth connection setting information.
   */
  connectionName?: string;
  /**
   * The buttons that should be displayed to the user when prompting for authentication. The array MUST contain one button of type “signin”. Other button types are not currently supported.
   */
  buttons?: IAuthCardButton[];
  /**
   * Provides information required to enable on-behalf-of single sign-on user authentication.
   */
  tokenExchangeResource?: ITokenExchangeResource;

  constructor(options: AuthenticationOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IAuthentication): Authentication {
    return new Authentication(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withText(text: string): this {
    this.text = text;
    return this;
  }

  withConnectionName(connectionName: string): this {
    this.connectionName = connectionName;
    return this;
  }

  withButtons(...buttons: IAuthCardButton[]): this {
    this.buttons = buttons;
    return this;
  }

  withTokenExchangeResource(
    tokenExchangeResource: ITokenExchangeResource,
  ): this {
    this.tokenExchangeResource = tokenExchangeResource;
    return this;
  }
}

/**
 * Defines a button as displayed when prompting a user to authenticate. For more information, refer to the [Bot Framework CardAction type](https://docs.microsoft.com/dotnet/api/microsoft.bot.schema.cardaction).
 */
export interface IAuthCardButton {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **signin**.
   */
  type?: string;
  /**
   * The caption of the button.
   */
  title?: string;
  /**
   * A URL to an image to display alongside the button’s caption.
   */
  image?: string;
  /**
   * The value associated with the button. The meaning of value depends on the button’s type.
   */
  value?: string;
}

export type AuthCardButtonOptions = Partial<IAuthCardButton>;

/**
 * Defines a button as displayed when prompting a user to authenticate. For more information, refer to the [Bot Framework CardAction type](https://docs.microsoft.com/dotnet/api/microsoft.bot.schema.cardaction).
 */
export class AuthCardButton implements IAuthCardButton {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **signin**.
   */
  type?: string;
  /**
   * The caption of the button.
   */
  title?: string;
  /**
   * A URL to an image to display alongside the button’s caption.
   */
  image?: string;
  /**
   * The value associated with the button. The meaning of value depends on the button’s type.
   */
  value?: string;

  constructor(options: AuthCardButtonOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IAuthCardButton): AuthCardButton {
    return new AuthCardButton(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withType(type: string): this {
    this.type = type;
    return this;
  }

  withTitle(title: string): this {
    this.title = title;
    return this;
  }

  withImage(image: string): this {
    this.image = image;
    return this;
  }

  withValue(value: string): this {
    this.value = value;
    return this;
  }
}

/**
 * Defines information required to enable on-behalf-of single sign-on user authentication. For more information, refer to the [Bot Framework TokenExchangeResource type](https://docs.microsoft.com/dotnet/api/microsoft.bot.schema.tokenexchangeresource)
 */
export interface ITokenExchangeResource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The unique identified of this token exchange instance.
   */
  id?: string;
  /**
   * An application ID or resource identifier with which to exchange a token on behalf of. This property is identity provider- and application-specific.
   */
  uri?: string;
  /**
   * An identifier for the identity provider with which to attempt a token exchange.
   */
  providerId?: string;
}

export type TokenExchangeResourceOptions = Partial<ITokenExchangeResource>;

/**
 * Defines information required to enable on-behalf-of single sign-on user authentication. For more information, refer to the [Bot Framework TokenExchangeResource type](https://docs.microsoft.com/dotnet/api/microsoft.bot.schema.tokenexchangeresource)
 */
export class TokenExchangeResource implements ITokenExchangeResource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The unique identified of this token exchange instance.
   */
  id?: string;
  /**
   * An application ID or resource identifier with which to exchange a token on behalf of. This property is identity provider- and application-specific.
   */
  uri?: string;
  /**
   * An identifier for the identity provider with which to attempt a token exchange.
   */
  providerId?: string;

  constructor(options: TokenExchangeResourceOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ITokenExchangeResource): TokenExchangeResource {
    return new TokenExchangeResource(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withUri(uri: string): this {
    this.uri = uri;
    return this;
  }

  withProviderId(providerId: string): this {
    this.providerId = providerId;
    return this;
  }
}

/**
 * Represents a set of Teams-specific properties on a card.
 */
export interface ITeamsCardProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Controls the width of the card in a Teams chat.
   *
   * Note that setting `width` to "full" will not actually stretch the card to the "full width" of the chat pane. It will only make the card wider than when the `width` property isn't set.
   */
  width?: TeamsCardWidth;
  /**
   * The Teams-specific entities associated with the card.
   */
  entities?: IMention[];
}

export type TeamsCardPropertiesOptions = Partial<ITeamsCardProperties>;

/**
 * Represents a set of Teams-specific properties on a card.
 */
export class TeamsCardProperties implements ITeamsCardProperties {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Controls the width of the card in a Teams chat.
   *
   * Note that setting `width` to "full" will not actually stretch the card to the "full width" of the chat pane. It will only make the card wider than when the `width` property isn't set.
   */
  width?: TeamsCardWidth;
  /**
   * The Teams-specific entities associated with the card.
   */
  entities?: IMention[];

  constructor(options: TeamsCardPropertiesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ITeamsCardProperties): TeamsCardProperties {
    return new TeamsCardProperties(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withWidth(width: TeamsCardWidth): this {
    this.width = width;
    return this;
  }

  withEntities(...entities: IMention[]): this {
    this.entities = entities;
    return this;
  }
}

/**
 * Represents a mention to a person.
 */
export interface IMention {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **mention**.
   */
  readonly type: 'mention';
  /**
   * The text that will be substituted with the mention.
   */
  text?: string;
  /**
   * Defines the entity being mentioned.
   */
  mentioned?: IMentionedEntity;
}

/**
 * @hidden
 * @internal
 *
 * Type guard to check if a value is of type IMention.
 *
 * @param value The value to check.
 * @returns True if the value is an instance of Mention, false otherwise.
 */
export function isMention(value: unknown): value is IMention {
  const obj = value as IMention;
  return typeof obj === 'object' && obj.type === 'mention';
}

export type MentionOptions = Partial<Omit<IMention, 'type'>>;

/**
 * Represents a mention to a person.
 */
export class Mention implements IMention {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * Must be **mention**.
   */
  readonly type = 'mention';
  /**
   * The text that will be substituted with the mention.
   */
  text?: string;
  /**
   * Defines the entity being mentioned.
   */
  mentioned?: IMentionedEntity;

  constructor(options: MentionOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: Omit<IMention, 'type'>): Mention {
    return new Mention(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withText(text: string): this {
    this.text = text;
    return this;
  }

  withMentioned(mentioned: IMentionedEntity): this {
    this.mentioned = mentioned;
    return this;
  }
}

/**
 * Represents a mentioned person or tag.
 */
export interface IMentionedEntity {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Id of a person (typically a Microsoft Entra user Id) or tag.
   */
  id?: string;
  /**
   * The name of the mentioned entity.
   */
  name?: string;
  /**
   * The type of the mentioned entity.
   */
  mentionType?: MentionType;
}

export type MentionedEntityOptions = Partial<IMentionedEntity>;

/**
 * Represents a mentioned person or tag.
 */
export class MentionedEntity implements IMentionedEntity {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The Id of a person (typically a Microsoft Entra user Id) or tag.
   */
  id?: string;
  /**
   * The name of the mentioned entity.
   */
  name?: string;
  /**
   * The type of the mentioned entity.
   */
  mentionType?: MentionType = 'Person';

  constructor(options: MentionedEntityOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IMentionedEntity): MentionedEntity {
    return new MentionedEntity(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withId(id: string): this {
    this.id = id;
    return this;
  }

  withName(name: string): this {
    this.name = name;
    return this;
  }

  withMentionType(mentionType: MentionType): this {
    this.mentionType = mentionType;
    return this;
  }
}

/**
 * Card-level metadata.
 */
export interface ICardMetadata {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The URL the card originates from. When `webUrl` is set, the card is dubbed an **Adaptive Card-based Loop Component** and, when pasted in Teams or other Loop Component-capable host applications, the URL will unfurl to the same exact card.
   */
  webUrl?: string;
}

export type CardMetadataOptions = Partial<ICardMetadata>;

/**
 * Card-level metadata.
 */
export class CardMetadata implements ICardMetadata {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The URL the card originates from. When `webUrl` is set, the card is dubbed an **Adaptive Card-based Loop Component** and, when pasted in Teams or other Loop Component-capable host applications, the URL will unfurl to the same exact card.
   */
  webUrl?: string;

  constructor(options: CardMetadataOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: ICardMetadata): CardMetadata {
    return new CardMetadata(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withWebUrl(webUrl: string): this {
    this.webUrl = webUrl;
    return this;
  }
}

/**
 * The resources that can be used in the body of the card.
 */
export interface IResources {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * String resources that can provide translations in multiple languages. String resources make it possible to craft cards that are automatically localized according to the language settings of the application that displays the card.
   */
  strings?: Record<string, IStringResource>;
}

export type ResourcesOptions = Partial<IResources>;

/**
 * The resources that can be used in the body of the card.
 */
export class Resources implements IResources {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * String resources that can provide translations in multiple languages. String resources make it possible to craft cards that are automatically localized according to the language settings of the application that displays the card.
   */
  strings?: Record<string, IStringResource>;

  constructor(options: ResourcesOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IResources): Resources {
    return new Resources(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withStrings(strings: Record<string, IStringResource>): this {
    this.strings = strings;
    return this;
  }
}

/**
 * Defines the replacement string values.
 */
export interface IStringResource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The default value of the string, which is used when no matching localized value is found.
   */
  defaultValue?: string;
  /**
   * Localized values of the string, where keys represent the locale (e.g. `en-US`) in the `<ISO 639-1>(-<ISO 3166-1 alpha-2>)` format. `<ISO 639-1>` is the 2-letter language code and `<ISO 3166-1 alpha-2>` is the optional 2-letter country code.
   */
  localizedValues?: Record<string, string>;
}

export type StringResourceOptions = Partial<IStringResource>;

/**
 * Defines the replacement string values.
 */
export class StringResource implements IStringResource {
  /**
   * Defines an optional key for the object. Keys are seldom needed, but in some scenarios, specifying keys can help maintain visual state in the host application.
   */
  key?: string;
  /**
   * The default value of the string, which is used when no matching localized value is found.
   */
  defaultValue?: string;
  /**
   * Localized values of the string, where keys represent the locale (e.g. `en-US`) in the `<ISO 639-1>(-<ISO 3166-1 alpha-2>)` format. `<ISO 639-1>` is the 2-letter language code and `<ISO 3166-1 alpha-2>` is the optional 2-letter country code.
   */
  localizedValues?: Record<string, string>;

  constructor(options: StringResourceOptions = {}) {
    Object.assign(this, options);
  }

  static from(options: IStringResource): StringResource {
    return new StringResource(options);
  }

  withKey(key: string): this {
    this.key = key;
    return this;
  }

  withDefaultValue(defaultValue: string): this {
    this.defaultValue = defaultValue;
    return this;
  }

  withLocalizedValues(localizedValues: Record<string, string>): this {
    this.localizedValues = localizedValues;
    return this;
  }
}
